; /* START FILE common/js/tagParser/en.js */ (function() {
    var json = {
        'gluten-free': {
            strings: [
                'glutenfree',
                'gluten free'
            ],
            abbreviations: [
                'g'
            ]
        },
        'low-lactose': {
            strings: [
                'low lactose'
            ],
            abbreviations: [
                'll'
            ]
        },
        'lactose-free': {
            strings: [
                'lactose free'
            ],
            abbreviations: [
                'l'
            ]
        },
        'milk-free': {
            strings: [
                'milk free'
            ],
            abbreviations: [
                'm'
            ]
        },
        'lacto-ovo': {
            strings: [
                'vegetarian'
            ],
        },
        vegetarian: {
            strings: [
                'vegan'
            ],
            abbreviations: [
                'v',
                'veg'
            ]
        },
        halal: {
            strings: [
                ' halal '
            ]
        },
        tofu: {
            strings: [
                ' tofu '
            ]
        },
        fish: {
            strings: [
                'salmon',
                ' fish '
            ]
        },
        pork: {
            strings: [
                'bacon',
                ' pork '
            ]
        },
        chicken: {
            strings: [
                ' chicken '
            ]
        },
        // duck: {
        // 	strings: [
        // 		' duck '
        // 	]
        // },
        dairy: {
            strings: [
                'milk', 'cheese'
            ]
        },
        beef: {
            strings: [
                ' beef ',
            ]
        },
        lamb: {
            strings: [
                ' lamb ',
            ]
        },
        // game: {
        // 	strings: []
        // },
        sushi: {
            strings: [
                'sushi',
                'nigiri',
                ' maki '
            ]
        },
        smoothie: {
            strings: [
                'smoothie',
            ]
        },
        pasta: {
            strings: [
                'pasta',
                'lasagne',
            ]
        },
        pizza: {
            strings: [
                'pizza',
            ]
        },
        // 'tex-mex': {
        // 	strings: [
        // 		' tex mex ',
        // 		' texmex '
        // 	]
        // },
        mediterranean: {
            strings: [
                'mediterrane',
                'mediterranean',
            ]
        },
        indian: {
            strings: [
                'indian',
            ]
        },
        italia: {
            strings: [
                ' italy ',
            ]
        },
        america: {
            strings: [
                'american',
            ]
        },
        asia: {
            strings: [
                ' asian ',
            ]
        },
        chinese: {
            strings: [
                ' chinese ',
            ]
        },
        noodles: {
            strings: [
                'noodles',
            ]
        },
        coffee: {
            strings: [
                'coffee',
            ]
        },
        pastry: {
            strings: [
                'wiener',
                'croissant',
                'croisant',
                'brownie'
            ]
        },
        sandwich: {
            strings: [
                'bagel',
                'panini ',
                'ciabatta',
                'sandwich'
            ]
        },
        soup: {
            strings: [
                ' soup '
            ]
        },
        spicy: {
            strings: [
                'chili',
                ' spicy '
            ]
        },
        salad: {
            strings: [
                'salad',
            ]
        },
        seafood: {
            strings: [
                ' seafood ',
            ]
        },
        raw: {
            strings: [
                ' raw ',
            ]
        },
        wok: {
            strings: [
                ' wok '
            ]
        }
    }

    // Can't test for 'window' since jest defines it
    const runningInNode = typeof process === 'object' && process.argv && process.exit

    if (runningInNode) {
        // Node.js
        module.exports = json
    } else {
        if (!window.tagParserModules)
            window.tagParserModules = {}
        window.tagParserModules.en = json
    }
})()
; /* START FILE common/js/tagParser/fi.js */ (function() {
    var json = {
        'gluten-free': {
            strings: [
                'gluteeniton',
                'gluteiiniton',
            ],
            abbreviations: [
                'g'
            ]
        },
        'low-lactose': {
            strings: [
                'vähälaktoosinen',
            ],
            abbreviations: [
                'vl'
            ]
        },
        'lactose-free': {
            strings: [
                'laktoositon',
            ],
            abbreviations: [
                'l'
            ]
        },
        'milk-free': {
            strings: [
                'maidoton',
            ],
            abbreviations: [
                'm'
            ]
        },
        'lacto-ovo': {
            strings: [
                'kasvissyö',
            ],
            abbreviations: [
                'kasvis'
            ]
        },
        vegetarian: {
            strings: [
                'vegaan',
            ],
            abbreviations: [
                'v',
                'veg'
            ]
        },
        halal: {
            strings: [
                ' halal '
            ]
        },
        tofu: {
            strings: [
                // tofua, tofupizza, 1Xtofunigiri, ...
                'tofu' // tofu is so weird word so it probably doesn't make false hits
            ]
        },
        fish: {
            strings: [
                'kalaa',
                ' kala ',
                ' lohi',
                'lohta ',
                ' savulohi',
                ' kirjolohi',
                'nieriä',
                'kampela',
                ' kalakei',
                ' kalakastik'
            ]
        },
        pork: {
            strings: [
                'kinkku',
                'porsaan',
                'porsaal', // porsaalla
                'porsasta ',
                'possun',
                ' possu',
                ' porsas ',
                'pekoni',
            ],
            rejects: [
                'possumunk'
            ]
        },
        chicken: {
            strings: [
                ' kanaa',
                ' kana ',
                ' kanansii',
                ' kananliha',
                ' kanankoip',
                ' kanakeit',
                ' kanafil',
                'broiler',
                'currykana',
                'chilikana',
            ]
        },
        // duck: {
        // 	strings: [
        // 		'ankka',
        // 	]
        // },
        beef: {
            strings: [
                'naudan',
                'nautaa',
                ' nauta ',
                'härän',
                'härkää'
            ]
        },
        lamb: {
            strings: [
                'lammas',
                ' lampaan'
            ]
        },
        // game: {
        // 	strings: [
        // 		' riista'
        // 	]
        // },
        dairy: {
            strings: [
                'maito', 'juusto'
            ]
        },
        sushi: {
            strings: [
                'sushi',
                ' sushe',
                'nigiri',
                ' maki '
            ]
        },
        smoothie: {
            strings: [
                'smoothie',
                ' lassi '
            ]
        },
        pasta: {
            strings: [
                'pasta',
                'lasagne',
                'lasagna'
            ]
        },
        pizza: {
            strings: [
                'pitsa'
            ]
        },
        // 'tex-mex': {
        // 	strings: [
        // 		' tex-mex '
        // 	]
        // },
        mediterranean: {
            strings: [
                ' välimeren'
            ]
        },
        indian: {
            strings: [
                'intialai'
            ]
        },
        italia: {
            strings: [
                ' italia'
            ]
        },
        america: {
            strings: [
                'amerik'
            ]
        },
        asia: {
            strings: [
                ' aasia'
            ]
        },
        chinese: {
            strings: [
                ' kiinalai'
            ]
        },
        noodles: {
            strings: [
                'nudel',
                'nuudel',
            ]
        },
        coffee: {
            strings: [
                'kahvi',
            ]
        },
        pastry: {
            strings: [
                'leivos',
                'viineri',
                'laskiaispull',
                'munkki',
                'croisant',
                'runebergin torttu',
                'runebergintorttu',
                'brownie',
                'korvapuusti',
                'muffinssi'
            ]
        },
        sandwich: {
            strings: [
                'bagel',
                'leipä ', // note: hiivaleipävehnäjauho
                'leipäkassi',
                'leipäpussi',
                'leipälaatikko',
                'leipää',
                'sämpylä',
                'panini ',
                'ciabatta',
                'sandwich',
                'patonki '
            ]
        },
        soup: {
            strings: [
                'keitto',
            ]
        },
        spicy: {
            strings: [
                'chili',
                ' tuli'
            ]
        },
        salad: {
            strings: [
                'salaatti',
            ]
        },
        seafood: {
            strings: [
                'katkarapu',
                'jattirapu',
                'mustekala'
            ]
        },
        raw: {
            strings: [
                'raaka'
            ]
        },
        processed: {
            strings: [
                'eines', 'eineks'
            ]
        },
        wok: {
            strings: [
                ' wok '
            ]
        }
    }

    // Can't test for 'window' since jest defines it
    const runningInNode = typeof process === 'object' && process.argv && process.exit

    if (runningInNode) {
        // Node.js
        module.exports = json
    } else {
        if (!window.tagParserModules)
            window.tagParserModules = {}
        window.tagParserModules.fi = json
    }
})()
; /* START FILE common/js/tagParser/sv.js */ (function() {
    var json = {
        dairy: {
            strings: [
                'mjölk'
            ]
        },
        coffee: {
            strings: [
                'kaffe'
            ]
        },
        soup: {
            strings: [
                'suppe ',
            ]
        },
        salad: {
            strings: [
                'sallad',
            ]
        },
        processed: {
            strings: [
                'färdigmat', 'färdigrätt'
            ]
        },
        wok: {
            strings: [
                ' wok '
            ]
        }
    }

    // Can't test for 'window' since jest defines it
    const runningInNode = typeof process === 'object' && process.argv && process.exit

    if (runningInNode) {
        // Node.js
        module.exports = json
    } else {
        if (!window.tagParserModules)
            window.tagParserModules = {}
        window.tagParserModules.sv = json
    }
})()
; /* START FILE common/js/tagParser/tagParser.js */ /*

This file can be run in node:
	node tagParser.js "Test Smoothie (M)" [fi|en,fi]

or in client
	*.jsList should contain all language files and tagParser.js

To add a new language:
	- copy en.js -> xx.js
	- change "tagParserModules.en" -> "tagParserModules.xx"
	- add tagParserRequire line in this file
	- add concatenation lines everywhere:
		- public/provider/js/provider.es5.jsList
		- (no other places yet)


When adding texts, test with:

select *
from (
select concat(' ', name, ' - ', description, ' ') text
from resq_offer o
order by o.id desc
limit 10000
) t
where text like '%test%';

 */

(function() {
    // Can't test for 'window' since jest defines it. Instead:
    // https://stackoverflow.com/a/61111010/2948
    const runningInNode =
		typeof process === 'object' &&
		typeof process.release === 'object' &&
		process.release.name === 'node'
    const runningInBrowser = !runningInNode

    let log
    if (runningInBrowser) {
        log = window.log
    } else {
        log = console.log
    }

    // Returns list of tagIds that this text matches.
    // You can pass multiple languages
    function parseTags(text, languageIds = 'en') {

        // languageIds = ['fi']

        if (!text || text.length <= 2)
            return []

        if (typeof languageIds === 'string')
            languageIds = [languageIds]

        languageIds = languageIds.filter(id => parsers[id])

        const abbreviations = []
        const numberOfLowerCaseLetters = text.split('').reduce(
            (prev, curr) => prev + (curr >= 'a' && curr <= 'z' ? 1 : 0),
            0)
        if (numberOfLowerCaseLetters > text.length / 2) {
            // is mostly lower case string

            // Get uppercase 1 character words
            let split = text.split(' ')
            split = [].concat(...split.map(s => s.split(',')))
            split = split.filter(s => s.length === 1).filter(s => s !== s.toLowerCase())

            abbreviations.push(...split)
        }

        const lowerCaseText = text.toLowerCase()
        const parenthesisParts = lowerCaseText.match(/\([^)]*\)/g) || []
        for (let part of parenthesisParts) {
            // remove parenthesis
            part = part.substring(1, part.length - 1)

            const parenthesisContainsNumbers = part.match(/\d/)
            if (!parenthesisContainsNumbers) {
                const splits = part.replace(',', ' ').split(' ').filter(Boolean)
                abbreviations.push(...splits)
            }
        }

        const strippedLowerCaseText = ' ' + lowerCaseText
            .replace(/\n/g, ' ')
            .replace(/,/g, ' ')
            .replace(/-/g, ' ')
            .replace(/\//g, ' ')
            .replace(/:/g, ' ')
            .replace(/\./g, ' ')
            .replace(/\(/g, ' ')
            .replace(/\)/g, ' ')
			+ ' '

        const activeParsers = []
        for (const langId of languageIds) {
            activeParsers.push(...parsers[langId])
        }

        const tagIds = activeParsers
            .map(parser => parser.parse(strippedLowerCaseText, abbreviations))
            .filter(Boolean)
        return Array.from(new Set(tagIds))
    }

    class TagParser {
        // text contains matchingStrings
        // or parenthesis has exactly given string (comma separated)
        // matchParenthesisParts also
        constructor(tagId, matchingStrings, matchAbbreviation, rejects) {
            this.tagId = tagId
            this.matchingStrings = matchingStrings
            if (!matchingStrings)
                throw new Error('invalid TagParser')
            this.matchAbbreviation = matchAbbreviation || []
            this.rejects = rejects || []
        }

        parse(lowerCaseText, abbreviations) {
            for (const reject of this.rejects) {
                lowerCaseText = lowerCaseText.replace(new RegExp(reject, 'g'), ' ')
            }

            if (this.matchingStrings.find(str => lowerCaseText.includes(str))) {
                // log(
                // 	'!!! parser find 1',
                // 	{
                // 		tagId: this.tagId,
                // 		matchingStrings: this.matchingStrings,
                // 		matchAbbreviation: this.matchAbbreviation,
                // 		rejects: this.rejects },
                // 	this.tagId
                // )
                return this.tagId
            }

            if (
                abbreviations.find(abbr =>
                    this.matchAbbreviation.find(match => abbr.toLowerCase() === match)
                )
            ) {
                // log(
                // 	'!!! parser find 2',
                // 	{
                // 		tagId: this.tagId,
                // 		matchingStrings: this.matchingStrings,
                // 		matchAbbreviation: this.matchAbbreviation,
                // 		rejects: this.rejects },
                // 	{
                // 		lowerCaseText, abbreviations
                // 	},
                // 	this.tagId
                // )
                return this.tagId
            }

            return null
        }
    }

    function tagParserRequire(languageId) {
        if (runningInNode) {
            const result = require('./' + languageId)
            return result
        } else {
            return window.tagParserModules[languageId]
        }
    }

    const languageConfigs = {
        en: tagParserRequire('en'),
        fi: tagParserRequire('fi'),
        sv: tagParserRequire('sv')
    }

    const parsers = {
        // Generated
        // en: [TagParser, TagParser], fi: [TagParser]
    }

    Object.keys(languageConfigs).forEach((langId) => {
        parsers[langId] = []
        const languageConfig = languageConfigs[langId]

        Object.keys(languageConfig).forEach(tagId => {
            const tagConfig = languageConfig[tagId]
            parsers[langId].push(
                new TagParser(tagId, tagConfig.strings, tagConfig.abbreviations, tagConfig.rejects)
            )
        })
    })

    if (runningInNode) {
        // Command-line invocation
        if (
            process.argv.length >= 3 &&
			process.argv[1].includes('tagParser.js') &&
			process.argv[2]
        ) {
            let lang = ['en', 'fi']
            if (process.argv[3]) {
                lang = process.argv[3].split(',').map(lid => lid.trim())
            }

            // log('par', parsers)

            console.log(parseTags(process.argv[2], lang))
        }
    }

    function cleanTagConflicts(listOfTags) {
        // tags = [tagId] OR tagId
        function remove(tags) {
            const tagIdsToRemove = Array.isArray(tags) ? tags : [tags]
            return {
                // tags = [tagId] OR tagId
                if: function(tags) {
                    const tagIdsToCheck = Array.isArray(tags) ? tags : [tags]
                    const shouldRemove = listOfTags.some(tag => tagIdsToCheck.includes(tag))

                    if (shouldRemove) {
                        listOfTags = listOfTags.filter(tag => !tagIdsToRemove.includes(tag))
                    }
                }
            }
        }

        // vegetarian = vegan here
        // "seaweed is not seafood" says Merriam-Webster & Mia
        const meatDietaryTags = ['beef', 'duck', 'fish', 'game', 'lamb', 'pork', 'chicken', 'seafood']

        // Diet meets protein
        remove('vegetarian').if([...meatDietaryTags, 'dairy'])
        remove('lacto-ovo').if(meatDietaryTags)
        remove('milk-free').if('dairy')

        // Diet conflicts
        remove('vegetarian').if(['lacto-ovo', 'low-lactose', 'lactose-free', 'milk-free'])
        remove('milk-free').if(['low-lactose', 'lactose-free'])
        remove('lactose-free').if(['low-lactose'])

        // Allergens could be done here as well but we don't use allergen tags in production so
        // don't bother...

        return listOfTags
    }

    if (runningInBrowser) {
        window.parseTags = parseTags
        window.cleanTagConflicts = cleanTagConflicts
    } else {
        module.exports.parseTags = parseTags
        module.exports.cleanTagConflicts = cleanTagConflicts
    }
})()
; /* START FILE provider/js/uiElements.js */ window.__ignoreHashChange = 0
function installHashChangeHandler() {
    window.addEventListener('hashchange', function() {
        if (window.__ignoreHashChange === 0) {
            if (window._dialog && window._dialog.hasChangedValues()) {
                if (window._dialog.confirmLeave()) {
                    goToCurrentTabOrDefault()
                }
            } else {
                goToCurrentTabOrDefault()
            }

        }
    })

    $(window).bind('beforeunload', function(e) {
        if (window._dialog && window._dialog.hasChangedValues()) {
            return true
        }
    })
}

function setLocationHashStealthily(hash) {
    window.__ignoreHashChange++
    location.hash = hash
    setTimeout(function() {
        window.__ignoreHashChange--
    }, 1)
}

function goToCurrentTabOrDefault(defaultTab) {
    var $currentTabButton = location.hash && $('.tabButton-' + location.hash.slice(1))
    if ($currentTabButton.length) {
        $currentTabButton.first().trigger('click')
    } else {
        if (defaultTab) {
            location.hash = defaultTab
        } else {
            $('.tabButton').first().trigger('click')
        }
    }
}

function createAlignMiddle(content) {
    var container = $('<div>').css({
        display: 'table'
    })
    var cell = $('<div>').css({
        display: 'table-cell',
        'vertical-align': 'middle'
    }).appendTo(container)

    cell.append(content)

    return container
}

function createTabButton(text, callback, tabName, linkHref) {
    var button = $('<div>').text(text).addClass('tabButton')

    if (tabName !== undefined) {
        button.addClass('tabButton-' + tabName)
        button.attr('tabButtonTabName', tabName)
    }

    var clickCallback = function() {

        if (window._dialog && window._dialog.hasChangedValues()) {
            if (!window._dialog.confirmLeave()) {
                return
            }
        }

        if (linkHref && window.redirect) {
            window.redirect(linkHref)
            return
        }

        button.blur()
        if (button.attr('disabled')) return
        callback(button.hasClass('selected'))
        window.scrollTo(0, 0)
        $('.tabButton').removeClass('selected')
        $('.topBar .topBarMenu').removeClass('visible').hide()
        $('.topBarMenuModalLayer').remove()

        if (tabName !== undefined) {
            setTimeout(function() {
                $('.tabButton-' + tabName).addClass('selected')
                $('#provider .topBar .topBarTitle').text(text).show()
            }, 0)

            if (tabName)
                setLocationHashStealthily(tabName)
            else
                window.removeHash()
        } else {
            setTimeout(function() {
                button.addClass('selected')
            }, 0)
            window.removeHash()
        }

        $('body').removeClass('freeze-scroll')
    }

    if (callback !== null) {
        button.on('click', clickCallback)
    }

    button.copyTabButton = function() {
        return createTabButton(text, callback, tabName)
    }

    if (!text) button.hide()

    return button
}

function createIconButton(iconUrl, callback) {
    var img = $('<img>').attr('src', iconUrl).addClass('iconButton')
    img.click(function(event) {
        img.blur()
        event.stopPropagation()
        if (img.attr('disabled')) return
        callback(event)
    })
    return img
}

function createImageWithTextButton(imgUrl, text, callback) {
    var div = $('<div>').addClass('imageWithTextButtonContainer').click(function() {
        div.blur()
        if (div.attr('disabled')) return
        callback()
    })
    $('<img>').attr('src', imgUrl).appendTo(div)
    $('<div>').addClass('imageWithTextButtonText').text(text).appendTo(div)
    return div
}

function createTextButton(text, callback, href, targetBlank) {
    var button = $(href ? '<a>' : '<span>').text(text).addClass('textButton')
    if (href) {
        button.attr('href', href)

        if (targetBlank)
            button.attr('target', '_blank')
    }
    button.click(function(e) {
        if (button.attr('disabled')) {
            e.preventDefault()
            return
        }
        callback(e)
    })
    return button
}

// unused
function createModalButton(text, callback) {
    var button = $('<button>').addClass('modal-button').attr('text', text).text(text).click(function(e) {
        e.stopPropagation()
        e.preventDefault()
        button.blur()
        if (button.attr('disabled')) return
        callback()
    })
    return button
}

// unused
function createBigButton(text, callback) {
    var button = $('<button>').text(text).addClass('bigButton')
    var clickCallback = function() {
        button.blur()
        if (button.attr('disabled')) return
        callback()
    }
    button.click(clickCallback)
    return button
}

function createBasicButton(text, callback, optionalExtraClass) {
    var button = $('<button>').text(text).addClass('basicButton').click(function(e) {
        e.stopPropagation()
        e.preventDefault()
        button.blur()
        if (button.attr('disabled')) return
        callback(e)
    })
    button.addClass(optionalExtraClass)
    return button
}

function createNavigationButton(text, callback, iconUrl) {
    var button = $('<div>').addClass('navigationButton selectNone').click(function(e) {
        e.stopPropagation()
        e.preventDefault()
        button.blur()
        if (button.attr('disabled')) return
        callback(e)
    })

    button.append($('<span>').addClass('navigationButtonText').text(text))
    if (iconUrl) {
        button.append($('<img>').addClass('navigationButtonIcon').attr({
            src: iconUrl
        }))
    }
    button.append($('<img>').addClass('navigationButtonArrowIcon').attr({
        src: '/common/img/icon_arrow_small.png'
    }))

    return button
}

function addModalLayer(clickCallback, className) {
    $('body').append($('<div>').addClass('modalLayer' + (className ? ' ' + className : '')).click(function() {
        $(this).remove()
        if (clickCallback)
            clickCallback()
    }))
}

function createTopBar(tabs, options) {
    options = $.extend({
        logo: true,
        language: true,
        logoutCallback: null,
        burgerMenuWidthLimit: 800,
        container: $('body'),
    }, options)

    var confirmedLogoutCallback = function() {
        if (options && options.logoutCallback) {
            if (confirm(lang.usermenu.menuitem.logout.confirm)) {
                options.logoutCallback()
            }
        }
    }

    var topBar = $('<div>').addClass('topBar')
    $('<div>').addClass('topBarTitle').appendTo(topBar).hide()

    var menuContainer = $('<div>').addClass('topBarMenu').appendTo(topBar)

    var burgerButton = $('<div>').addClass('topBarBurgerButton').append($('<img>').attr('src', '/common/img/burger_icon.svg')).click(toggleTopBarMenu)
    topBar.append(burgerButton)
    var burgerViewAvailable = options.logoutCallback || tabs

    var view = ''

    function setBurgerView(isBurgerView) {
        if (isBurgerView && burgerViewAvailable) {
            if (view == 'burger') return
            view = 'burger'
            $('.topBarElement').hide()
            //menuContainer.hide();
            /* menuContainer.css('transform', 'translateY(-100vh)'); */
            menuContainer.removeClass('visible')
            burgerButton.show()
            //logo.removeClass("logoLeft");
            logo.addClass('logoLeft')
            $('.topBarMenuModalLayer').remove()
        } else {
            if (view == 'normal') return
            view = 'normal'
            $('.topBarElement').show()
            //menuContainer.hide();
            /* menuContainer.css('transform', 'translateY(-100vh)'); */
            burgerButton.hide()
            if (tabs) logo.addClass('logoLeft')
            $('.topBarMenuModalLayer').remove()
        }
    }

    function resizeCallback() {
        var burgerEnabled = $(window).width() < options.burgerMenuWidthLimit

        if (window.intercomUpdate) {
            window.intercomUpdate({
                hide_default_launcher: burgerEnabled
            })
        }
        setBurgerView(burgerEnabled)
    }

    if (burgerViewAvailable)
        $(window).resize(resizeCallback)
    //setTimeout(resizeCallback, 1);

    function toggleTopBarMenu() {
        if (menuContainer.hasClass('visible')) {
            menuContainer.removeClass('visible')
            $('.topBarMenuModalLayer').remove()
            $('.topBarTitle').show()

            $('body').removeClass('freeze-scroll')
            topBar.removeClass('menu-open')
        }
        else {
            $('body').addClass('freeze-scroll')
            topBar.addClass('menu-open')
            menuContainer.addClass('visible')
            $('.topBarTitle').hide()
            addModalLayer(function() {
                menuContainer.removeClass('visible')
            }, 'topBarMenuModalLayer')
        }
    }

    if (tabs && tabs.length > 0) {
        setTimeout(function() {
            var defaultTabName = tabs[0].attr('tabButtonTabName')
            installHashChangeHandler()
            goToCurrentTabOrDefault(defaultTabName)
        }, 10)

        var tabContainer = $('<div>').addClass('tabContainer topBarElement').appendTo(topBar)
        tabContainer.append(tabs)

        var tabCopies = tabs.map(function(tab) {
            return tab.copyTabButton()
        })
        menuContainer.append(tabCopies)
    }

    if (options.logo) {
        var logoUrl = '/common/img/resq_logo.png'
        var logo = $('<a>').attr('href', '/').addClass('logo ' + (tabs ? ' logoLeft' : '')).append($('<img>').attr('src', logoUrl)).appendTo(topBar)
    }
    if (options.language) {
        topBar.append(createLanguageController().addClass('topBarElement'))
        menuContainer.append(createLanguageController())
    }
    if (options.logoutCallback) {
        var logoutText = window.lang ? lang.p.button.logout : 'Log out'
        topBar.append(createTextButton(logoutText, confirmedLogoutCallback).addClass('topBarElement topBarLogoutButton'))
        menuContainer.append(createTabButton(logoutText, options.logoutCallback).addClass('topBarLogoutButton'))
    }

    topBar.css({ visibility: 'hidden' }).prependTo(options.container).css({ visibility: 'visible' })
    resizeCallback()

    var ENABLE_DEV_TOP_BAR = false
    if (ENABLE_DEV_TOP_BAR && window.env && use.env.DEV_ENV) {
        topBar.css({
            'background': '#4B6827',
        })
        if (logo) {
            logo.text('DEV Environment')
        }
    }

    return topBar
}

function createLanguageController() {
    var languageSelectorContainer = $('<div>').addClass('languageSelector-touchArea')

    var languageSelectorCurrent = $('<div />').addClass('current-lang')
    var language = window.getLanguage()
    var languageSelector = $('<div>').addClass('languageSelector')

    languageSelectorCurrent.append($('<div class="text-allcaps">').text(language).css('display', 'inline-block'))
    languageSelectorCurrent.append($('<span class="icon-arrow-down">').css('margin-left', 4))
    //languageSelectorCurrent.append($('<span />').addClass('icon-arrow-down'));
    languageSelectorContainer.append(languageSelectorCurrent)
    window.wait.env.then(function() {
        var languages = use.env.SUPPORTED_LANGUAGES
        var otherLanguages = languages.slice()
        var currentLanguage = otherLanguages.indexOf(language)
        /*
		 if (currentLanguage !== -1) {
		 otherLanguages.splice(currentLanguage, 1);
		 }
		 */
        otherLanguages.forEach(function(language) {
            var languageContainer = $('<div>')
            languageContainer.addClass('language')
            languageContainer
            //.append($('<span class="language-long"></span>'))
                .append($('<span class="language-short text-allcaps">' + language + '</span>'))

            languageSelector.append(languageContainer)
        })
    })

    languageSelector.on('click', 'div', function(ev) {
        //.find('.language-short')
        var nextLang = $(ev.target).text().toLowerCase()
        if (nextLang && nextLang !== language) {
            window.setLanguageAndReload(nextLang)
        }
    })

    languageSelectorContainer.click(function(ev) {
        languageSelectorContainer.toggleClass('open')
        ev.stopPropagation()
    })
    $('html').click(function() {
        languageSelectorContainer.removeClass('open')
    })
    languageSelectorContainer.append(languageSelector)

    return languageSelectorContainer
}

// Input stuff
//////////////////////////////

function validateTime(input) {
    var val = input.val()
    var vals = val.split(':')
    var newVal = null

    if (val == '') {
        newVal = ''
    }
    else if (vals.length >= 2) {
        var val1 = parseInt(vals[0])
        var val2 = parseInt(vals[1])
        if (!isNaN(val1) && val1 >= 0 && val1 < 24) {
            val1 = ('0' + val1).slice(-2)

            if (!isNaN(val2) && val2 >= 0 && val2 < 60) {
                val2 = ('0' + val2).slice(-2)
            }
            else
                val2 = '00'

            newVal = val1 + ':' + val2
        }
    }
    else if (vals.length == 1) {
        val = parseInt(vals[0])
        if (!isNaN(val) && val >= 0 && val < 24) {
            newVal = ('0' + val).slice(-2) + ':00'
        }
    }

    if (newVal) {
        input.val(newVal)
        input.data('val', newVal)
    }
    else {
        input.val(input.data('val'))
    }
}
function validateTimeOld(input) {
    input.data('val', input.val())
    input.change(function() {
        validateTime(input)
    })
}
function validateAmount(input) {
    input.data('oldVal', input.val())
    input.change(function() {
        var val = input.val()
        if (val == '') {
            input.data('oldVal', val)
            return
        }
        var num = parseInt(val)
        if (isNaN(num) || num <= 0) {
            input.val(input.data('oldVal'))
        }
        else {
            input.val(num)
            input.data('oldVal', input.val())
        }
    })
    input.change()
}

function validateLocation(input) {
    input.data('oldVal', input.val())

    function handler() {
        var val = input.val()
        if (val == '') {
            input.data('oldVal', val)
            input.val('')
            return
        }
        var num = parseFloat(val)
        if (isNaN(num) || num < -180 || num > 180) {
            input.val(input.data('oldVal'))
        }
        else {
            input.val(num)
            input.data('oldVal', input.val())
        }
    }

    input.change(handler)
    handler()
}

function createInputLabel(title, subTitle, options) {
    if (subTitle) subTitle = ' (' + subTitle + ')'
    else subTitle = ''

    var el = $('<div>').addClass('inputBlockTitle').text(title + subTitle)
    if (options && options.collapse) {
        el = $('<a href="">').addClass('inputBlockTitle').text(title + subTitle)
    }
    el.click(function(e) {
        e.preventDefault()
    })
    return el
}

function createSimpleInputBlock(localizationObject, type, defaultValue, horizontalAlign, width) {
    if (!localizationObject)
        localizationObject = {}
    else if (typeof localizationObject == 'string')
        localizationObject = { title: localizationObject }
    var title = localizationObject.title || ''
    var name = title.replace(/[ -]/g, '_') || ('' + Math.random())
    var placeholder = localizationObject.placeholder || ''
    return createInputBlockOld(name, title, placeholder, type, defaultValue, horizontalAlign, width)
}

function createInputBlock(options) {
    var defaultOptions = {
        label: '', // overrides localization
        placeholder: '', // overrides localization
        localization: '', // string or { label: "", placeholder: "" }
        size: 'full', // full/half/halfRight/auto/fixed
        blockClass: '',
        inputClass: '',
        type: 'text', // select option type is: [{ id: "fi", name: "Finland" }, ...]
        value: '', // default value,
        helpText: '',
        tabIndex: -1,
        required: false,
        optional: false,
        disabled: false
    }
    options = $.extend(defaultOptions, options)

    var block = $('<div>').addClass('inputBlock inputBlock-' + options.size + ' inputBlock-type-' + options.type)

    if (options.required) {
        block.addClass('required')
    }
    var blockContent = $('<div>').addClass('inputBlockContent')

    if (options && options.collapse) {
        block.addClass('inputBlock-collapse')
    }
    if (options && !!options.disabled) {
        block.addClass('inputBlock-disabled')
    }
    if (options.blockClass) block.addClass(options.blockClass)

    var label = options.label || options.localization && options.localization.label

    var labelSummary = $('<span></span>')
    labelSummary.addClass('inputBlock-label-summary')

    if ('price' === options.type && options.value) {
        labelSummary.text(isNaN(options.value) ? '' : (options.value / 100))
    } else {
        labelSummary.text(options.value)
    }

    if (label && !(options.type === 'checkbox2') && !(options.type === 'amountStepper')) {

        var inputLabel = createInputLabel('')

        var labelText = $('<span>').addClass('inputBlock-label-summary-label')
        if (typeof label === 'string') {
            labelText.text(label)
        } else {
            labelText.append(label)
        }
        if (options && options.optional) {
            block.addClass('optional')
            labelText.attr('data-optional', lang.p.dialog.inputBlockLabel.optional)
        }

        inputLabel.append(labelText)

        if (options && options.collapse) {
            var fullscreenInputLabel = $('<div>').addClass('inputBlockTitle')
            fullscreenInputLabel.append(labelText.clone())
            fullscreenInputLabel.css({
                position: 'absolute',
                top: '0',
                height: '60px',
                width: '100%'
            })
            fullscreenInputLabel.click(function() {
                block.trigger('collapse')
            })
            fullscreenInputLabel.hide()

            if (options.helpText) {
                var helpText = $('<div>').addClass('inputBlock-helpText')
                helpText.html(options.helpText)
                blockContent.append(helpText)
            }
            inputLabel.append(labelSummary)
        }

        block.append(inputLabel)
    }

    block.append(blockContent)
    var input

    if (options.type !== 'empty') {
        input = createInput($.extend({}, options, {
            class: options.inputClass,
            width: '100%',
            placeholder: options.placeholder || options.localization && options.localization.placeholder,
            disabled: options && !!options.disabled
        }))

        input.attr('tabindex', options.tabIndex)
        if (options && options.collapse) {
            input.on('focus', function() {
                $('body').addClass('input-focus')

                if (!block.hasClass('expanded')) {
                    block.trigger('expand')
                }
                $('.modalBody.modalPopupSection').scrollTop($('.modalBody.modalPopupSection').data('original-scroll-top'))
                $('body').scrollTop(0)
            })
            input.on('blur', function() {
                $('body').removeClass('input-focus')
            })
            var val = input.val()
            if (!val || val.length < 1) {
                val = options.placeholder
            }
            labelSummary.text(val)

            input.on('change', function() {
                val = input.val()
                if (!val || val.length < 1) {
                    val = options.placeholder
                }
                labelSummary.text(val)
            })
        }
    }

    blockContent.append(input)
    if (options.type != 'empty') {

        block.data('changed', false)
        block.data('get', input.data('get'))
        block.data('set', input.data('set'))
        block.data('change', input.data('change'))
        block.data('type', input.data('type'))
        block.data('input', input)
        block.data('value', input.data('get')())
        input.data('change')(function() {
            block.data('changed', true)
            block.data('value', input.data('get')())
        })
    }

    // Clear button for search input must be added here
    if (options.type === 'search') {
        var clearSearch = $('<div class="clearSearch">&times;</div>')
        clearSearch.click(function() {
            input.val('')
            clearSearch.hide()
            if ($.isFunction(options.onChange)) {
                options.onChange()
            }
        })

        const handleInputChange = function() {
            if (input.val() === '') {
                clearSearch.hide()
            } else {
                clearSearch.show()
            }
            if ($.isFunction(options.onChange)) {
                options.onChange()
            }
        }

        input.keyup(handleInputChange)
        input.change(handleInputChange)

        blockContent.append(clearSearch.hide())
    }

    var touchEnabled = $('html').hasClass('touch')

    if (input) {
        input.on('keydown', function(e) {
            var code = e.keyCode || e.which

            if (input && input.is('textarea')) {
                return
            }

            if (13 === code) { //return key
                if (block.hasClass('expanded')) {
                    var next = block.nextAll('div.inputBlock.inputBlock-collapse:first')
                    if (next && next.length > 0) {
                        next.trigger('expand')
                    } else {
                        block.trigger('collapse')
                    }

                }
            }
        })
    }

    //detect dragging from clicking action when touch is enabled. we have
    // to hijack the touchend event in order to focus an input and show the keyboard on ios webkit

    var touchStartEvent
    var initByTouch = false
    var isDragging = false
    var dragStartY

    //handle collapsing & expanding on non touch devices. no input focus trickery needed.
    var ALWAYS_ENABLE_COLLAPSING = true
    if (!touchEnabled || ALWAYS_ENABLE_COLLAPSING) {
        $(inputLabel).on('click', function(e) {
            if (initByTouch) {
                return
            }
            if (block.hasClass('expanded')) {
                block.trigger('collapse')
            } else {
                block.trigger('expand')
                input && input.focus()
            }
        })
    }

    $(inputLabel).on('touchstart', function(e) {
        if (options.disabled) {
            return
        }

        initByTouch = true
        //mark the starting x position of a touch
        dragStartY = e.originalEvent.touches[0].screenY
        touchStartEvent = e
        isDragging = false
        inputLabel.addClass('active')

    })

    $(inputLabel).on('touchmove', function(e) {
        if (options.disabled) {
            return
        }

        //detect dragging/scrolling
        if (Math.abs(dragStartY - e.originalEvent.touches[0].screenY) > 20) {
            inputLabel.removeClass('active')
            isDragging = true
        }
    })
    $(inputLabel).on('touchend touchleave', function(e) {
        e.preventDefault()
        if (options.disabled) {
            return
        }
        touchStartEvent = null
        setTimeout(function() {
            initByTouch = false
        }, 100)

        inputLabel.removeClass('active')
        if (isDragging) {
            //touch was detected as dragging
            return
        }

        //collapse the block if expanded
        if (block.hasClass('expanded')) {
            block.trigger('collapse')
            return
        }

        //these might not contain any inputs, just expand the block
        if (block.hasClass('inputBlock-type-empty')) {
            block.trigger('expand')
        } else if (!input.is(':focus')) {
            //use plain old expand for inputblocks with .autofocus
            if (!block.hasClass('autofocus')) {
                block.trigger('expand')
            } else {
                //select the input
                input.focus()
            }
        }
    })

    block.on('expand', function() {
        if (options.disabled) {
            return
        }
        var others = block.parent().find('.inputBlock-collapse').filter(function(i, item) {
            return item != block[0]
        })
        others.trigger('collapse')

        var originalTop = $('.modalBody.modalPopupSection').scrollTop()
        $('.modalBody.modalPopupSection').data('original-scroll-top', originalTop)

        setTimeout(function() {

            //scroll the expanded view based on size

            var offset = $('.inputBlock-collapse.expanded').offset()
            if (!offset) {
                // Sometimes offset does not exist, presumably because the element
                // does not exist. In that case, avoid error.
                return
            }
            var scrollTop = offset.top + $('.modalBody.modalPopupSection').scrollTop() - 50

            var naturalScrollMargin = $('.modalBody.modalPopupSection')[0].scrollHeight - $('.modalBody.modalPopupSection').innerHeight()

            var diff = (block.height() + block.offset().top + $('.modalBody.modalPopupSection').scrollTop()) - $('.modalBody.modalPopupSection').outerHeight()

            //handle block scroll position. Only scroll if the whole block doesn't fit in the current viewport. Mobile devices always scroll to top
            var ENABLE_BLOCK_SCROLL_HANDLING = true
            if (!ENABLE_BLOCK_SCROLL_HANDLING) {
                return
            } else if (diff > 0 || touchEnabled) {
                //bigger than viewport? attach top
                if (block.height() > $('.modalBody.modalPopupSection').innerHeight() || touchEnabled) {
                    $('.modalBody.modalPopupSection').data('original-scroll-top', scrollTop)
                } else {
                    //smaller than viewport, attach bottom;
                    scrollTop = scrollTop - ($('.modalBody.modalPopupSection').outerHeight() - block.height())
                    $('.modalBody.modalPopupSection').data('original-scroll-top', scrollTop)
                }
                $('.modalBody.modalPopupSection').animate({
                    scrollTop: scrollTop
                }, {
                    duration: 250, easing: 'swing', complete: function() {
                    }
                })

            }

            if (input && input.focus && !touchEnabled && !input.is(':focus')) {
                input.focus()
            }
        }, 0)

        block.addClass('expanded')
    })

    block.on('collapse', function() {
        if (block.hasClass('expanded')) {
            var fullHeight = blockContent.outerHeight()
            blockContent.css({ height: fullHeight })
            $('.modalBody.modalPopupSection').css({
                paddingBottom: 0
            })
            setTimeout(function() {
                blockContent.css({ height: '' })
                block.removeClass('expanded')
            }, 10)
            if (input) {
                input.blur()
            }
        }
    })
    return block
}

function createInput(options) {
    var defaultOptions = {
        placeholder: '',
        width: '100%', // default 100%. in small screens width is forced to 100%.
        class: '',
        label: '', // some inputs needs label in input element (checkbox)
        type: 'text', // select option type is: [{ id: "fi", name: "Finland" }, ...]
        value: '',
        disabled: false,
    }
    options = $.extend(defaultOptions, options)

    if (!inputTypes[options.type])
        alert('type ' + options.type + ' not supported')

    var type = $.extend({}, inputTypes.text, inputTypes[inputTypes[options.type].inherits], inputTypes[options.type])

    var input = type.create(options).addClass('basicInput basicInput-type-' + options.type)


    var inlinePlaceholder = ''
    if (type === 'amountSpinner') {
        inlinePlaceholder = options.placeholder
    }

    type.init(input, options)
    var realInput = type.getInputElement(input)
    if (realInput) {
        realInput.attr({
            type: type.type,
            placeholder: inlinePlaceholder,
            disabled: !!options.disabled
        })
    }
    if (options.class) input.addClass(options.class)
    type.set(input, options.value)
    type.validate(input)
    if (realInput) {
        realInput.change(function() {
            type.validate(input)
        })
    }
    input.data('type', type)
    input.data('get', function() {
        return type.get(input)
    })
    input.data('set', function(val) {
        type.set(input, val)
        if (realInput)
            realInput.change()
    })
    if (realInput) {
        input.data('change', function(listener) {
            realInput.change(listener)
        })
    }

    return input
}

var inputTypes = {
    text: {
        inherits: 'text', // cannot inherit inherited
        type: 'text',
        create: function() {
            return $('<input>')
        },
        init: function(input) {
        },
        validate: function(input) {
        },
        set: function(input, value) {
            input.val(value)
        },
        get: function(input) {
            return input.val()
        },
        getInputElement: function(rootElement) {
            // if this returns null, you must have your own setter, change-listener and call change on set
            return rootElement
        }
    },
    username: {},
    email: {
        type: 'email',
        init: function(input) {
            input.attr({
                'name': 'email',
                'autocomplete': 'on'
            })
        }
    },
    password: {
        type: 'password',
    },
    empty: {
        type: 'empty',
        init: function() {

        },
    },
    price: {
        type: 'text',
        set: function(input, value) {
            // log('!!! price set', { input, value })

            if (value === null) {
                input.val('')
            } else {
                input.val(isNaN(value) ? '' : (value / 100))
            }
            input.data('oldVal', input.val())
        },
        get: function(input) {
            const result = Math.round(parseFloat(input.val()) * 100)
            // log('!!! price get', { input, result })
            return result
        },
        validate: function(input) {
            var val = input.val()

            // log('!!! price validate', { input, val })
            // log('!!! typeof val', typeof val)

            // Just in case
            val = String(val)
            val = val.trim()
            val = val.replace(/,/g, '.')

            // log('!!! val afterwards', { input, val })

            if (val === '') {
                input.data('oldVal', val)
                return
            }

            var num = parseFloat(val)
            if (isNaN(num) || num < 0) {
                // log('!!! revert to old val', input.data('oldVal'))
                input.val(input.data('oldVal') || '')
            } else {
                var minPriceFloat = use.profile.country.minPrice / 100
                if (num !== 0 && use.profile.country && use.profile.country.currency && num < minPriceFloat) {
                    num = minPriceFloat
                }

                input.val(num.toFixed(2))
                input.data('oldVal', input.val())
            }
        },
    },
    location: {
        set: function(input, value) {
            input.val(value)
            input.data('oldVal', input.val())
        },
        validate: function(input) {
            var val = input.val()
            if (val == '') {
                input.data('oldVal', val)
                input.val('')
                return
            }
            var num = parseFloat(val)
            if (isNaN(num) || num < -180 || num > 180) {
                input.val(input.data('oldVal') || '')
            }
            else {
                input.val(num)
                input.data('oldVal', input.val())
            }
        }
    },
    textarea: {
        create: function() {
            return $('<textarea>')
        },
        init: function(input) {
            input.attr('rows', 6)
            input.css({
                'height': 'auto',
            })
        }

    },
    number: {
        type: 'number',
        get: function(input) {
            return parseFloat(input.val())
        },
    },
    checkbox: {
        type: 'checkbox', // doesn't work because of container
        create: function(options) {
            var container = $('<div>')
            var name = 'checkbox_' + Math.random()
            var input = $('<input>').attr({
                id: name,
            }).appendTo(container)

            var label = $('<label>').text(options.label).attr({
                for: name
            }).appendTo(container)
            if (!options.label) {
                container.css('position', 'relative')
                label.addClass('checkbox-bigEmptyLabelClickArea')
                container.addClass('selectNone')
            }
            return container
        },
        init: function(input, options) {

        },
        get: function(input) {
            return input.find('input').prop('checked') ? 1 : 0
        },
        set: function(input, value) {
            input.find('input').prop('checked', value && value != 'false')
        },
        getInputElement: function(rootElement) {
            return rootElement.find('input')
        }
    },
    amount: {
        type: 'tel'
        //validateAmount(input);
    },
    amountStepper: {
        type: 'tel',

        create: function(options) {
            var container = $('<div>')

            var focused = false

            var label = $('<label>').append($('<span>').text(options.label)).appendTo(container)
            label.on('click',function(e) {
                e.preventDefault()
                e.stopPropagation()

                if (focused) {
                    console.warn('input had focus', input)
                    //input.blur();
                } else {
                    focused = true
                    input.focus()
                }
            })

            var name = 'stepper_' + Math.random()
            var input = $('<input>').attr({
                id: name,
                size: 3,
                placeholder: ''
            }).appendTo(label)

            var placeholder = $('<div>').addClass('placeholder').text(options.placeholder).appendTo(label)

            input.on('focus', function() {
                input.select()
                placeholder.hide()
                input.css('height','auto')
            })
            input.on('blur', function() {
                console.log('blurring', parseInt(input.val()))
                if (input.val() && parseInt(input.val()) > 0) {
                    input.val(parseInt(input.val()))
                } else {
                    console.log('emptying')
                    input.trigger('change')
                    input.val('')
                }
                setTimeout(function() {
                    if (!input.is(':focus')) {
                        focused = false
                    }
                },250)
            })

            function createButton(options) {
                var btn = $('<button>').text(options.title)
                btn.on('touchstart', function() {})
                return btn
            }
            var stepper = $('<div>').addClass('stepper')
            var addButton = createButton({title: '+'})
            var subtractButton = createButton({title: '-'})

            addButton.click(function() {
                var val = parseInt(input.val() || 0)
                val = val + 1
                if (!val || val < 0) {
                    val = 0
                }
                input.val(val)
            })
            subtractButton.click(function() {
                var val = parseInt(input.val() || 0)

                if (val > 0) {
                    val = val - 1
                } else {
                    val = 0
                }
                input.val(val)
            })

            input.on('keydown', function(e) {
                if (e.key === 'ArrowUp') {
                    addButton.trigger('click')
                } else if (e.key === 'ArrowDown') {
                    subtractButton.trigger('click')
                } else if (e.key === 'Enter') {
                    input.blur()
                }
            })

            input.change(function() {
                var val = parseInt(input.val() || 0)

                if (val > 0) {
                    placeholder.hide()
                    input.css('height','auto')
                } else {
                    placeholder.show()
                    input.css('height','0')
                    input.val('')
                    //					input.hide();
                }
            })

            stepper.appendTo(container)
            input.trigger('change')
            if (!options.label) {
                container.css('position', 'relative')
            }
            return container
        },
        getInputElement: function(rootElement) {
            return rootElement.find('input')
        },
        get: function(input) {
            return parseInt(input.find('input').val() || 0)
        },
        set: function(input, value) {
            input.find('input').val(parseInt(input) || 0)
        },
    },
    checkbox2: {
        type: 'checkbox', // doesn't work because of container
        create: function(options) {
            var container = $('<div>')

            var labelContent = $('<span>')
            if (typeof options.label === 'string') {
                labelContent.text(options.label)
            } else {
                labelContent.append(options.label)
            }
            var label = $('<label>').append(labelContent).appendTo(container)

            var name = 'checkbox_' + Math.random()
            var input = $('<input>').attr({
                id: name
            }).appendTo(label)
            input.prop('checked', options.value)

            var slider = $('<div>').addClass('checkbox-slider').appendTo(label)
            var sliderKnob = $('<div>').addClass('checkbox-slider-knob').appendTo(slider)

            if (!options.label) {
                container.css('position', 'relative')
                label.addClass('checkbox-bigEmptyLabelClickArea')
                container.addClass('selectNone')
            }
            return container
        },
        init: function(input, options) {

        },
        get: function(input) {
            return input.find('input').prop('checked') ? 1 : 0
        },
        set: function(input, value) {
            input.find('input').prop('checked', value && value != 'false')
        },
        getInputElement: function(rootElement) {
            return rootElement.find('input')
        }
    },
    radio: {
        type: 'radio', // doesn't work because of container
        create: function(options) {
            var container = $('<div>').addClass('radioButtonContainer')
            var rnd = '' + Math.random()
            rnd = rnd.substring(3)
            var name = 'radio_' + rnd

            options.radioElements.forEach(function(e) {
                var div = $('<div>').addClass('radioButtonElement')

                var radioButton = $('<input>').attr({
                    type: 'radio',
                    name: name,
                    id: name + '_' + e.id,
                    value: e.id
                }).appendTo(div)

                if (options.radioValue == e.id || e.checked) {
                    radioButton.prop('checked', true)
                }

                var label = $('<label>').attr('for', name + '_' + e.id).append(e.label || 'Radio button without label')
                div.append(label)

                container.append(div)
            })

            container.data('change', function(listener) {
                container.find('input:radio[name=' + name + ']').change(listener)
            })

            return container
        },
        get: function(input) {
            return input.find('input:checked').val()
        },
        set: function(input, value) {
            input.find('input[value="' + value + '"]').prop('checked', true)
            input.find('input:radio').change()
        },
        getInputElement: function(rootElement) {
            return null
        }
    },
    range: {
        type: 'range',
        init: function(input, options) {
            if (options.rangeOptions) {
                input.attr(options.rangeOptions)
            }

            input.data('inputEvent', function(listener) {
                input.on('input', listener)
            })
        },
    },
    search: {
        inherits: 'text',
        //type: 'text', // Can't use type="search" because of inconsistent implementation in browsers
    },
    time: {
        validate: validateTime,
        get: function(input) {
            if (input.val().length <= 1)
                return null
            else
                return input.val() + ':00' // 00:00 -> 00:00:00
        },
        set: function(input, value) {
            if (typeof value == 'string' && value.length > 10)
                value = new Date(value)

            if (value instanceof Date) {
                value = value.toTimeString()
            }

            if (!value)
                value = ''

            input.val(value.substring(0, 5))
        },
    },
    select: {
        create: function(options) {
            return createInputBlockOld('select', null, options.placeholder, 'select', options.value, null, null, options.selectOptions)
        },
        init: function(input, options) {
            // This is a hack that makes this hacky wrapper look good
            input.removeClass('basicInput')
        },
        get: function(input) {
            return input.input.val()
        },
        getInputElement: function(rootElement) {
            return rootElement.input
        },
    }
}

function createInputBlockOld(name, title, placeholder, type, defaultValue, horizontalAlign, width, optionalOptions) {
    var div = $('<div>').addClass('inputBlock')
    if (title && type != 'checkbox') {
        var inputTitle = createInputLabel(title)
        inputTitle.attr('id', 'inputTitle_' + name)
        div.append(inputTitle)
    }

    var options = optionalOptions || {}
    var tag
    var wrap = false
    if (type === 'textarea') {
        tag = '<textarea>'
    } else if (type === 'select') {
        tag = '<select>'
        wrap = true
    } else {
        tag = '<input>'
    }

    var input = $(tag).attr({
        placeholder: placeholder,
        id: 'input_' + name
    }).addClass('basicInput').val(defaultValue)

    var result

    if (wrap) {
        var wrapper = $('<div class=inputWrapper>').addClass('inputWrapper-' + type).append(input)
        div.append(wrapper)
    } else {
        div.append(input)
    }
    if (type === 'textarea') {
        setTimeout(function() {
            input.autogrow({ vertical: true, horizontal: false, flickering: false })
        }, 0)

    }

    if (horizontalAlign) {
        div.css({
            float: horizontalAlign,
            width: width,
            display: 'inline-block'
        })
    } else {
        div.css('clear', 'both')
    }

    var getValueFunc = function() {
        return input.val()
    }

    input.change(function() {
        input.attr('changed', true)
        div.attr('changed', true)
        getValueFunc.changed = true
    })

    if (type === 'text') {
        input.attr('type', 'text')
    } else if (type === 'username') {
        input.attr('type', 'text')
    } else if (type === 'email') {
        input.attr({
            'type': 'email',
            'name': 'email',
            'autocomplete': 'on'
        })
    } else if (type === 'password') {
        input.attr('type', 'password')
    } else if (type === 'location') {
        input.attr('type', 'text')
        validateLocation(input)
    } else if (type === 'amount') {
        input.attr('type', 'number')
        validateAmount(input)
    } else if (type === 'number') {
        input.attr('type', 'number')
    } else if (type === 'checkbox') {
        input.attr('type', 'checkbox')
        input.css('width', 'auto')
        div.append($('<label>').text(title).attr('for', 'input_' + name).css({
            float: 'right',
            width: 'calc(100% - 25px)'
        })).append($('<div style=\'clear: both\'>'))
        if (defaultValue && defaultValue != 'false')
            input.prop('checked', true)
        getValueFunc = function() {
            return input.prop('checked') ? 1 : 0
        }
    } else if (type === 'time') {
        div.addClass('timeInputBlock')
        input.attr('type', 'text').addClass('timeInput')
        if (defaultValue) {
            if (typeof defaultValue == 'string' && defaultValue.length > 10)
                defaultValue = new Date(defaultValue)

            if (defaultValue instanceof Date) {
                defaultValue = defaultValue.toTimeString().substr(0, 5)
            }

            input.val(defaultValue.substring(0, 5)) // 00:00:00 -> 00:00
        }
        validateTimeOld(input)
        getValueFunc = function() {
            return input.val() + ':00' // 00:00 -> 00:00:00
        }
    } else if (type === 'select') {
        var values = options.values || []
        var labels = options.labels || values
        values.forEach(function(value, idx) {
            var label = labels[idx]
            var option = $('<option>').attr('value', value).text(label)
            if (String(value) === String(defaultValue)) {
                option.attr('selected', 'selected')
            }
            input.append(option)
        })
    }

    div.input = input
    div.getValueFunc = getValueFunc
    return div
}

function createTextCheckbox(text, id, callback) {
    var button = $('<span>').text(text).attr('id', id).addClass('textCheckbox').click(function() {
        if (button.attr('disabled')) return
        button.toggleClass('selected')
        if (callback) {
            callback(button.hasClass('selected'))
        }
    })
    return button
}

/*
 items = [{text, value}]
 callback = function(value) {}
 */
function createMenu(defaultValue, items, callback) {
    var ul = $('<ul>')

    function addItems(items) {
        items.forEach(function(item) {
            var li = $('<li>').attr({
                value: item.value,
            }).text(item.text)

            if (item.value == defaultValue) {
                li.css({
                    fontWeight: 'bold',
                })
            }

            ul.append(li)
        })

        setTimeout(function() {
            ul.menu({
                select: function(event, ui) {
                    if (callback)
                        callback($(event.currentTarget).attr('value'))
                    ul.menu('destroy').remove()
                }
            })
        }, 10)

        return ul
    }

    if (items) addItems(items)
    ul.addItems = addItems

    return ul
}

function addBrowserUpdate() {
    wait.env.then(function(env) {
        //PROVIDER_DEPRECATED_BROWSERS
        if (env && env.BROWSER_UPDATE_OPTIONS) {
            window.$buoop = env.BROWSER_UPDATE_OPTIONS
            var e = document.createElement('script')
            e.src = '//browser-update.org/update.min.js'
            document.body.appendChild(e)
        }
    })
}
; /* START FILE provider/js/providerModalDialog.js */ 
//
// Ugh - this whole thing is duplicated in modalDialog.js
//
// TODO do something about it
//

function createAlertBackground(callback) {
    return $('<div class=alert-background>').click(function(ev) {
        if (ev.target === this) {
            callback && callback()
        }
    })
}

function createAlertForBackground(alertBackground) {
    var alertWrapper = $('<div class=alertWrapper>').appendTo(alertBackground)
    return $('<div class=alert>').appendTo(alertWrapper)
}

// emulates alert()
//
// Show alert. Return promise that resolves after alert has been dismissed.
// The returned promise never rejects.
//
// title: "Hups!" by default
// optionalClass: class to be added to alert, e.g. "alert-wide"
// raw: "raw" if alert is message contains HTML (otherwise it will be escaped). Also jquery element is supported
function showAlert(message, title, optionalClass /* e.g. "alert-wide" */, raw, okText) {
    if (title == null) {
        title = window.lang ? lang.common.oops : 'Oops!'
    }

    if (!okText) {
        okText = 'OK'
    }

    var promise = $.Deferred()

    var alertBackground = createAlertBackground(dismiss)

    function dismiss() {
        alertBackground.remove()
        promise.resolve()
    }

    var alert = createAlertForBackground(alertBackground)

    if (optionalClass) {
        alert.addClass(optionalClass)
    }
    alert.append($('<h1>' + title + '</h1>'))
    var messageElement = $('<div class=messageAlert>')
    alert.append(messageElement)
    if (raw) {
        messageElement.append(message)
    } else {
        messageElement.text(message)
    }

    alert.append(window.createBasicButton(okText, dismiss))

    var oldKeyDown = window.onkeydown
    window.onkeydown = function(e) {
        var ESC = 27
        if (e.keyCode == ESC) {
            window.onkeydown = oldKeyDown
            dismiss()
        }
    }

    alertBackground.appendTo(document.body)

    return promise
}

/*
Returns a promise.
Resolves if we should continue.
Rejects if we should not continue or popup is dismissed.

message: String
buttons: [{
	label: String,
	action: 'continue' | 'dismiss' | function() {}
}]
doNotShowAgainId: String

doNoShowAgain works only if user presses "continue"
 */
function showLightPopup(
    message,
    buttons = [{ label: lang.common.continue, action: 'continue' }],
    options = {}
) {
    const promise = $.Deferred()

    const { title, doNotShowAgainId } = options

    const storeId = 'lightPopup-' + doNotShowAgainId
    if (doNotShowAgainId && window.store.get(storeId) === '1') {
        return promise.resolve()
    }

    const freeResources = () => {
        alertBackground.remove()
        window.onkeydown = oldKeyDown
    }

    const dismissHandler = () => {
        freeResources()
        promise.reject()
    }
    const continueHandler = () => {
        if (doNotShowAgainId) {
            window.store.set(storeId, checkbox.data('value'))
        }
        freeResources()
        promise.resolve()
    }

    const alertBackground = createAlertBackground(dismissHandler)

    const alert = createAlertForBackground(alertBackground).addClass('lightPopup')

    if (title) {
        $('<h1>')
            .text(title)
            .appendTo(alert)
    }

    $('<div class=messageAlert>')
        .text(message)
        .appendTo(alert)

    let checkbox
    if (doNotShowAgainId) {
        checkbox = window.createInputBlock({
            type: 'checkbox',
            label: lang.offers.dialog.surplusPriceWarning.dontShowAgain,
            value: false,
        })
        alert.append(checkbox)
    }

    const buttonsContainer = $('<div>')
        .addClass('lightPopupButtons')
        .appendTo(alert)

    for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i]
        const action = button.action || 'dismiss'

        let handler

        if (action === 'continue') handler = continueHandler
        else if (action === 'dismiss') handler = dismissHandler
        else if (typeof action === 'function') handler = action

        // alert.append(createBasicButton(button.label, handler))
        buttonsContainer.append(
            window.createTextButton(button.label, handler).addClass('lightPopupButton')
        )
    }

    const oldKeyDown = window.onkeydown
    window.onkeydown = function(e) {
        const ESC = 27
        if (e.keyCode == ESC) {
            dismissHandler()
        }
    }

    alertBackground.appendTo(document.body)

    return promise
}

// Emulates prompt()
function showPrompt(question, options) {
    if (options === undefined) {
        options = {}
    }

    return showConfirm(question, options.placeholder, options.defaultValue, 'text')
}

function showConfirm(question, placeholder, defaultValue, inputType) {
    placeholder = placeholder || ''
    defaultValue = defaultValue || ''
    inputType = inputType || 'text'

    return new Promise(function(resolve, reject) {
        var dlg = new ModalDialog('', {})

        dlg.add($('<p>').text(question).addClass('question'))
        var answer = dlg.addInputOld('answer', '', placeholder, inputType, defaultValue)

        // Simulate a form with <input type=submit>
        answer.input.on('keypress', function(ev) {
            if (ev.keyCode === 13) {
                button.click()
            }
        })

        var button = dlg.addButton(lang.common.ok, function() {
            resolve(answer.input.val())
            dlg.hide()
        })

        dlg.show()
        setTimeout(function() {
            answer.input.focus()
        }, 100)
    })
}

/*
 var data = {}
 for (var i = 0; i < dlg.values.length; i++) {
 if (!dlg.values[i].valueName) continue;
 if (dlg.values[i].changed || (dlg.values[i].inputBlock && dlg.values[i].inputBlock.data("changed")))
 data[dlg.values[i].valueName] = dlg.values[i]();
 }

 console.log("data", data)
 * */

function ModalDialog(title, opts)
{
    // console.log("modaldialog", opts)
    var defaultOptions = {
        width: 'auto', // content max width. (for example "600px" or "50vw")
        submitFromEnter: false,
        popup: true,
        saveOnlyEdited: false,
        hideCallback: null,
        preventLeaveOnChanges: false,
        class: '',
        hideTitle: false,
        autoTabIndexify: false,
        autofocusFirstInput: false,
    }

    var currentTabIndex = 100

    opts = $.extend(defaultOptions, opts)
    var self = this

    var background = $('<div>').addClass('modal-background').click(function() {
        self.hide()
    })
    var dialogContainer = $('<div>').addClass('modalDialog-container').click(function() {
        self.hide()
    })
    var dialog = $(opts.submitFromEnter ? '<form>' : '<div>').addClass('modalDialog').appendTo(dialogContainer)
    if (opts.class) {
        dialog.addClass(opts.class)
    }
    dialog.click(function(e) {
        if (opts.popup)
            e.stopPropagation()
    })

    window._dialog = this

    $(window).on('hashchange', function(e) {

        //return confirm("You sure?")
    })


    if (!opts.popup)
        dialog.addClass('modalDialog-nonpopup')


    this.addHorizontalLine = function(container) {
        return $('<div>').addClass('modal-horizontalLine').appendTo(container || body)
    }

    title = $('<div>').addClass('modal-title modalPopupSection').append($('<h2>').append(title).addClass(''))

    if (opts.hideTitle == false) {
        title.appendTo(dialog)
    }

    if (opts.popup) {
        var closeButton = $('<div>').addClass('modalCloseButton').append($('<img>').attr('src', '/common/img/icon_close.png')).appendTo(dialog).click(function() {
            if (!closeButton.attr('disabled'))
                self.hide()
        })
    }
    var body = $('<div>').addClass('modalBody modalPopupSection').appendTo(dialog)
    var footer = $('<div>').addClass('modalFooter modalPopupSection').appendTo(dialog)

    if (opts.width) {
        dialog.find('.modalPopupSection').css({
            maxWidth: opts.width,
        })

        //includes 40 + 40 px padding
        dialog.css({maxWidth: 'calc(' + opts.width + ' + 80px)'})

        dialog.append($('<div>').width(opts.width).attr('reason', 'this block defines desired width'))
    }

    var values = []
    this.values = values

    var layoutWidth = 12 // align width, not real width
    var i = 0 // align position
    this.confirmLeave = function() {
        if (opts.preventLeaveOnChanges) {
            return window.escapedConfirm(lang.p.dialog.unsavedChanges.confirmText)
        }
        return

    }
    this.hasChangedValues = function() {
        if (!opts.preventLeaveOnChanges) {
            return false
        }
        var dlg = this
        $('input:focus').blur()

        var data = {}
        for (var i = 0; i < dlg.values.length; i++) {
            if (!dlg.values[i].valueName) continue
            if (dlg.values[i].changed || (dlg.values[i].inputBlock && dlg.values[i].inputBlock.data('changed')))
                data[dlg.values[i].valueName] = dlg.values[i]()
        }
        var changedProviderDLTimeInputs = $('.ProviderDLTimeInput input').toArray().map(function(input) { return $(input).val()}).toString()
        //console.log("checking for changes", this.values, data, changedProviderDLTimeInputs);
        return Object.keys(data).length > 0 || (this.savedProviderDLTimeInputs && changedProviderDLTimeInputs && this.savedProviderDLTimeInputs !== changedProviderDLTimeInputs)
    }
    this.addInput = function(options) {
        if (opts.autoTabIndexify && !Object.prototype.hasOwnProperty.call(options, 'tabIndex'))
            options.tabIndex = currentTabIndex++

        var appendToFooter = !!options.appendToFooter
        var block = window.createInputBlock(options)

        var s = options.size
        var w = 0 // align width, not real width
        if (s == 'half') {
            w = 6
            if (i % 6 != 0) this.add($('<br>'))
        }
        else if (s == 'big') w = 11
        else if (s == 'small') w = 1
        else if (s == 'auto') w = 1.234567

        if (!w) i = 0
        if (i > 0) block.addClass('inputBlock-notFirst')
        i = (i+w) % layoutWidth

        if (!options.addLater) {
            (appendToFooter ? footer : body).append(block)
        }


        if (options.name) {
            var getValueFunc = function() {
                return block.data('get')()
            }
            getValueFunc.valueName = options.name
            getValueFunc.inputBlock = block

            values.push(getValueFunc)
        }

        return block
    }

    this.addInputOld = function(name, title, placeholder, type, defaultValue, horizontalAlign, width, options = {}) {
        var div = window.createInputBlockOld(name, title, placeholder, type, defaultValue, horizontalAlign, width, options)

        body.append(div)

        var getValueFunc = div.getValueFunc
        getValueFunc.input = div.input
        getValueFunc.valueName = name
        getValueFunc.container = div
        values.push(getValueFunc)
        return getValueFunc
    }

    this.addInputTitle = function(title, subTitle, container) {
        container = container || body
        if (subTitle) subTitle = ' (' + subTitle + ')'
        else subTitle = ''
        var result = $('<div>').addClass('inputBlockTitle').text(title + subTitle)
        result.appendTo(container)
        return result
    }

    this.add = function(div) {
        if (opts.autoTabIndexify) {
            // Maybe go through div and find its inputs, and give them tabindexes.
            // If necessary.
            // options.tabIndex = currentTabIndex++;
        }

        body.append(div)
        return div
    }

    this.addToFooter = function(div) {
        footer.append(div)
        return div
    }

    function createButton(text, callback, optionalExtraClass) {
        return window.createBasicButton(text, function() {
            var data = {}
            for (var i = 0; i < values.length; i++) {
                if (!values[i].valueName) continue
                if (!opts.saveOnlyEdited || values[i].changed || (values[i].inputBlock && values[i].inputBlock.data('changed')))
                    data[values[i].valueName] = values[i]()
            }

            dialog.find('*').attr('disabled', true)
            callback.apply(null, [data])
        }, optionalExtraClass).addClass('modal-button')
    }

    this.addBodyButton = function(text, callback, optionalExtraClass) {
        var button = createButton(text, callback, optionalExtraClass)
        body.append(button)
        return button
    }

    this.addButton = function(text, callback, optionalExtraClass) {
        var button = createButton(text, callback, optionalExtraClass || 'basicConfirmButton')
        footer.append(button)

        if (opts.autoTabIndexify) {
            button.attr('tabindex', currentTabIndex++)
        }

        return button
    }

    this.addCancelButton = function() {
        console.log('addCancelButton not supported anymore')
        return
    }

    this.addTextButton = function(text, callback) {
        var button = window.createTextButton(text, callback)

        footer.append($('<div>').css('clear', 'both'), button)
        if (opts.autoTabIndexify) {
            button.attr('tabindex', currentTabIndex++)
        }

        return button
    }

    this.addClear = function() {
        this.add($('<div>').css('clear', 'both'))
    }
    this.disableAll = function() {
        dialog.find('*').attr('disabled', true)
    }
    this.enableAllAgain = function() {
        dialog.find('*').attr('disabled', false)
    }

    this.show = function() {

        var scrollPosition = document.body.scrollTop

        var dialog = dialogContainer.children('.modalDialog')

        dialogContainer.css({top: 0})

        dialogContainer.show()

        /*
		if ($('html')[0].classList.contains('provider')){
			console.log('porovider')

			 var topPosition = ~~((window.innerHeight - dialog.height()) / 2);
			 if (topPosition < 70)
			 topPosition = 70;

			 if (topPosition > window.innerHeight*0.25)
			 topPosition = ~~(window.innerHeight*0.25);


			 dialog.css({ top: (scrollPosition + topPosition) + 'px' });

			 dialog.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(){
				var input = dialog.find('input').first();
				if (input.val() == '') input.focus();
			});

		} else {
			dialog.css({ top: 0 })
		}
		*/

        // Couldn't get above scroll position memory thing to work so I'll just put the dialog to top of screen.
        dialog.css({ top: 0 })

        dialogContainer.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function() {
            //fix mobile safaris handling of extra viewport space
            $('html').height(window.innerHeight)
        })


        $('body').append(background, dialogContainer)

        var oldKeyDown = window.onkeydown
        window.onkeydown = function(e) {
            var ESC = 27
            if (e.keyCode == ESC) {
                self.hide()
                window.onkeydown = oldKeyDown
            }
        }
        $('body').addClass('scroll-freeze')
        background.show()

        if (opts.autofocusFirstInput) {
            dialogContainer.find('input, button').first().focus()
        }
    }
    this.hide = function(dismissChanges) {
        if (this.hasChangedValues() && !dismissChanges) {
            if (!this.confirmLeave()) {
                return
            }
        }

        dialogContainer.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function() {
            dialogContainer.remove()
        })

        $('body').removeClass('scroll-freeze')

        dialogContainer.addClass('modal-hide')

        background.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function() {
            background.remove()
        })
        background.addClass('modal-hide')

        if (opts.hideCallback)
            opts.hideCallback()
    }
    this.getDialogElement = function() {
        return dialog
    }
    this.isVisible = function() {
        return dialog.is(':visible')
    }
}
; /* START FILE provider/js/modalDialogOfferTemplate.js */ const repeatDays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

// This is called from Offer Templates page, when "+ New Template" button is clicked.
function openCreateOfferTemplateDialog() {
    var dlg = new window.ModalDialog(lang.p.dialog.template.title,
        { width: '700px', submitFromEnter: true, preventLeaveOnChanges: true })
    var self = this
    var name = dlg.addInput({
        name: 'name',
        label: lang.p.dialog.template.name.placeholder,
        placeholder: lang.p.dialog.template.name.placeholder,
        value: use.env.DEV_ENV ? 'Test Food' : '',
        size: 'auto',
        collapse: true,
        tabIndex: 1000,
        helpText: lang.p.dialog.template.name.helpText
    }).addClass('autofocus')

    window.TagProposer.addToDialog(dlg, name, false)

    var desc = dlg.addInput({
        type: 'textarea',
        name: 'description',
        label: lang.p.dialog.template.description.label,
        placeholder: lang.p.dialog.template.description.placeholder,
        value: '',
        tabIndex: 1250,
        helpText: lang.p.dialog.template.description.helpText,
        size: 'auto',
        collapse: true
    })
    window.TagProposer.addToDialog(dlg, desc, false)

    if (use.profile.enterpriseId) {
        dlg.addInput({
            name: 'itemCode',
            label: lang.p.dialog.template.itemCode.label,
            placeholder: lang.p.dialog.template.itemCode.placeholder,
            value: '',
            size: 'auto',
            collapse: true,
            helpText: '',
            tabIndex: 1500,
        })
    }

    var price = dlg.addInput({
        type: 'price',
        name: 'defaultPrice',
        label: lang.p.offers.table.price,
        placeholder: '0.00',
        value: use.profile.country.minPrice,
        size: 'auto',
        helpText: lang.p.dialog.template.defaultPriceHelpText,
        collapse: true,
        tabIndex: 2000,
    }).addClass('autofocus')

    const dynamicPricingBlock = window.addDynamicPricing(
        price,
        use.profile.country.minPrice,
        use.profile.isDynamicPricingEnabled
    )
    const quantityInput = dlg.addInput({
        ...window.offerCommonFields.quantity.attributes,
        tabIndex: 3000,
    }).addClass('autofocus')

    quantityInput
        .find('input')
        .change((e) => window.offerCommonFields.quantity.handleChange(e, quantityInput))

    quantityInput.hide()

    dlg.getDialogElement().on('submit', function(e) {
        e.preventDefault()
        dlg.getDialogElement().find('.inputBlock-collapse').trigger('collapse')
    })

    this.offerTimesInputs = new window.OfferTimesInputs({
        times: window.getProviderDefaultOrderAndFetchTimes()
    })
    this.offerTimesInputs.getEl().hide()

    var example = lang.p.dialog.template.description.example.split('\n').join('</p><p>')
    example = $('<em><p>' + example + '</p></em>')
    example.addClass('ProviderDescriptionExample')
    example.css({
        fontSize: '14px'
    })
    var exampleTitle = $('<div>' + lang.p.dialog.template.description.exampleDesc + '</div>')
    exampleTitle.css({
        textTransform: 'uppercase',
        fontSize: '14px'
    })

    desc.add(window.createAllergenReminder(dlg, desc))
    desc.find('.inputBlockContent').append(window.createAllergenReminder(dlg))
    desc.find('.inputBlockContent').append(exampleTitle)
    desc.find('.inputBlockContent').append(example)

    window.addTagSelectionToDialogPart1(dlg, null, 4000)

    if (use.env.DEV_ENV) {
        // TODO real image uploader widget
        var image = dlg
            .addInput({
                type: 'text',
                name: 'imageUrl',
                label: '(DEV) imageUrl',
                placeholder: 'You can edit url here but not upload yet',
                value: '',
                helpText: '',
                size: 'auto',
                collapse: true,
                tabIndex: 0,
                optional: true,
            })
            .addClass('input-image-url')
        dlg.add($('<div>').addClass('spacer').addClass('input-image-url'))
    }

    window.setupImageUrlVisibility(dlg)

    window.addTagSelectionToDialogPart2(dlg, null, 4000)

    // This UI toggle will be always hidden. The visibility of fetch & order times is now
    // controlled by repeat enabled toggle (see createRepeatControls in providerUIElementsOld.js),
    // which controls this toggle, which shows/hides the fetch & order times.
    var fetchOrderTimesToggle = dlg.addInput({
        type: 'checkbox2',
        label: '',
        value: '',
        tabIndex: 8000,
        addLater: true
    })

    // fetchOrderTimesToggle is always hidden.
    fetchOrderTimesToggle.hide()

    var data = {
        repeatEnabled: false,
        repeatPause: false,
        repeatDays: ['mon', 'tue', 'wed', 'thu', 'fri']
    }

    var repeatControls = window.createRepeatControls(dlg, data, fetchOrderTimesToggle)

    var repeatToggle = repeatControls.find('input')

    if (!use.profile.isModel) {
        dlg.add(repeatControls)
    }

    dlg.add(fetchOrderTimesToggle)

    fetchOrderTimesToggle.addClass('ProviderDLSwitch')
    var fetchOrderTimesToggleInput = fetchOrderTimesToggle.find('input')
    fetchOrderTimesToggleInput.change(function() {
        if (fetchOrderTimesToggleInput.prop('checked')) {
            //DLRangeTable.show();
            //timeGraph.show();
            self.offerTimesInputs.getEl().show()
            quantityInput.show()
        } else {
            //fetchOrderTimesDisclaimer.hide();
            //DLRangeTable.hide();
            self.offerTimesInputs.getEl().hide()
            //timeGraph.hide();
            quantityInput.hide()
        }
    })

    var closingTime = new Date()
    closingTime.setHours(23)
    closingTime.setMinutes(0)
    closingTime.setSeconds(0)
    closingTime.setMilliseconds(0)

    var firstSlot = new Date()
    firstSlot.setMinutes(0)
    firstSlot.setHours(6)
    firstSlot.setSeconds(0)
    firstSlot.setMilliseconds(0)

    var hardClosingTime = new Date(closingTime)
    hardClosingTime.setHours(24)
    var firstBundle = new Date(firstSlot)
    firstBundle.setMinutes(5)

    dlg.add(this.offerTimesInputs.getEl())

    dlg.addButton(lang.p.dialog.template.submit, function(data) {
        data.tags = window.getTagsFromModalDialog()

        if (dynamicPricingBlock) {
            data.isDynamicallyPriced = dynamicPricingBlock.data('value')
        }

        var values = this.offerTimesInputs.getTimes()

        if (!fetchOrderTimesToggleInput.prop('checked')) {
            values = {
                orderStartTime: null,
                orderEndTime: null,
                fetchStartTime: null,
                fetchEndTime: null
            }
        }

        $.extend(data, values)

        values = {}

        var repeatEnabled = false

        if (repeatToggle.prop('checked')) {
            repeatEnabled = true

            var days = repeatControls.find('.checkbox-list-buttons input').map(function(key, item) {
                return $(item).prop('checked') ? repeatDays[key] : ''
            }).filter(function(key, item) {
                return item.length > 0
            })

            var d = []

            for (var i = 0; i < days.length; i++) {
                d.push(days[i])
            }

            values = {
                repeatEnabled: repeatEnabled,
                repeatDays: d
            }

            $.extend(data, values)
        }

        window.removeImageUrlFromDataIfDisabled(dlg, data)

        window.postRequest('provider/offerTemplate', data).done(function(res) {
            var insertId = res['id']
            console.log('offer posted', insertId)

            var text = window.formatText(lang.p.templates.toast.add.success, '<strong>' + data.name + '</strong>')
            window.updateCurrentView(window.createRowBlinker(insertId))

            window.createToast(text, function() {
                $.extend(data, { id: insertId })
                openEditOfferTemplateDialog(data)
            })
            dlg.hide(true)

        }).fail(window.dialogFailResponse)
    })

    dlg.show()
}

// This is called from Offer Templates page, when "Edit" icon is clicked on a template.
function openEditOfferTemplateDialog(json) {
    const dlg = new window.ModalDialog(lang.p.dialog.editTemplate.title, {
        width: '700px',
        preventLeaveOnChanges: true,
    })
    var self = this
    //var name = dlg.addInputOld("name", lang.p.dialog.template.name.label, lang.p.dialog.template.name.placeholder, "text", json.name, "left", "78%");
    var name = dlg.addInput({
        name: 'name',
        label: lang.p.dialog.template.name.placeholder,
        placeholder: lang.p.dialog.template.name.placeholder,
        value: json.name,
        size: 'auto',
        collapse: true,
        helpText: lang.p.dialog.template.name.helpText,
        tabIndex: 1000,
    }).addClass('autofocus')
    window.TagProposer.addToDialog(dlg, name, false)

    var desc = dlg.addInput({
        type: 'textarea',
        name: 'description',
        label: lang.p.dialog.template.description.label,
        placeholder: lang.p.dialog.template.description.placeholder,
        value: json.description,
        size: 'auto',
        helpText: lang.p.dialog.template.description.helpText,
        collapse: true,
        tabIndex: 1250,
    })
    window.TagProposer.addToDialog(dlg, desc, false)

    desc.find('.inputBlockContent').append(window.createAllergenReminder(dlg))

    if (use.profile.enterpriseId) {
        dlg.addInput({
            name: 'itemCode',
            label: lang.p.dialog.template.itemCode.label,
            placeholder: lang.p.dialog.template.itemCode.placeholder,
            value: json.itemCode,
            size: 'auto',
            collapse: true,
            helpText: '',
            tabIndex: 1500,
        })
    }

    var price = dlg.addInput({
        type: 'price',
        name: 'defaultPrice',
        label: lang.p.offers.table.price,
        placeholder: '0.00',
        value: json.defaultPrice,
        size: 'auto',
        helpText: lang.p.dialog.template.defaultPriceHelpText,
        collapse: true,
        tabIndex: 2000,
    }).addClass('autofocus')

    const dynamicPricingBlock = window.addDynamicPricing(price, json.defaultPrice, json.isDynamicallyPriced)

    const attributes = Object.assign({}, window.offerCommonFields.quantity.attributes, { value: json.quantity })

    const quantityInput = dlg.addInput({
        ...attributes,
        tabIndex: 3000,
    }).addClass('autofocus')

    quantityInput
        .find('input')
        .change((e) => window.offerCommonFields.quantity.handleChange(e, quantityInput))

    quantityInput.hide()

    if (json.repeatEnabled) {
        quantityInput.show()
    }

    var example = lang.p.dialog.template.description.example.split('\n').join('</p><p>')
    example = $('<em><p>' + example + '</p></em>')
    example.addClass('ProviderDescriptionExample')
    example.css({
        fontSize: '14px'
    })
    var exampleTitle = $('<div>' + lang.p.dialog.template.description.exampleDesc + '</div>')
    exampleTitle.css({
        textTransform: 'uppercase',
        fontSize: '14px'
    })
    desc.find('.inputBlockContent').append(exampleTitle)
    desc.find('.inputBlockContent').append(example)

    window.addTagSelectionToDialogPart1(dlg, json, 5000)

    if (use.env.DEV_ENV) {
        // TODO real image uploader widget
        var image = dlg
            .addInput({
                type: 'text',
                name: 'imageUrl',
                label: '(DEV) imageUrl',
                placeholder: 'You can edit url here but not upload yet',
                value: json.imageUrl,
                helpText: '',
                size: 'auto',
                collapse: true,
                tabIndex: 0,
                optional: true,
            })
            .addClass('input-image-url')
        dlg.add($('<div>').addClass('spacer').addClass('input-image-url'))
    }

    window.setupImageUrlVisibility(dlg)

    window.addTagSelectionToDialogPart2(dlg, json, 5000)

    var defaults = window.getProviderDefaultOrderAndFetchTimes()

    var times = {
        orderStart: json.orderStartTime || defaults.orderStart,
        orderEnd: json.orderEndTime || defaults.orderEnd,
        fetchStart: json.fetchStartTime || defaults.fetchStart,
        fetchEnd: json.fetchEndTime || defaults.fetchEnd
    }

    this.offerTimesInputs = new window.OfferTimesInputs({
        times
    })

    // This UI toggle will be always hidden. The visibility of fetch & order times is now
    // controlled by repeat enabled toggle (see createRepeatControls in providerUIElementsOld.js),
    // which controls this toggle, which shows/hides the fetch & order times.
    var fetchOrderTimesToggle = dlg.addInput({
        type: 'checkbox2',
        label: '',
        value: '',
        addLater: true
    })
    fetchOrderTimesToggle.hide()

    var repeatWasEnabled = json.repeatEnabled

    if (repeatWasEnabled) {
        fetchOrderTimesToggle.find('input').prop('checked', true)
        self.offerTimesInputs.getEl().show()
        //DLRangeTable.show();
        //timeGraph.show();
    } else {
        fetchOrderTimesToggle.find('input').prop('checked', false)
        self.offerTimesInputs.getEl().hide()
        //DLRangeTable.hide();
        //timeGraph.hide();
    }

    var repeatControls = window.createRepeatControls(dlg, json, fetchOrderTimesToggle, function(value) {
        if (value) {
            quantityInput.show()
        } else {
            quantityInput.hide()
        }
    })
    var repeatToggle = repeatControls.find('input')

    dlg.add(repeatControls)

    dlg.add(fetchOrderTimesToggle)

    var fetchOrderTimesToggleInput = fetchOrderTimesToggle.find('input')
    fetchOrderTimesToggle.addClass('ProviderDLSwitch')

    fetchOrderTimesToggleInput.change(function() {
        if (fetchOrderTimesToggleInput.prop('checked')) {
            self.offerTimesInputs.getEl().show()
            //DLRangeTable.show();
            //timeGraph.show();

        } else {
            self.offerTimesInputs.getEl().hide()
            //DLRangeTable.hide();
            //timeGraph.hide();
        }
    })

    dlg.add(this.offerTimesInputs.getEl())

    dlg.addButton(lang.p.dialog.editTemplate.submit, function(data) {
        data.tags = window.getTagsFromModalDialog()
        //ar values = getOfferTimes({ format: 'time' });
        //set values to null if edit times is unchecked

        if (dynamicPricingBlock) {
            data.isDynamicallyPriced = dynamicPricingBlock.data('value')
        }

        var values = this.offerTimesInputs.getTimes()

        if (!fetchOrderTimesToggleInput.prop('checked')) {
            values = {
                orderStartTime: null,
                orderEndTime: null,
                fetchStartTime: null,
                fetchEndTime: null
            }
        }

        $.extend(data, values)
        var repeatEnabled = false

        if (repeatToggle.prop('checked')) {
            repeatEnabled = true
        }

        var days = repeatControls.find('.checkbox-list-buttons input').map(function(key, item) {

            return $(item).prop('checked') ? repeatDays[key] : ''
        }).filter(function(key, item) {
            return item.length > 0
        })

        var d = []

        for (var i = 0; i < days.length; i++) {
            d.push(days[i])
        }

        values = {
            repeatEnabled: repeatEnabled,
            repeatDays: d
        }

        $.extend(data, values)
        $.extend(data, { id: json.id })

        // console.warn('saving template', data)

        window.removeImageUrlFromDataIfDisabled(dlg, data)

        window.postRequest('provider/offerTemplate/' + json.id, data).done(function() {
            window.updateCurrentView(window.createRowBlinker(json.id))

            var text = window.formatText(lang.p.templates.toast.edit.success, '<strong>' + data.name + '</strong>')
            window.createToast(text, function() {
                openEditOfferTemplateDialog(data)
            })

            dlg.hide(true)
        }, 'basicConfirmButton').fail(window.dialogFailResponse)

    })

    //console.info("defaults", defaults, json);
    /*
	var timeGraph = dlg.createTimeGraph({ graphHours: 17, hideCurrentTime: true });
	dlg.updateTimeGraph(timeGraph, { values: defaults, firstSlot: firstSlot, closingTime: closingTime });
	dlg.add(timeGraph);
	var DLRangeTable = dlg.addDLRangeTable({
		values: defaults, onValuesChanged: function(values) {
			console.warn("DLRangeTable content changed", values);
			var times = {};
			for (var key in values){
				times[key] = stringToDate(values[key]);
			}

			dlg.updateTimeGraph(timeGraph, { values: times, firstSlot: firstSlot, closingTime: closingTime });
			return;


			var values = getOfferTimes();
			var fetchStart = $('input[name=fetchStart]');
			var orderStart = $('input[name=orderStart]');
			var orderEnd = $('input[name=orderEnd]');
			var fetchEnd = $('input[name=fetchEnd]');
			if (changedInput){

				var inputName = changedInput.attr('name');

				if (stringToDate(changedInput.val()).getTime() < firstBundle.getTime()) {
					//console.warn("date overflow", changedInput.val())
					changedInput.val(dateToString(firstBundle, true))
					return;
				} else if (stringToDate(changedInput.val()).getTime() > hardClosingTime.getTime()) {
					//console.warn("date overflow", changedInput.val())
					changedInput.val(dateToString(hardClosingTime, true))
					return;
				}

				if (inputName === 'orderStart') {
					//console.log("orderstart changed", changedInput.val())
					if (stringToDate(changedInput.val()).getTime() > stringToDate(fetchStart.val()).getTime()) {
						fetchStart.val(changedInput.val())
					}
				} else if (inputName === 'fetchStart') {
					if (changedInput.val() === orderStart.val()) {

					} else if (stringToDate(changedInput.val()).getTime() < stringToDate(orderStart.val()).getTime()) {

						var minutes = getBundleMinutes(stringToDate(orderStart.val()).getMinutes()) - 30;
						var newDate = stringToDate(orderStart.val())
						newDate.setMinutes(minutes)
						var time = dateToString(newDate, true);
						changedInput.val(time)
						orderStart.val(time)

						//orderStart.val(changedInput.val())
					}
				} else if (inputName === 'fetchEnd') {

					if (stringToDate(changedInput.val()).getTime() < stringToDate(orderEnd.val()).getTime()) {
						//changedInput.val(orderEnd.val())
						orderEnd.val(changedInput.val())
					}
				} else if (inputName === 'orderEnd') {

					if (stringToDate(changedInput.val()).getTime() > stringToDate(fetchEnd.val()).getTime()) {
						fetchEnd.val(changedInput.val())
					} else if (true) {

					}
				}
			}
			//console.log("update timegraph with", values)
			dlg.updateTimeGraph(timeGraph, { values: values, firstSlot: firstSlot, closingTime: closingTime });
		}
	});

	if (json.orderStartTime || json.orderEndTime || json.fetchStartTime || json.fetchEndTime) {
		fetchOrderTimesToggleInput.prop('checked', true)
		//DLRangeTable.show();
		//timeGraph.show();
	} else {
		//DLRangeTable.hide();
		//timeGraph.hide();
	}
*/
    dlg.show()

    function getOfferTimes(options) {
        var data

        if (options && options.format && options.format === 'time') {
            data = {
                orderStartTime: window.DLRangeTable.find('input[name=orderStart]').val() + ':00',
                orderEndTime: window.DLRangeTable.find('input[name=orderEnd]').val() + ':00',
                fetchStartTime: window.DLRangeTable.find('input[name=fetchStart]').val() + ':00',
                fetchEndTime: window.DLRangeTable.find('input[name=fetchEnd]').val() + ':00'
            }
        } else {
            data = {
                orderStart: window.stringToDate(window.DLRangeTable.find('input[name=orderStart]').val()),
                orderEnd: window.stringToDate(window.DLRangeTable.find('input[name=orderEnd]').val()),
                fetchStart: window.stringToDate(window.DLRangeTable.find('input[name=fetchStart]').val()),
                fetchEnd: window.stringToDate(window.DLRangeTable.find('input[name=fetchEnd]').val())
            }
        }

        return data
    }
}
; /* START FILE provider/js/modalDialogOffer.js */ // Utility for showing/hiding image input when the input is being set up
function setupImageUrlVisibility(dialog) {
  const dialogEl = dialog.getDialogElement()
  const body = dialogEl.children('.modalBody')
  if (!body.length) {
    log('setupImageUrlVisibility(): body not found')
  }
  if (use.env.allowImages) {
    body.removeClass('disable-image-input')
  } else {
    body.addClass('disable-image-input')
  }
}

function removeImageUrlFromDataIfDisabled(dialog, data) {
  const dialogEl = dialog.getDialogElement()
  const body = dialogEl.children('.modalBody')
  if (!body.length) {
    log('setupImageUrlVisibility(): body not found')
  }
  if (body.hasClass('disable-image-input')) {
    data.imageUrl = ''
  }
}

function addTimeInputs(dlg, options = {}) {
  // Overly complicated Time stuff:
  // ##############################

  if (options.selectedDay === undefined) {
    options.selectedDay = 0
  }

  if (options.showExactPublishTime === undefined) {
    options.showExactPublishTime = true
  }

  var publishTime

  const selectedDayWrapper = {
    selectedDay: options.selectedDay
  }

  var daySelector = dlg
    .addInput({
      type: 'radio',
      radioElements: [
        {
          id: 'today',
          checked: selectedDayWrapper.selectedDay == 0,
          label: lang.p.dialog.orderpickuptimes.today,
        },
        {
          id: 'tomorrow',
          checked: selectedDayWrapper.selectedDay == 1,
          label: lang.p.dialog.orderpickuptimes.tomorrow,
        },
      ],
    })
    .addClass('inputBlock-checkboxButtons')
    .change(function () {
      var value = daySelector.data('value')

      if (value === 'today') {
        var movedDefaults = window.getProviderDefaultOrderAndFetchTimes(0)

        // If default orderEnd is less than the current time,
        // use current time + 1 hour as the default order end.
        //
        // This will also push pickup end time as far into the future
        // as necessary (if necessary).
        const nowTime = new window.OfferTime().fromDate(new Date())
        const orderEndOfferTime = new window.OfferTime().setTime(movedDefaults.orderEnd)

        const oneHourFromNow = new window.OfferTime().fromDate(new Date())
        oneHourFromNow.setHours(oneHourFromNow.getHours() + 1)
        if (orderEndOfferTime.getValue() <= nowTime.getValue()) {
          movedDefaults.orderEnd = oneHourFromNow.getTime() + ':00'
        }

        selectedDayWrapper.selectedDay = 0

        self.offerTimesInputs.init({
          times: movedDefaults,
          afterNow: true,
          nowTime: nowTime,
        })
      } else if (value === 'tomorrow') {
        selectedDayWrapper.selectedDay = 1
        self.offerTimesInputs.init({
          times: window.getProviderDefaultOrderAndFetchTimes(1),
          afterNow: false,
          daysFromNow: 1
        })
      } else {
        throw new Error('invalid daySelector value ' + value)
      }
    })

  dlg.add(window.offerTimesInputs.getEl())

  var info = $('<div>').css({
    display: 'inline-block',
    fontSize: '14px',
    lineHeight: '20px',
  })
  info.addClass('ProviderPublishInfo inputBlock')

  if (!options.showExactPublishTime) {
    info.hide()
  }
  var timeSpan = $('<span class="ProviderPublishTime">')

  function updateTimes(force) {
    if (selectedDayWrapper.selectedDay > 0) {
      publishTime = window.stringToDate(self.offerTimesInputs.getTimes().orderStartTime)
      publishTime.setDate(publishTime.getDate() + selectedDayWrapper.selectedDay)
    } else {
      publishTime = window.stringToDate(self.offerTimesInputs.getTimes().orderStartTime)
    }

    if (!force && !dlg.isVisible()) {
      return
    }

    var notificationTimeString = window.dateToString(publishTime, true)

    var diff =
      (publishTime - window.getLocalDate(use.profile.timezoneOffsetInMinutes)) / 1000 / 60

    var diffString = ''
    if (diff > 2) {
      diffString = '' + Math.floor(diff) + ' ' + lang.p.dialog.offer.minutes
    } else if (diff < 0) {
      diffString = '0 ' + lang.p.dialog.offer.seconds
    } else {
      diffString = '' + Math.floor(diff * 60) + ' ' + lang.p.dialog.offer.seconds
    }

    var bundleCheck = !$('input[name=orderStart]').data('disable-bundle-check')
    if (timeSpan.text() != notificationTimeString) {
      timeSpan.text(notificationTimeString)
    }

    var str = '' + lang.p.dialog.offer.thatIsIn + ' ' + diffString
    if (timeLeftSpan.text() !== str) {
      timeLeftSpan.text(str)
    }

    if (!bundleCheck) {
      timeSpan.hide()
      timeLeftSpan.hide()
      timeNowSpan.show()
    } else {
      timeSpan.show()
      timeLeftSpan.show()
      timeNowSpan.hide()
    }

    if (diff <= 0 && bundleCheck) {
      var nextPublish = window.getLocalDate(use.profile.timezoneOffsetInMinutes)
      var min = window.getBundleMinutes(nextPublish.getMinutes() + 1)
      nextPublish.setSeconds(0)
      nextPublish.setMilliseconds(0)
      nextPublish.setMinutes(min)
    }
  }

  var timeLeftSpan = $('<div>').addClass('timeLeft')
  var timeNowSpan = $('<div>' + lang.p.dialog.orderpickuptimes.now + '</div>')
  timeNowSpan.addClass('ProviderPublishTime')
  timeNowSpan.hide()
  info.append([
    $('<span class="ProviderPublishTimeWillPublishTime">').text(
      lang.p.dialog.offer.willPublishTime + ' '
    ),
    timeSpan,
    timeLeftSpan,
    timeNowSpan,
  ])

  window.setIntervalUntilElementIsHidden(updateTimes, 1000, dlg.getDialogElement())

  dlg.add(info)

  dlg.addClear()

  return {daySelector, selectedDayWrapper}
}

// This is called from Offer Templates page, when "Make offer..." button is clicked
// And from Offer page, when "+ New Offer..." button and then a template is clicked
function openCreateOfferDialog(offerTemplateJSON) {
  const dlg = new window.ModalDialog(lang.p.dialog.offer.title, {
    width: '500px',
    preventLeaveOnChanges: true,
  })

  var self = window

  const defaultTimes = window.getProviderDefaultOrderAndFetchTimes(0)

  window.offerTimesInputs = new window.OfferTimesInputs({
    times: defaultTimes,
    afterNow: true,
    nowTime: new window.OfferTime().fromDate(new Date()),
  })

  var name = dlg.addInput({
    name: 'name',
    label: lang.p.dialog.editOffer.form.name.label,
    placeholder: lang.p.dialog.editOffer.form.name.placeholder,
    value: offerTemplateJSON.name,
    size: 'auto',
    collapse: true,
    helpText: lang.p.dialog.template.name.helpText,
    tabIndex: 1000,
    disabled: use.profile.enforceSharedTemplates,
  })

  var description = dlg.addInput({
    type: 'textarea',
    name: 'description',
    label: lang.p.dialog.editOffer.form.description.label,
    placeholder: lang.p.dialog.editOffer.form.description.placeholder,
    value: offerTemplateJSON.description,
    size: 'auto',
    collapse: true,
    tabIndex: 1500,
    disabled: use.profile.enforceSharedTemplates,
  })

  var price = dlg
    .addInput({
      type: 'price',
      name: 'price',
      label: window.formatText(
        lang.p.dialog.offer.form.unitPrice,
        use.profile.country.currency.name
      ),
      placeholder: '0.00',
      value: offerTemplateJSON.defaultPrice,
      size: 'auto',
      collapse: true,
      tabIndex: 2000,
      disabled: use.profile.enforceSharedTemplates,
    })
    .addClass('autofocus')

  const dynamicPricingBlock = window.addDynamicPricing(
    price,
    offerTemplateJSON.defaultPrice,
    offerTemplateJSON.isDynamicallyPriced
  )

  const quantityInput = dlg.addInput({
    ...window.offerCommonFields.quantity.attributes,
    placeholder: lang.p.dialog.inputBlockLabel.tapToSet,
    tabIndex: 3000,
  })
  quantityInput
    .find('input')
    .change((e) => window.offerCommonFields.quantity.handleChange(e, quantityInput))

  //addTagSelectionToDialogPart1(dlg, offerTemplateJSON, 0, use.profile.enforceSharedTemplates)

  addImageSelectorToDialog(dlg, offerTemplateJSON)

  //addTagSelectionToDialogPart2(dlg, offerTemplateJSON, 0, use.profile.enforceSharedTemplates)

  setTimeout(function () {
    if (!window.isTouch) {
      quantityInput.find('input').focus()
      quantityInput.find('input').select()
    }
  }, 250)

  dlg.addClear()

  var updateOfferTemplate

  function showSaveChanges() {
    function getInputValue(block) {
      return block.data('get')()
    }

    var isVisible =
      getInputValue(name) !== offerTemplateJSON.name ||
      getInputValue(description) !== offerTemplateJSON.description ||
      getInputValue(price) !== offerTemplateJSON.defaultPrice ||
      (dynamicPricingBlock &&
        getInputValue(dynamicPricingBlock) !== offerTemplateJSON.isDynamicallyPriced)

    // TODO once templates have non-null imageUrls, add this
    // || getInputValue(imageUrl) !== offerTemplateJSON.imageUrl

    if (isVisible) {
      updateOfferTemplate.show()
    } else {
      updateOfferTemplate.data('set')(false)
      updateOfferTemplate.hide()
    }
  }

  if (offerTemplateJSON.providerId === use.profile.id) {
    updateOfferTemplate = dlg.addInput({
      type: 'checkbox2',
      name: 'updateOfferTemplate',
      label: lang.offers.dialog.summary.saveChangesToTemplate,
      value: false,
      size: 'auto',
    }).hide()

    // TODO also listen to changes in tags (if they are re-enabled for editing!)
    // dynamicPricingBlock need not be listened since its input events bubble up to price
    var offerTemplateFields = [name, description, price]

    for (var otf of offerTemplateFields) {
      otf.on('input', showSaveChanges)
    }
  }

  const {daySelector, selectedDayWrapper} = addTimeInputs(dlg)

  dlg.addButton(
    lang.offers.dialog.publishOffer,
    function (data) {
      var tags = []

      for (var i = 0; i < offerTemplateJSON.tags.length; i++) {
        tags.push(offerTemplateJSON.tags[i].id)
      }

      //var tags = getTagsFromModalDialog()
      data.tags = window.cleanTagConflicts(tags)
      data.day = window.getLocalDate(use.profile.timezoneOffsetInMinutes).getDay()

      if (dynamicPricingBlock) {
        data.isDynamicallyPriced = dynamicPricingBlock.data('value')
      }

      var times = self.offerTimesInputs.getTimes()
      var todayTimes = {}
      for (var key in times) {
        var time = new window.OfferTime().setTime(times[key])
        var date = new Date()

        if (time.getHours() < 6) {
          date.setHours(date.getHours() + 24)
        }
        if (date.getHours() < 6) {
          date.setHours(date.getHours() - 24)
        }

        date.setHours(time.getHours())
        date.setMinutes(time.getMinutes())
        date.setSeconds(0)
        date.setMilliseconds(0)
        todayTimes[key.replace('Time', '')] = date
      }

      var futureTimes = {}

      ;['orderStart', 'orderEnd', 'fetchStart', 'fetchEnd'].forEach(function (item, key) {
        var date = new Date(todayTimes[item])
        date.setDate(date.getDate() + 1)
        futureTimes[item] = date
      })

      if (selectedDayWrapper.selectedDay > 0) {
        data.day = data.day + selectedDayWrapper.selectedDay
        $.extend(data, futureTimes)
      } else {
        $.extend(data, todayTimes)
      }

      data.createOfferTemplate = false
      data.offerTemplateId = offerTemplateJSON.id

      removeImageUrlFromDataIfDisabled(dlg, data)

      var saveChanges = data.updateOfferTemplate
      delete data.updateOfferTemplate

      showPriceHighWarning(data.price, data.tags)
        .then(() => postOfferCreation(dlg, data))
        .then(() => {
          if (saveChanges) {
            var templateData = {
              name: data.name,
              description: data.description,
              defaultPrice: data.price,
              isDynamicallyPriced: data.isDynamicallyPriced,
              // TODO uncomment when templates can have imageUrls
              // imageUrl: data.imageUrl,
              //tags: data.tags,
            }
            window.postRequest('provider/offerTemplate/' + data.offerTemplateId, templateData)
          }
        })
        .fail(() => {
          dlg.enableAllAgain()
        })
    },
    'basicConfirmButton'
  )

  daySelector.trigger('change')
  dlg.show()
}

// This is called from Offers page, when "Edit" icon is clicked on an offer
function openEditOfferDialog(json) {
  var self = window

  const dlg = new window.ModalDialog(lang.p.dialog.editOffer.title, {
    width: '700px',
    preventLeaveOnChanges: true,
  })

  // Limit editing to quantity and order & fetch times. The following fields are disabled:
  // - name
  // - description
  // - imageUrl
  // - tags (offer type and other tags)
  const editingIsLimited = json.ordered > 0 && !use.env.admin

  var name = dlg
    .addInput({
      name: 'name',
      label: lang.p.dialog.editOffer.form.name.label,
      placeholder: lang.p.dialog.editOffer.form.name.placeholder,
      value: json.name,
      size: 'auto',
      collapse: true,
      helpText: lang.p.dialog.template.name.helpText,
      disabled: use.profile.enforceSharedTemplates || editingIsLimited,
    })
    .addClass('autofocus')
  window.TagProposer.addToDialog(dlg, name, false)

  var desc = dlg.addInput({
    type: 'textarea',
    name: 'description',
    label: lang.p.dialog.editOffer.form.description.label,
    placeholder: lang.p.dialog.editOffer.form.description.placeholder,
    value: json.description,
    size: 'auto',
    collapse: true,
    disabled: use.profile.enforceSharedTemplates || editingIsLimited,
  })
  window.TagProposer.addToDialog(dlg, desc, false)

  desc.find('.inputBlockContent').append(window.createAllergenReminder(dlg))

  var price = dlg
    .addInput({
      type: 'price',
      name: 'price',
      label: window.formatText(
        lang.p.dialog.offer.form.unitPrice,
        use.profile.country.currency.name
      ),
      placeholder: '0.00',
      value: json.price,
      size: 'auto',
      collapse: true,
      disabled: use.profile.enforceSharedTemplates,
    })
    .addClass('autofocus')

  var priceDiv = $('<div>').text(lang.p.dialog.editOffer.form.price + ' ')
  priceDiv.append(window.formatCurrency(json.price, use.profile.country.currency))
  priceDiv.append(' ' + lang.p.dialog.editOffer.form.priceDescription)
  price.find('input').hide()
  price.find('.inputBlockContent').append(priceDiv)

  priceDiv.css({
    marginBottom: '20px',
  })

  const dynamicPricingBlock = window.addDynamicPricing(price, json.price, json.isDynamicallyPriced)

  const existingOffer = {ordered: json.ordered || 0, defaultValue: json.originalQuantity}
  const quantityInput = dlg.addInput({
    ...window.offerCommonFields.quantity.attributes,
    label: lang.p.dialog.editOffer.form.totalQuantity,
    value: json.originalQuantity,
  })
  quantityInput.find('input').change((e) => window.offerCommonFields.quantity.handleChange(e, quantityInput, existingOffer))

  window.setInputBlockSummary(
    quantityInput,
    `<span>${existingOffer.ordered}/${json.originalQuantity}</span><em> ${lang.p.offers.table.sold}</em>`
  )

  var defaults = {
    orderStart: new window.TimeValidator().getValFromDate(new Date(json.orderStart)) + ':00',
    orderEnd: new window.TimeValidator().getValFromDate(new Date(json.orderEnd)) + ':00',
    fetchStart: new window.TimeValidator().getValFromDate(new Date(json.fetchStart)) + ':00',
    fetchEnd: new window.TimeValidator().getValFromDate(new Date(json.fetchEnd)) + ':00',
  }

  addTagSelectionToDialogPart1(
    dlg,
    json,
    0,
    use.profile.enforceSharedTemplates || editingIsLimited
  )

  addImageSelectorToDialog(dlg, json, editingIsLimited)

  addTagSelectionToDialogPart2(
    dlg,
    json,
    0,
    use.profile.enforceSharedTemplates || editingIsLimited
  )

  dlg.addHorizontalLine()
  dlg.add(
    $(
      '<div class="inputBlock" style="margin-top: 30px"><div class="inputBlockTitle">' +
      lang.p.dialog.orderpickuptimes.orderpickuptime +
      '</div></div>'
    )
  )

  // NOTE: this happens in the local time and time zone of the device that the partner is
  // using. Doing it otherwise might indeed be confusing, since that device's clock is
  // what the partner thinks the time is, let's not mess with that.
  //
  // This converts a date like '2021-05-05 12:12:23.333' to the start of the day
  // (in this case, '2021-05-05 00:00:00.000') so it can be compared to today more easily.
  function getStartOfDayInResQUniverse(date) {
    const result = new Date(date)
    // 00:00 - 04:00 belong to the previous date
    if (result.getHours() < 4 || (result.getHours() === 4 && result.getMinutes() === 0)) {
      result.setDate(result.getDate() - 1)
    }
    result.setHours(0, 0, 0, 0)
    return result
  }

  const today = getStartOfDayInResQUniverse(new Date())
  const tomorrow = getStartOfDayInResQUniverse(new Date())
  tomorrow.setDate(tomorrow.getDate() + 1)

  // 0: today
  // 1: tomorrow
  // These two are possible. (In the web app at least)
  let daysFromNow
  const orderStartDay = getStartOfDayInResQUniverse(json.orderStart)
  if (orderStartDay.getTime() === today.getTime()) {
    daysFromNow = 0
  } else if (orderStartDay.getTime() === tomorrow.getTime()) {
    daysFromNow = 1
  } else {
    // This error only seen if something seriously goes wrong, so hardcoded string ok
    window.showAlert('Only orders scheduled for today and tomorrow can be edited.')
    throw new Error(`invalid order day: ${orderStartDay} (today: ${today})`)
  }

  window.offerTimesInputs = new window.OfferTimesInputs({
    times: defaults,
    afterNow: false,
    offerId: json.id,
    validateNow: true,
    daysFromNow,
  })

  const {daySelector, selectedDayWrapper} = addTimeInputs(dlg, {
    selectedDay: daysFromNow,
    showExactPublishTime: false,
  })

  dlg.addButton(
    lang.p.dialog.editOffer.form.submit,
    function (data) {
      const tags = getTagsFromModalDialog()
      data.tags = window.cleanTagConflicts(tags)

      const times = self.offerTimesInputs.getTimes()
      const todayTimes = {
        orderStart: json.orderStart,
        orderEnd: json.orderEnd,
        fetchStart: json.fetchStart,
        fetchEnd: json.fetchEnd,
      }

      if (dynamicPricingBlock) {
        data.isDynamicallyPriced = dynamicPricingBlock.data('value')
      }

      for (const key in times) {
        // this has provider timezone baked in

        const time = new window.OfferTime().setTime(times[key])

        const date = getStartOfDayInResQUniverse(new Date(json.orderStart))

        // Possible date adjustment 1:
        // 00:00 - 04:00 (the maximum value after midnight) are interpreted as the next day
        if (time.getHours() <= 4) {
          date.setDate(date.getDate() + 1)
        }

        // Possible date adjustment 2:
        // daysFromNow is the original value of today/tomorrow selector; current value is
        // stored in selectedDayWrapper. The difference is used to adjust the date.
        const dayChange = selectedDayWrapper.selectedDay - daysFromNow
        date.setDate(date.getDate() + dayChange)

        date.setHours(time.getHours(), time.getMinutes(), 0, 0)

        // OK, so this is how the midnight-detecting code *used* to be. First of all, let's
        // start from what 'time' is. If the time input says 12:00, then time.getValue()
        // would be minutes starting from previous midnight... in UTC timezone. Because it
        // uses a Date object dated 1970-01-01, the offset is +02:00... IF your computer
        // uses the Finnish timezone. So in Finland:
        // 12:00 => this.getValue() / 60 === 10
        // 04:00 => this.getValue() / 60 === 26
        //
        // As said, this depended on the time zone of the device that uses the partner app.
        // If the timezone Asia/Tokyo:
        // 12:00 => this.getValue() / 60 === 3
        // 04:00 => this.getValue() / 60 === 19
        //
        // So, the code here checked if time was after midnight... if you happened to be
        // in the Finnish timezone. And it broke on all others. Another bug: what does
        // date.getHours() + 24 do near daylight savings adjustment dates?
        //
        // if (time.getValue() / 60 >= 22) {
        // 	date.setHours(date.getHours() + 24)
        // }

        const k = key.replace('Time', '')
        todayTimes[k] = date
      }

      $.extend(data, todayTimes)

      removeImageUrlFromDataIfDisabled(dlg, data)

      postOfferEdit(dlg, data, json.id)
    },
    'basicConfirmButton'
  )
  dlg.show()
}

// This is called from Offers page, when "+ New Offer..." button and then "+ Create new offer"
// button is clicked.
function openCreateOfferFromScratchDialog() {
  var json = {
    name: '',
    tags: []
  }

  window.offerTimesInputs = new window.OfferTimesInputs({
    times: window.getProviderDefaultOrderAndFetchTimes(0),
    afterNow: true,
    nowTime: new window.OfferTime().fromDate(new Date()),
  })

  var self = window
  const dlg = new window.ModalDialog(lang.p.offers.button.newOffer, {
    width: "700px",
    preventLeaveOnChanges: true,
  })

  dlg.addInput({
    type: 'checkbox2',
    name: 'createOfferTemplate',
    label: lang.offers.dialog.summary.saveAsTemplate,
    value: use.profile.createOfferTemplateByDefault,
    size: 'auto',
  })

  var name = dlg
    .addInput({
      name: 'name',
      label: lang.p.dialog.editOffer.form.name.label,
      placeholder: lang.p.dialog.editOffer.form.name.placeholder,
      value: json.name,
      size: 'auto',
      collapse: true,
      helpText: lang.p.dialog.template.name.helpText,
      tabIndex: 0,
    })
    .addClass('autofocus')
  window.TagProposer.addToDialog(dlg, name, false)

  setTimeout(function () {
    if (!window.isTouch) {
      name.find('input').focus()
      name.find('input').select()
    }
  }, 250)

  var desc = dlg.addInput({
    type: 'textarea',
    name: 'description',
    label: lang.p.dialog.editOffer.form.description.label,
    placeholder: lang.p.dialog.editOffer.form.description.placeholder,
    value: json.description,
    size: 'auto',
    collapse: true,
    tabIndex: 0,
  })
  window.TagProposer.addToDialog(dlg, desc, false)

  desc.find('.inputBlockContent').append(window.createAllergenReminder(dlg))

  var price = dlg
    .addInput({
      type: 'price',
      name: 'price',
      label: window.formatText(
        lang.p.dialog.offer.form.unitPrice,
        use.profile.country.currency.name
      ),
      placeholder: '0',
      value: null,
      size: 'auto',
      collapse: true,
      tabIndex: 0,
    })
    .addClass('autofocus')

  const dynamicPricingBlock = window.addDynamicPricing(
    price,
    null,
    use.profile.isDynamicPricingEnabled
  )

  const quantityInput = dlg.addInput({
    ...window.offerCommonFields.quantity.attributes,
    label: lang.p.dialog.editOffer.form.totalQuantity,
    tabIndex: 0,
  })
  quantityInput.find('input').change((e) => window.offerCommonFields.quantity.handleChange(e, quantityInput))

  addTagSelectionToDialogPart1(dlg, json)

  addImageSelectorToDialog(dlg)

  addTagSelectionToDialogPart2(dlg, json)

  const {daySelector, selectedDayWrapper} = addTimeInputs(dlg)

  dlg.addButton(
    lang.offers.dialog.publishOffer,
    function (data) {
      const tags = getTagsFromModalDialog()
      data.tags = window.cleanTagConflicts(tags)

      // I dunno why day is in data... I just copied this.
      data.day = window.getLocalDate(use.profile.timezoneOffsetInMinutes).getDay()

      if (dynamicPricingBlock) {
        data.isDynamicallyPriced = dynamicPricingBlock.data('value')
      }

      var times = self.offerTimesInputs.getTimes()
      var todayTimes = {}
      for (var key in times) {
        var time = new window.OfferTime().setTime(times[key])
        var date = new Date()

        if (time.getHours() < 6) {
          date.setHours(date.getHours() + 24)
        }
        if (date.getHours() < 6) {
          date.setHours(date.getHours() - 24)
        }

        date.setHours(time.getHours())
        date.setMinutes(time.getMinutes())
        date.setSeconds(0)
        date.setMilliseconds(0)
        todayTimes[key.replace('Time', '')] = date
      }

      var futureTimes = {}

      ;['orderStart', 'orderEnd', 'fetchStart', 'fetchEnd'].forEach(function (item) {
        var date = new Date(todayTimes[item])
        date.setDate(date.getDate() + 1)
        futureTimes[item] = date
      })

      if (selectedDayWrapper.selectedDay > 0) {
        data.day = data.day + selectedDayWrapper.selectedDay
        $.extend(data, futureTimes)
      } else {
        $.extend(data, todayTimes)
      }

      if (data.price === null || isNaN(data.price)) {
        window.dialogFailResponse(lang.offers.dialog.fields.price.errorEmpty)
        return
      }

      removeImageUrlFromDataIfDisabled(dlg, data)

      showPriceHighWarning(data.price, data.tags).then(() => postOfferCreation(dlg, data)).fail(() => {
        dlg.enableAllAgain()
      })
    },
    'basicConfirmButton'
  )
  daySelector.trigger('change')
  dlg.show()
}

function postOfferCreation(dlg, data) {
  return window.postRequest('provider/offer', data)
    .done(function () {
      window.updateMyInfo() // visibleOnMap may have changed
      window.updateCurrentView()
      dlg.hide(true)

      var text = window.formatText(
        lang.p.offers.toast.add.success,
        '<strong>' + data.name + '</strong>'
      )
      window.createToast(text, '#offers')
    })
    .fail(window.dialogFailResponse)
}

function postOfferEdit(dlg, data, id) {
  return window.postRequest('provider/offer/' + id, data)
    .done(function () {
      window.updateCurrentView(window.createRowBlinker(id))
      var text = window.formatText(
        lang.p.offers.toast.edit.success,
        '<strong>' + data.name + '</strong>'
      )
      window.createToast(text)
      dlg.hide(true)
    })
    .fail(window.dialogFailResponse)
}


function getTagsFromModalDialog() {
  // Disable tags that don't need to be saved.
  // .remove-me are disabled because they are hidden due to food type selection
  // [disableReason] are disabled because they are implied by some other tag
  $('.tag-button.remove-me, .tag-button[disableReason]').removeClass('selected')

  var selectedTags = []
  $('.tag-button.selected').each(function () {
    selectedTags.push($(this).attr('tagId'))
  })
  return selectedTags
}

// Returns a jQuery element.
// json is offer or template json. May be incomplete.
function createTagSelection(json, tags, additionalClass, placeholder) {
  const assumedTagType = (tags[0] && tags[0].type) || 'none'

  function isSelectedTag(id) {
    if (!json) return false
    for (var i = 0; i < json.tags.length; i++) {
      if (json.tags[i] && json.tags[i].id == id) return true
    }
    return false
  }

  function createTagButton(tag) {
    var name = tag.name
    var id = tag.id

    function onClick() {
      if (button.attr('disabled')) return
      button.toggleClass('selected')

      if (tag.type === 'foodType') {
        tagSelection.find('*').removeClass('selected')
        button.addClass('selected')

        if (use.env.allowImages) {
          tagSelection.closest('.modalPopupSection').removeClass('disable-image-input')
        } else {
          // Should hide image URL uploader
          tagSelection.closest('.modalPopupSection').addClass('disable-image-input')
        }

        if (button.attr('tagtype') === 'foodType') {
          button.parent().trigger('collapse')
        }
      }

      $('.inputBlock-collapse-tags').each(function (key, el) {
        var tags = []
        $(el)
          .find('.tag-button.selected .tag-button-text')
          .each(function (key, selectedTextLabel) {
            tags.push($(selectedTextLabel).text())
          })

        var summaryEl = $(el).find('.inputBlock-label-summary')
        var summaryText = tags.join(', ')

        if (!summaryText) {
          summaryText = placeholder
        }

        summaryEl.text(summaryText)
      })

      makeDisabledTags()

      button.trigger('tagButtonStateChanged')
    }

    var button = $('<div>')
      .addClass('tag-button')
      .attr('tagId', id)
      .attr('tagType', tag.type)
      .attr('id', 'tag-button-' + id)

    button.click(onClick)

    if (tag.iconUrl)
      button.append(
        $('<img>')
          .attr('src', tag.iconUrl)
          .addClass('tag-button-icon')
      )
    button.append(
      $('<span>')
        .text(name)
        .addClass('tag-button-text')
    )

    if (isSelectedTag(id)) {
      setTimeout(function () {
        button.click()
      }, 10)
    }
    return button
  }

  var tagSelection = $('<div>').addClass('tag-selection')
  if (additionalClass) {
    tagSelection.addClass(additionalClass)
  }

  const orderedTags = [].concat(tags)

  // Only certain types need sorting; food type tags should not be sorted by name since there
  // are only few of them, and neither should dietary tags; those even come with some extra
  // stuff like '<div class="spacer">' between tag objects, so don't even try
  if (assumedTagType === 'protein' || assumedTagType === 'location' || assumedTagType === 'other') {
    orderedTags.sort((t1, t2) => {
      return t1.name < t2.name ? -1 : t1.name > t2.name ? 1 : 0
    })
  }

  for (var i in tags) {
    var fit = tags[i]
    if (typeof fit === 'string') {
      tagSelection.append(fit)
    } else {
      tagSelection.append(createTagButton(fit))
    }
  }
  tagSelection.data('placeholder')
  return tagSelection
}

function makeDisabledTags() {
  $('.tag-button, .tag-button .textCheckbox')
    .removeAttr('disabled')
    .removeAttr('title')
    .removeAttr('disableReason')

  function addDisabler(disabler, disableList, implicit) {
    for (var i = 0; i < disableList.length; i++) {
      var disabled = disableList[i]
      var buttonIsSelected = $('#tag-button-' + disabler + '.selected').size() === 1
      if (buttonIsSelected) {
        var text =
          implicit === 'implicit'
            ? window.formatText(
              lang.p.dialog.tags.implicit,
              window.tags[disabled].name,
              window.tags[disabler].name
            )
            : window.formatText(lang.p.dialog.tags.explicit, window.tags[disabler].name)

        var buttonToDisable = $('#tag-button-' + disableList[i])
        buttonToDisable
          .attr('disabled', 'disabled')
          .attr('disableReason', disabler)
          .attr('title', text)
        if (implicit === 'implicit') {
          buttonToDisable.addClass('pseudo-selected-for-' + disabler)
        }
      } else {
        if (implicit === 'implicit') {
          $('#tag-button-' + disableList[i]).removeClass(
            'pseudo-selected-for-' + disabler
          )
        }
      }
    }
  }

  // lactose-free implies low-lactose
  addDisabler('lactose-free', ['low-lactose'], 'implicit')

  // milk-free implies lactose-free, which implies low-lactose
  addDisabler('milk-free', ['lactose-free', 'low-lactose'], 'implicit')

  // vegetarian implies all of the above
  addDisabler('vegetarian', ['lacto-ovo', 'milk-free', 'lactose-free', 'low-lactose'], 'implicit')

  // vegetarian disables meat types
  addDisabler('vegetarian', [
    'beef',
    'pork',
    'dairy',
    'game',
    'chicken',
    'fish',
    'seafood',
    'duck',
    'lamb',
  ])

  // lacto-ovo-vegetarian disables meat types, too (but not dairy)
  addDisabler('lacto-ovo', ['beef', 'pork', 'game', 'chicken', 'fish', 'seafood', 'duck', 'lamb'])

  $('.tag-button[disableReason]').click(function () {
    var reasonButton = $('#tag-button-' + $(this).attr('disableReason'))
    reasonButton
      .stop(true, true)
      .animate({opacity: 0.2}, 'fast')
      .animate({opacity: 1}, 'fast')
  })
}

// My guess is that fake input block means the clickable element that can be expanded to actual
// input block. Mia & Marko
function createFakeInputBlock(options) {
  var fakeInputBlock = window.createInputBlock({
    label: options.title,
    type: 'empty',
    collapse: true,
    helpText: options.helpText,
    optional: !!options.optional,
    required: !!options.required,
    disabled: !!options.disabled,
  })

  fakeInputBlock.addClass('inputBlock-collapse-tags')

  if (options.tabIndex) {
    var fakeAnchor = $('<a href="#"></a>').attr('tabindex', options.tabIndex)
    fakeInputBlock.append(fakeAnchor)
    fakeAnchor.click(function (e) {
      e.preventDefault
    })
    fakeAnchor.on('focus', function () {
      console.log('section focused.')
      if (!fakeInputBlock.hasClass('expanded')) {
        fakeInputBlock.trigger('expand')
      }
    })
  }

  return fakeInputBlock
}

function addOneTagSelection(text, type, customClass, itemTabIndex, tabIndex, json) {
  var tIndex

  if (text) {
    var subtitle = $('<div>')
      .text(text)
      .addClass('tag-selection-subtitle')
    //dlg.add(subtitle);
  }

  if (itemTabIndex && itemTabIndex > tabIndex) {
    tIndex = itemTabIndex
  } else {
    tIndex = tabIndex
  }

  var selection = createCustomTagSelection(json, type, null, tIndex)

  if (customClass) {
    selection.addClass(customClass)
    if (subtitle) subtitle.addClass(customClass)
  }
  return selection
}

function addImageSelectorToDialog(dlg, json = null, disabled = false) {
  let result

  if (use.env.DEV_ENV) {
    // TODO real image uploader widget
    result = dlg.addInput({
      type: 'text',
      name: 'imageUrl',
      label: '(DEV) imageUrl',
      placeholder: 'You can edit url here but not upload yet',
      value: json ? json.imageUrl : '',
      helpText: '',
      size: 'auto',
      collapse: true,
      tabIndex: 0,
      optional: true,
      disabled,
    }).addClass('input-image-url')
    dlg.add(
      $('<div>')
        .addClass('spacer')
        .addClass('input-image-url')
    )

    setupImageUrlVisibility(dlg)
  }

  return result
}

function addTagSelectionToDialogPart1(dlg, json, tabIndex, disabled) {
  var foodTypeBlock = createFakeInputBlock({
    title: lang.p.dialog.tags.type,
    classNames: 'inputBlock-collapse-tags',
    tabIndex: tabIndex + 100,
    required: true,
    disabled,
  })

  foodTypeBlock
    .find('.inputBlockContent')
    .append(addOneTagSelection(null, 'foodType', 'tag-selection-food-type', undefined, tabIndex, json))

  dlg.add(foodTypeBlock)

  dlg.add($('<div>').addClass('spacer'))
}

function addTagSelectionToDialogPart2(dlg, json, tabIndex, disabled) {
  var dietBlock = createFakeInputBlock({
    title: lang.p.dialog.tags.dietaryFit,
    classNames: 'inputBlock-collapse-tags',
    helpText: lang.p.dialog.tags.dietaryFitHelpText,
    tabIndex: tabIndex + 200,
    optional: true,
    disabled,
  })

  dietBlock
    .find('.inputBlockContent')
    .append(
      createTagSelection(
        json,
        [
          window.tags['vegetarian'],
          window.tags['lacto-ovo'],
          '<div class="spacer" />',
          window.tags['milk-free'],
          window.tags['lactose-free'],
          window.tags['low-lactose'],
          '<div class="spacer" />',
          window.tags['gluten-free'],
          '<div class="spacer" />',
          window.tags['halal'],
        ],
        'tag-selection-diet',
        lang.p.dialog.inputBlockLabel.none,
        tabIndex + 200
      )
    )

  dlg.add(dietBlock)

  var tagsProteinBlock = createFakeInputBlock({
    title: lang.p.dialog.tags.protein,
    classNames: 'inputBlock-collapse-tags',
    helpText: lang.p.dialog.tags.proteinHelpText,
    tabIndex: tabIndex + 300,
    optional: true,
    disabled,
  })
  tagsProteinBlock
    .find('.inputBlockContent')
    .append(addOneTagSelection(lang.p.dialog.tags.protein, 'protein', 'tag-selection-protein', undefined, tabIndex, json))

  var tagsLocationBlock = createFakeInputBlock({
    title: lang.p.dialog.tags.cuisine,
    classNames: 'inputBlock-collapse-tags',
    helpText: lang.p.dialog.tags.cuisineHelpText,
    tabIndex: tabIndex + 400,
    optional: true,
    disabled,
  })
  tagsLocationBlock
    .find('.inputBlockContent')
    .append(addOneTagSelection(lang.p.dialog.tags.cuisine, 'location', 'tag-selection-cuisine', undefined, tabIndex, json))

  var tagsOthersBlock = createFakeInputBlock({
    title: lang.p.dialog.tags.other,
    classNames: 'inputBlock-collapse-tags',
    helpText: lang.p.dialog.tags.otherHelpText,
    tabIndex: tabIndex + 500,
    optional: true,
    disabled,
  })
  tagsOthersBlock
    .find('.inputBlockContent')
    .append(addOneTagSelection(lang.p.dialog.tags.other, 'other', 'tag-selection-other', undefined, tabIndex, json))

  dlg.add(tagsProteinBlock)
  dlg.add(tagsLocationBlock)
  dlg.add(tagsOthersBlock)

  // set some foodType active if it isn't already
  setTimeout(function () {
    if ($(".tag-button[tagType='foodType'].selected").size() != 1) {
      $(".tag-button[tagType='foodType'].selected").removeClass('selected')

      var tagName =
        use.profile.defaultOfferType || 'meal'

      $('#tag-button-' + tagName).addClass('selected')

      // The foodType tag selector does not display its text appropriately when it is created.
      // This fixes that in bug in a particularly nasty hacky way. Luckily this piece of code
      // will hopefully be discarded soon. --A 2019-03-12
      const text = $(".tag-button[tagType='foodType'].selected .tag-button-text").text()
      const $tagButtonParentEl = $(".tag-button[tagType='foodType']").parent().parent().parent()
      $tagButtonParentEl.find('.inputBlock-label-summary').text(text)
    }
  }, 200)
}

function sortAndFilterFoodTypeTagSelection(tags) {
  var result = window.sortBy(tags, 'orderIndex')

  var defaultOfferType = use.profile.defaultOfferType

  if (defaultOfferType) {
    if (defaultOfferType === 'events') {
      result = result.filter(function (tag) {
        return tag.id === 'events'
      })
    } else {
      result = result.filter(function (tag) {
        return tag.id !== 'events'
      })
    }
  }

  return result
}

function createCustomTagSelection(offerJSON, tagType, tagSelection) {
  if (tagSelection) {
    for (let i = 0; i < tagSelection.length; i++) {
      tagSelection[i] = window.tags[tagSelection[i]]
    }
  }
  tagSelection = tagSelection || []

  for (const i in window.tags) {
    if (tagSelection.indexOf(window.tags[i]) >= 0) continue

    if (window.tags[i].type == tagType) tagSelection.push(window.tags[i])
  }

  if (tagType === 'foodType') {
    tagSelection = sortAndFilterFoodTypeTagSelection(tagSelection)
  }
  return createTagSelection(offerJSON, tagSelection)
}

// Resolve if we should continue (.then)
// Rejects if we should go back (.fail)
function showPriceHighWarning(price, tags) {
  // if surplusPriceWarningLimit is not defined for this country, no warning is shown
  if (price >= use.profile.country.surplusPriceWarningLimit
    && !tags.includes('nonsurplus')
    && !tags.includes('ingredients')
    && !tags.includes('grocery-bag')) {
    return window.showLightPopup(
      lang.offers.dialog.surplusPriceWarning.text,
      [
        {
          label: lang.offers.dialog.surplusPriceWarning.goBack,
          action: 'dismiss',
        },
        {
          label: lang.offers.dialog.surplusPriceWarning.publish,
          action: 'continue',
        },
      ],
      {doNotShowAgainId: 'high-offer-price'}
    )
  } else {
    return $.Deferred().resolve()
  }
}

function showRestrictedEditingWarning(offer) {
  const editingIsLimited = offer.ordered > 0 && !use.env.admin

  // offers.summary.onlyAllowsLimitedEditing.title
  // offers.summary.onlyAllowsLimitedEditing.text
  if (editingIsLimited) {
    return window.showLightPopup(lang.offers.summary.onlyAllowsLimitedEditing.text, [
      {
        label: lang.common.goBack,
        action: 'dismiss'
      },
      {
        label: lang.common.continue,
        action: 'continue'
      },
    ], {
      title: lang.offers.summary.onlyAllowsLimitedEditing.title
    })
  } else {
    return $.Deferred().resolve()
  }
}

// Show an error if device and venue timezones are different
function showTimezoneWarning() {
  // In provider data we have timezoneOffsetInMinutes as returned by moment.js based on venue timezone (e.g. Helsinki -> 120)
  // Date().getTimezoneOffset() returns a "reverse offset" so we have to switch the sign here.
  // Both offsets account for dst.
  const deviceTimezoneOffset = -(new Date().getTimezoneOffset())
  const timezonesAreDifferent = use.profile.timezoneOffsetInMinutes !== deviceTimezoneOffset
  if (timezonesAreDifferent) {
    const deviceTimezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone
    const text = lang.warning.wrongTimezone.text
      .replace("[deviceTimezone]", deviceTimezoneName)
      .replace("[venueTimezone]", use.profile.timezone)
      .replace("[venueTimezone]", use.profile.timezone)
    return window.showLightPopup(text, [
      {
        label: lang.common.goBack,
        action: 'dismiss'
      },
      {
        label: lang.warning.wrongTimezone.action.continueAnyway,
        action: 'continue'
      },
    ], {
      title: lang.warning.wrongTimezone.title,
      doNotShowAgainId: 'timezone-warning'
    })
  } else {
    return $.Deferred().resolve()
  }
}
; /* START FILE provider/js/modalDialogProviderChangePassword.js */ 
function openProviderChangePasswordDialog(username)
{
	var dlg = new window.ModalDialog(lang.p.dialog.changePassword.title, { width: '600px' })

	var placeholder = ''
	for (var i = 0; i < use.env.PASSWORD_MIN_LENGTH; i++) {
		placeholder += '*'
	}

	dlg.addInputOld('oldPassword', lang.p.dialog.changePassword.oldPassword, placeholder, 'password', '')
	var new1 = dlg.addInputOld('newPassword', lang.p.dialog.changePassword.newPassword, placeholder, 'password', '')
	var new2 = dlg.addInputOld('newPassword2', lang.p.dialog.changePassword.newPassword2, placeholder, 'password', '')

	dlg.addButton(lang.p.dialog.changePassword.submit, function(data) {

		if (new1() !== new2()) {
			alert(lang.p.dialog.changePassword.badlyTyped)
			dlg.enableAllAgain()
			return
		}

		if (!(data.oldPassword && data.newPassword && data.newPassword2)) {
			dlg.enableAllAgain()
			return
		}

		window.postRequest('provider/editProvider', data).done(function() {

			alert(lang.p.dialog.changePassword.submitted)
			dlg.hide()

			if (!username) return

			var data2 = {
				username: username,
				password: new1(),
			}

      window.postRequest('provider/login', data2).done(function(results) {
        results = JSON.parse(results)
        window.store.set('providerToken', results.providerToken)
      }).fail(window.dialogFailResponse)

		}).fail(window.dialogFailResponse)

	}, 'basicConfirmButton')
	dlg.show()
}

; /* START FILE provider/js/modalDialogTagProposer.js */ 
function openTagProposerDialog(offerTemplate, callback) {
    if (use.profile.enforceSharedTemplates
		|| use.profile.id !== offerTemplate.providerId) {
        // Provider with enforceSharedTemplates can not edit templates or create offers from
        // scratch. Tag proposer should not suggest tags for these.
        // Also don't propose tags for templates you don't own (shared from enterprise level).
        callback && callback()
        return
    }
    let providerSkippedTagProposalsForTemplates = window.store.get('providerSkippedTagProposalsForTemplates')
    if (providerSkippedTagProposalsForTemplates) {
        try {
            providerSkippedTagProposalsForTemplates = JSON.parse(providerSkippedTagProposalsForTemplates)
            if (providerSkippedTagProposalsForTemplates.includes(offerTemplate.id)) {
                callback && callback()
                return // no need to hide
            }
        } catch (e) {
            console.log('tag suggestion open fail', e)
        }
    }

    const originalTags = {}
    if (offerTemplate.tags) {
        offerTemplate.tags.forEach(tag => {
            originalTags[tag.id] = true
        })
    }

    const suggestions = window.parseTags(offerTemplate.name + ' ' + offerTemplate.description, use.profile.country.languages)
    const cleanedSuggestions = window.cleanTagConflicts(suggestions)
    const missingTag = cleanedSuggestions.find(tagId => !originalTags[tagId])

    if (!missingTag) {
        // No more tags to suggest. All good!
        callback && callback()
        return // no need to hide
    }


    const currentTags = Object.assign({}, originalTags)

    var dlg = new window.ModalDialog(lang.p.tagProposerPopup.title, { width: '600px' })

    dlg.add(
        $('<div>').addClass('tagProposerDialog-explanation')
            .text('We noticed that there are some tags that could be added to this offer. If the tags look correct, click "Add and continue".')
    )

    const offerCard = $('<div>').addClass('tagProposerDialog-offerCard')
    offerCard.append(
        $('<div>').addClass('tagProposerDialog-offerName').text(offerTemplate.name),
        $('<div>').addClass('tagProposerDialog-offerDescription').text(offerTemplate.description)
    )

    dlg.add(offerCard)

    function addTag(tagId, isAdded) {
        if (isAdded)
            currentTags[tagId] = true
        else
            delete currentTags[tagId]
    }

    function checker(tagId) {
        return !!currentTags[tagId]
    }

    var tagProposer = new window.TagProposer(addTag, checker, true, 'before create offer dialog')

    tagProposer.el.classList.add('tagProposerDialog-tagProposer')

    dlg.add(tagProposer.el)

    function updateWithDelay() {
        tagProposer.updateWithDelay(offerTemplate.name + ' ' + offerTemplate.description)
    }

    setTimeout(updateWithDelay, 100)

    function dontAskAgainAboutThisTemplate() {
        try {
            let providerSkippedTagProposalsForTemplates = window.store.get('providerSkippedTagProposalsForTemplates')
            if (providerSkippedTagProposalsForTemplates)
                providerSkippedTagProposalsForTemplates = JSON.parse(providerSkippedTagProposalsForTemplates)
            else
                providerSkippedTagProposalsForTemplates = []
            providerSkippedTagProposalsForTemplates.push(offerTemplate.id)
            window.store.set('providerSkippedTagProposalsForTemplates', JSON.stringify(providerSkippedTagProposalsForTemplates))
        } catch (e) {
            console.log('tag suggestion confirm fail', e)
        }
    }

    dlg.addButton(lang.p.tagProposerPopup.skip, function (data) {
        callback && callback()
        dlg.hide()
        dontAskAgainAboutThisTemplate()
    }, 'modalDialogGrayButton')

    dlg.addButton(lang.p.tagProposerPopup.addAndContinue, function (data) {
        const originalKeys = Object.keys(originalTags)
        const currentKeys = Object.keys(currentTags)
        const unionKeys = [...new Set(originalKeys.concat(currentKeys))]
        const changesExist = originalKeys.length !== currentKeys.length || originalKeys.length !== unionKeys.length
        const proposedKeys = tagProposer.list.views.map(view => view.tagId)
        const allAdded = !proposedKeys.find(key => !currentTags[key])

        if (!allAdded) {
            dontAskAgainAboutThisTemplate()
        }

        if (changesExist) {
            const editData = {
                tags: currentKeys
            }

            window.postRequest('provider/offerTemplate/' + offerTemplate.id, editData).done(function (res) {
                const newOfferTemplate = res.offerTemplate

                // override the existing offerTemplate
                Object.assign(offerTemplate, newOfferTemplate)

                callback && callback()
            })
        } else {
            callback && callback()
        }
        dlg.hide()
    }, 'basicConfirmButton')
    dlg.show()
}
; /* START FILE provider/js/view/tabView.js */ 


var updateCurrentView = function() {}
if (!window.updateDevTools) window.updateDevTools = function() {}
; /* START FILE provider/js/view/offerView.js */ function createOfferView(createdCallback) {
    var content = window.clearViewContent();

    updateInfoText();

    var headerContainer = $('<div>').addClass('header-container');
    var actionContainer = $('<div>').addClass('action-container');

    var primaryAction = $('<div>').addClass('offersView-primaryActionWrapper');

    setTimeout(() => {
        const button = new window.Vue({
            render: (h) =>
                h(
                    // TODO make button look disabled
                    window.NewButton,
                    {
                        on: {
                            click() {
                                window.showTimezoneWarning().then(function () {
                                    wait.profile.then((profile) => {
                                        if (profile.restricted) {
                                            alert(lang.p.offers.newOfferRestricted);
                                            return;
                                        }

                                        window.openCreateOfferFromTemplatePopup(() => {
                                            // make button visible
                                            primaryAction.css('visibility', 'visible');
                                        });
                                        // hide button
                                        primaryAction.css('visibility', 'hidden');
                                    });
                                });
                            },
                        },
                    },
                    lang.p.offers.button.newOffer
                ),
        }).$mount();
        primaryAction.append(button.$el);
    });

    // text.appendTo(headerContainer)
    primaryAction.appendTo(actionContainer);
    actionContainer.appendTo(headerContainer);
    headerContainer.appendTo(content);

    var activeOffersHeader = window.createTableHeader(lang.p.offers.activeOffersTitle);
    content.append(activeOffersHeader);

    var activeOffersTable = new window.Table();
    activeOffersTable.addSmallHeader(lang.p.tab.offers);
    activeOffersTable.addPrimaryColumn(lang.p.offers.table.foodName, 200, 500);
    var priceHeaderCell = activeOffersTable.addColumn(lang.p.offers.table.price, 200);
    activeOffersTable.addColumn(lang.p.offers.table.availableUntil, 160);
    activeOffersTable.addColumn(lang.p.offers.table.sold, 90);
    activeOffersTable.addButtonColumn(lang.p.offers.table.edit, 90);
    activeOffersTable.addButtonColumn(lang.p.offers.table.halt, 80);
    activeOffersTable.addPopoverColumn();
    content.append(activeOffersTable.getElement().addClass('offerTable'));
    activeOffersTable.getElement().hide();
    activeOffersHeader.hide();

    priceHeaderCell.addClass('priceHeaderCell');

    var upcomingOffersHeader = window.createTableHeader(lang.p.offers.upcomingOffersTitle);
    content.append(upcomingOffersHeader);

    var upcomingOffersTable = new window.Table();
    upcomingOffersTable.addSmallHeader(lang.p.tab.offers);
    upcomingOffersTable.addPrimaryColumn(lang.p.offers.table.foodName, 200, 500);
    upcomingOffersTable.addColumn(lang.p.offers.table.publishDate, 250);
    upcomingOffersTable.addColumn(lang.p.offers.table.portions, 90);
    upcomingOffersTable.addButtonColumn(lang.p.offers.table.edit, 90);
    upcomingOffersTable.addButtonColumn(lang.p.offers.table.halt, 80);
    upcomingOffersTable.addPopoverColumn();
    content.append(upcomingOffersTable.getElement().addClass('offerTable'));
    upcomingOffersTable.getElement().hide();
    upcomingOffersHeader.hide();

    // Shown if there are no offers or offers can't be made
    const placeholderText = $('<div class="placeholderText">').text(lang.p.offers.table.fetching);
    content.append(placeholderText);

    function createUpcomingOfferRow(json) {
        var name = json.name || '-';
        //name += formatText(lang.p.offers.table.publishTime, );
        var formatRelativeDateTime = function (date) {
            var publishTime = date.toTimeString().substring(0, 5);

            if (date.getDate() == new Date().getDate() + 1) {
                return lang.p.dialog.orderpickuptimes.tomorrow + ' ' + publishTime;
            } else if (date.getDate() == new Date().getDate()) {
                return lang.p.dialog.orderpickuptimes.today + ' ' + publishTime;
            }
            return window.formatDate(date) + ' ' + publishTime;
        };

        // For some reason this uses tagIds, not tags like templateView. What now?
        const isNonsurplus = json.tagIds && json.tagIds.includes('nonsurplus');

        const nameCell = window.getOfferNameElement(name, isNonsurplus);

        var tr = upcomingOffersTable.addRow(
            nameCell,
            formatRelativeDateTime(new Date(json.orderStart)),
            json.originalQuantity,
            window.createIconButton('img/edit_symbol.png', function () {
                window.openEditOfferDialog(json);
            }),

            window.createIconButton('img/halt_symbol.png', function () {
                deleteOffer(json);
            }),
            createOfferPopover(json)
        );

        tr.data('id', json.id);
    }

    function createOfferRow(json) {
        var selectedTable = activeOffersTable;

        var name = json.name || '-';
        var ordered = json.ordered || 0;

        const editButton = window.createIconButton('img/edit_symbol.png', function () {
            window.openEditOfferDialog(json);
        });

        const haltButton = window.createIconButton('img/halt_symbol.png', function () {
            deleteOffer(json);
        });

        if (!json.active) {
            editButton.attr('disabled', true);
            editButton.addClass('disabled');

            haltButton.attr('disabled', true);
            haltButton.addClass('disabled');
        }

        const originalPriceFormatted = window.formatCurrency(
            ~~json.price,
            use.profile.country.currency,
            true
        );
        const dynamicPriceFormatted = window.formatCurrency(
            ~~json.dynamicPrice,
            use.profile.country.currency,
            true
        );
        const hasPriceChangedDynamic = json.dynamicPrice !== json.price;

        const isNonsurplus = json.tagIds && json.tagIds.includes('nonsurplus');

        const priceCell = $('<span/>').addClass('priceCell');

        if (isNonsurplus) {
            priceCell.addClass('priceCell-nonsurplus');
        }

        if (hasPriceChangedDynamic) {
            const originalPrice = $('<span/>')
                .addClass('loweredPrice')
                .text(originalPriceFormatted);
            priceCell.append(originalPrice);
        }

        if (json.isDynamicallyPriced) {
            var dpIcon = $('<img/>');
            dpIcon.addClass('dynamicPricing');
            dpIcon.attr('src', 'img/icon-smart-price-descending-white.svg');
            dpIcon.appendTo(priceCell);
        }

        priceCell.append($('<span/>').text(dynamicPriceFormatted));

        const nameCell = window.getOfferNameElement(name, isNonsurplus);

        var tr = selectedTable.addRow(
            nameCell,
            priceCell,
            new Date(json.orderEnd).toTimeString().substring(0, 5),
            ordered + ' / ' + json.originalQuantity,

            window.createIconButton('img/edit_symbol.png', function () {
                window.showTimezoneWarning().then(function () {
                    window.showRestrictedEditingWarning(json).then(function () {
                        window.openEditOfferDialog(json);
                    });
                });
            }),

            window.createIconButton('img/halt_symbol.png', function () {
                deleteOffer(json);
            }),
            createOfferPopover(json)
        );

        if (!json.active) {
            tr.addClass('disabled');
        }

        tr.data('id', json.id);
        tr.attr('oid', json.id);
    }

    function updateInfoText() {
        window.setInfoText('', '', null, null, lang.p.tab.allOffers, false);
    }

    function refresh(offers) {
        wait.profile.then((profile) => {
            wait.env.then((env) => refreshWithEnvAndProfile(env, profile, offers));
        });
    }

    // Apparently this function at least
    // - shows / hides "Upcoming offers" table"
    // - probably also updates their contents
    function refreshWithEnvAndProfile(env, profile, offers) {
        if (!activeOffersTable.isInDOM()) {
            return;
        }

        if (!offers) {
            return;
        }

        // Deep copy so that we can be sure that state.offers will not be edited.
        offers = JSON.parse(JSON.stringify(offers));

        activeOffersTable.setEmptyText(lang.p.offers.table.fetching);

        var offersBasedOnStatus = {
            active: [],
            upcoming: [],
        };

        activeOffersTable.removeRows();
        upcomingOffersTable.removeRows();

        // sort offers by orderStart
        if (offers && offers.length) {
            offers.sort(function (a, b) {
                return new Date(a.orderStart) > new Date(b.orderStart);
            });
        }

        for (var i = 0; i < offers.length; i++) {
            if (offers[i].published) {
                offersBasedOnStatus.active.push(offers[i]);
                createOfferRow(offers[i]);
            } else {
                offersBasedOnStatus.upcoming.push(offers[i]);
                createUpcomingOfferRow(offers[i]);
            }
        }

        const showActiveOffers = offersBasedOnStatus.active.length > 0;
        const showUpcomingOffersTable = offersBasedOnStatus.upcoming.length > 0;
        const showPlaceholderText = !(showActiveOffers || showUpcomingOffersTable);

        let placeholderTextContent = lang.offers.noOffers.noActiveOffers;

        if (profile.restricted) {
            placeholderTextContent =
                profile.restrictionType === 'newPartner'
                    ? lang.offers.noOffers.waitingForActivation
                    : lang.offers.noOffers.postingOffersSuspended;
        }

        if (showActiveOffers) {
            activeOffersTable.getElement().show();
            activeOffersHeader.show();
        } else {
            activeOffersTable.getElement().hide();
            activeOffersHeader.hide();
        }

        if (showUpcomingOffersTable) {
            upcomingOffersTable.getElement().show();
            upcomingOffersHeader.show();
        } else {
            upcomingOffersTable.getElement().hide();
            upcomingOffersHeader.hide();
        }

        if (showPlaceholderText) {
            placeholderText.show();
            placeholderText.text(placeholderTextContent);
        } else {
            placeholderText.hide();
        }

        updateInfoText();

        activeOffersTable.setDataReady(true);
        upcomingOffersTable.setDataReady(true);
        if (typeof createdCallback === 'function') {
            createdCallback();
        }
    }

    window.offersStream.forEach(function listener(offers) {
        if (!activeOffersTable.isInDOM()) {
            window.offersStream.removeListener(listener);
            return;
        }

        refresh(offers);
    });
}

function deleteOffer(json) {
    if (window.escapedConfirm(window.formatText(lang.p.offers.delete.confirm, json.name))) {
        window.postRequest('provider/deleteOffer/' + json.id).done(function () {
            window.createRowBlinker(json.id, window.updateCurrentView, '#a92c39', 1)();
            var text = window.formatText(
                lang.p.offers.toast.delete.success,
                '<strong>' + json.name + '</strong>'
            );
            window.createToast(text);
        });
    }
}

function createOfferPopover(json) {
    var formatTimeDisplay = function (date) {
        if (date) {
            return window.dateToString(new Date(date), true);
        }
    };

    var el = $('<div>').addClass('popover-inner');

    if (json && json.orderEnd && json.orderStart) {
        $(
            '<div><span>' +
                lang.p.dialog.orderpickuptimes.order +
                ':</span> <span>' +
                formatTimeDisplay(json.orderStart) +
                ' - ' +
                formatTimeDisplay(json.orderEnd) +
                '</span></div>'
        ).appendTo(el);
    }

    if (json && json.fetchEnd && json.fetchStart) {
        $(
            '<div><span>' +
                lang.p.dialog.orderpickuptimes.pickup +
                ':</span> <span>' +
                formatTimeDisplay(json.fetchStart) +
                ' - ' +
                formatTimeDisplay(json.fetchEnd) +
                '</span></div>'
        ).appendTo(el);
    }

    var description = (json && json.description) || '';

    if (description) {
        $(
            '<div><span>' +
                lang.p.dialog.editOffer.form.description.label +
                ':</span> <span>' +
                description +
                '</span></div>'
        ).appendTo(el);
    }

    const link = `https://app.resq-club.com/offer/${json.id}`;

    $(
        '<div><span>' +
            lang.p.offers.table.offerLink +
            `:</span> <a href="${link}" target="_blank">` +
            link +
            '</a></div>'
    ).appendTo(el);

    return el;
}
; /* START FILE provider/js/view/myInfoView.js */ function createMyInfoView() {
    var content = window.clearViewContent()

    window.setInfoText('', lang.p.myInfo.loading, null, null, lang.p.tab.myInfo, true)

    window.updateMyInfo(function() {
        var realContent = window.clearViewContent()
        var content = $('<div>').addClass('flex-center').appendTo(realContent)

        window.setInfoText('', lang.p.myInfo.helpText2, null, null, lang.p.tab.myInfo, true)

        var json = use.profile
        //openEditMyInfoDialog(response.myInfo);

        var dlg = new window.ModalDialog(null, { width: '720px', popup: false, saveOnlyEdited: true, preventLeaveOnChanges: true, hideTitle: true })

        dlg.addInputOld('name', lang.p.myInfo.form.name.label, '', 'text', json.name)

        /*dlg.addInput({
			type: 'text',
			name: 'name',
			label: lang.p.myInfo.form.name.label,
			placeholder: lang.p.myInfo.form.name.placeholder,
			value: json.name,
			size: 'auto',
			collapse: true
		})
		*/

        dlg.addInputOld('description', lang.p.myInfo.form.description.label, lang.p.myInfo.form.description.placeholder, 'textarea', json.description)

        dlg.addClear()

        dlg.addInputOld('publicPhoneNumber', lang.p.myInfo.form.publicPhoneNumber.label,
            '+' + use.profile.country.countryCode + '...', 'text', json.publicPhoneNumber, 'left',
            '49%')

        dlg.addInputOld('website', lang.p.myInfo.form.website.label, lang.p.myInfo.form.website.placeholder, 'text', json.website, 'right', '49%')

        const addressInput = dlg.addInputOld('address', lang.p.myInfo.form.address.label, lang.p.myInfo.form.address.placeholder, 'text', json.address, 'left', '49%')

        const searchLocationButton = $(`<button class="basicButton" style="margin-top: 15px;">`).text(
            lang.p.myInfo.form.useAddressToUpdateLocation
        )
        let postalCode = json.postalCode

        searchLocationButton.on('click', () => {
            const address = addressInput.input.val()
            if (!address) {
                return
            }

            const city = use.profile.locationCity

            mapLocationSelector.search(`${address} ${city}`, (result => {
              const [postCodeComponent] = result.address_components.find(item => item.types.includes('postal_code'))
              if (postCodeComponent)
                postalCode = postCodeComponent.long_name
            }))
        })

        addressInput.input.change(() => {
            const newAddress = addressInput.input.val()
            searchLocationButton.prop('disabled', !newAddress)
        })

        dlg.add(searchLocationButton)

        dlg.addClear()

        let latitude = json.latitude
        let longitude = json.longitude

        const locationText = lang.p.myInfo.form.location.label
        const mapContainer = $(
            `<div class="inputBlock">
				<div class="inputBlockTitle" id="inputTitle_address">${locationText}</div>
			</div>`
        )

        dlg.add(mapContainer)

        const mapLocationSelector = new window.MapLocationSelector({
            latitude: json.latitude,
            longitude: json.longitude,
            centerChanged: (lat, lng) => {
                // log('Location', { lat, lng })
                latitude = lat
                longitude = lng
            },
            context: 'provider'
        })

        mapContainer.append(mapLocationSelector.el)

        dlg.addClear()
        dlg.addHorizontalLine()
        var orderTimeContainer = $('<div>').addClass('container')
        orderTimeContainer.css({
            margin: 20
        })
        orderTimeContainer.append($('<h3>'+ lang.settings.myInfo.fetchTimes.title +'</h3>').css({}))
        orderTimeContainer.append($('<p><span class="icon icon-info"></span> '+ lang.settings.myInfo.fetchTimes.info +'</p>').css({fontSize: 14}))

        dlg.add(orderTimeContainer)


        const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

        const values = days.map(day => ({
            fetchStart: window.stringToDate(json[day + 'FetchStart']),
            fetchEnd: window.stringToDate(json[day + 'FetchEnd']),
        }))

        const limits = {
            serviceEnd: new window.OfferTime().setTime('04:00'),
            serviceStart: new window.OfferTime().setTime('06:00')
        }

        const DLDaysTable = createDLDaysTable({
            days: days,
            values: values,
            callback: function(input) {
                var name = input.attr('name')

                var inputOfferTime = new window.OfferTime().setTime(input.val())
                //check if current change is legal


                if (inputOfferTime.getValue() > limits.serviceEnd.getValue()) {
                    input.val(limits.serviceEnd.getTime())
                } else if (new window.OfferTime().setTime(input.val()).getValue() < limits.serviceStart.getValue()) {
                    input.val(limits.serviceStart.val())
                }

                if (name.substr(3) === 'FetchStart') {
                    const neighbor = input.parent().parent().find('input:first')
                    if (new window.OfferTime().setTime(neighbor.val()).getValue() > inputOfferTime.getValue()) {
                        neighbor.val(inputOfferTime.getTime())
                    }

                } else if (name.substr(3) === 'FetchEnd') {
                    const neighbor = input.parent().parent().find('input:last')
                    if (new window.OfferTime().setTime(neighbor.val()).getValue() < inputOfferTime.getValue()) {
                        neighbor.val(inputOfferTime.getTime())

                        setTimeout(function() {
                            neighbor.trigger('change')
                        },0)
                    }
                }
            }
        })

        orderTimeContainer.append(DLDaysTable)

        dlg.addClear()

        const orderEndOffsetInput = createOrderEndOffsetInput(json.defaultOrderEndBeforeFetchEndInMinutes)

        dlg.add($('<div>').append(lang.settings.myInfo.fetchTimes.orderEndText1,
            orderEndOffsetInput,
            lang.settings.myInfo.fetchTimes.orderEndText2))

        dlg.addClear()

        dlg.addButton(
            lang.p.myInfo.form.submit,
            (data) => {
                const hasLocationChanged = latitude !== json.latitude || longitude !== json.longitude || postalCode !== json.postalCode
                const payload = {
                    ...data,
                    ...(hasLocationChanged && { latitude, longitude, postalCode }),
                    defaultOrderEndBeforeFetchEndInMinutes: orderEndOffsetInput.data('value'),
                }

                DLDaysTable
                    .find('.ProviderDLDayRow')
                    .each((key, r) => {
                        const row = $(r)

                        const fetchStartKey = `${days[key]}FetchStart`
                        const fetchEndKey = `${days[key]}FetchEnd`

                        const currentStart = json[fetchStartKey]
                        const currentEnd = json[fetchEndKey]

                        const updatedStart = `${row.find(`input[name=${fetchStartKey}]`).val()}:00`
                        const updatedEnd = `${row.find(`input[name=${fetchEndKey}]`).val()}:00`

                        if (currentStart === updatedStart && currentEnd === updatedEnd) return

                        payload[fetchStartKey] = updatedStart
                        payload[fetchEndKey] = updatedEnd
                    })

                window
                    .postRequest('provider/editProvider', payload)
                    .done(() => {
                        window.showAlert(lang.p.myInfo.form.submitted, ' ')
                        createMyInfoView()
                    })
                    .fail(window.dialogFailResponse)
            },
            'basicConfirmButton'
        )

        dlg.getDialogElement().appendTo(content)

        dlg.savedProviderDLTimeInputs = $('.ProviderDLTimeInput input').toArray().map(function(input) { return $(input).val()}).toString()
    })
}


function createDLDaysTable(options) {
    var el = $('<div/>')
    el.addClass('providerDLRangeTable')

    var icon  = $('<img>').attr('src', '/app/img/Icons_clock.png').addClass('offerDetailsIcon').prop('outerHTML')
    el.append('<div class="providerFetchOrderTimesHeaderRow"><span class="ProviderDLDayRowSpacer"></span><span class="inputBlockTitle">' + icon + ' ' + lang.settings.myInfo.fetchTimes.fetchStart + '</span><span class="inputBlockTitle">' + icon + ' ' +  lang.settings.myInfo.fetchTimes.fetchEnd + '</span></div>')

    for (var i = 0; i < options.days.length ; i++) {
        var row = createDLDayRow({
            day: options['days'][i],
            values: options['values'][i],
            callback: options.callback})
        el.append(row)
    }

    return el
}

function createDLDayRow(options) {
    var el = $('<div></div>')
    el.addClass('ProviderDLDayRow')
    el.addClass('ProviderDLDayRow'+ window.stringCapitalize(options.type))

    var header = $('<div>'+ lang.p.dialog.orderpickuptimes.weekdayLabels[options.day] +'</div>')
    header.addClass('ProviderDLDayRowHeader')
    var fetchStartContainer = window.createDLTimeInput({type: 'FetchStart', parentName: options.day, callback: options.callback, defaultValue: options.values.fetchStart})
    var fetchEndContainer = window.createDLTimeInput({type: 'FetchEnd', parentName: options.day, callback: options.callback, defaultValue: options.values.fetchEnd})

    el.append(header)
    el.append(fetchStartContainer)
    el.append(fetchEndContainer)

    return el
}

function createOrderEndOffsetInput(initialValue) {
    const container = $('<div>').addClass('orderEndOffsetInput ProviderDLTimeInput ProviderInputControls')

    let minutes = initialValue || 0
    const visualization = $('<span>').addClass('orderEndOffsetVisualization')

    function update() {
        visualization.text(minutes + ' min')
        container.data('value', minutes)
    }

    var addButton = window.createDLTimeInputButton({type: 'add', cb: function(values) {
        minutes = Math.min(120, minutes + 15)
        update()
    }})

    var subtractButton = window.createDLTimeInputButton({type: 'subtract', cb: function(values) {
        minutes = Math.max(0, minutes - 15)
        update()
    }})

    update()

    container
        .append(visualization)
        .append(subtractButton)
        .append(addButton)

    return container
}
; /* START FILE provider/js/view/orderView.js */ function isOrderCancelled(order) {
  return order.refundStatus === 'full'
}

function createOrderView(createdCallback) {
  // Temporarily redirect to new web app during rollout of orders page
  if (use.profile.useNewWebApp) {
    window.location.href = `${use.env.NEW_PARTNER_APP_URL_BASE}/${window.getLanguage()}/orders`;
  }

  var content = window.clearViewContent()

  let sortBy = window.store.get('ordersSortBy')
  if (!['name', 'time', 'offer'].includes(sortBy)) {
    sortBy = 'name'
  }

  function setBasicInfoText() {
    window.setInfoText(
      lang.p.orders.helpText1 + ' ',
      lang.p.orders.helpText2,
      null,
      null,
      lang.p.tab.orders,
      false
    )

    // Add a button for switching to new view if the feature is enabled for user
    if (use.profile.showOrdersViewSwitchButton) {
      // Don't create button if it already exists
      if ($('.viewSwitch').length) {
        return;
      }

      let infoHeader = $('#infoTextHeader');

      if(!infoHeader.length) {
        $('.body-wrapper').prepend('<div id="infoTextHeader"></div>');
        infoHeader = $('#infoTextHeader');
      }

      const infoText = $('#infoText');

      infoText.prepend(infoHeader);
      infoHeader.append($('.pageTitleText'))

      infoHeader.append('<button class="viewSwitch">' + lang.p.orders.goToNewView + '</button>').on(
        'click',
        (evt) => {
          window.postRequest(
            'provider/webAppPreference',
            { preference: 'new' }
          ).done(() => window.location.reload());
        }
      );
    }
  }

  setBasicInfoText()

  $('.orderNotification').hide()
  /*
$("#infoText").empty();

var leftText = "Below is a list of orders that have been bought within 24h. <span id='orderRefreshTime'></span><br/><br/>You can mark orders as fetched so you know what orders have been fetched.";
var rightText = "Identify customer!<br/><br/><br/>Ask customer's name when he/she comes fetch the order.";

content.append(createDoubleContainer(leftText, rightText));
*/

  content.append(window.createOrderInstructions())
  content.append(createOrderNotificationSetting())
  var nameInput = createNameInput()
  $('<div class="search-wrapper"></div>')
    .append(nameInput)
    .append(createSortInput())
    .appendTo(content)

  function addOrdersTable(tableVisible = false) {
    const ordersTable = new window.Table()
    ordersTable.addSmallHeader(lang.p.tab.orders)
    ordersTable.addPrimaryColumn(lang.p.orders.table.customerName, 130, 300, -1, 1)
    ordersTable.addPrimaryColumn(lang.p.orders.table.offer, 100, 250, -1)
    ordersTable.addPrimaryColumn(lang.p.orders.table.phone, 100, 140, 2, 1, true)
    ordersTable.addSecondaryColumn(lang.p.orders.table.orderTime, 55)
    const currency = use.profile.country.currency.name
    ordersTable.addSecondaryColumn(currency, 100)
    ordersTable.addButtonColumn('', 180)
    ordersTable.setEmptyText(lang.p.orders.table.fetchingOrders)
    ordersTable.addPopoverColumn()
    if (!tableVisible) {
      ordersTable.getElement().hide()
    }
    ordersTable.getElement().addClass('orders')
    content.append(ordersTable.getElement())

    return ordersTable
  }

  const openOrdersHeader = window.createTableHeader(lang.orders.table.tabs.open)
  content.append(openOrdersHeader)
  openOrdersHeader.hide()

  const openOrdersTable = addOrdersTable(true)

  const closedOrdersHeader = window.createTableHeader(lang.orders.table.tabs.closed)
  content.append(closedOrdersHeader)
  closedOrdersHeader.hide()

  const closedOrdersTable = addOrdersTable()

  const allOrderTables = [openOrdersTable, closedOrdersTable]

  function undoFetchOrder(json) {
    window
      .postRequest('provider/setFetched/' + json.id, {
        fetched: false,
      })
      .done(function () {
        // TODO I couldn't see the toast, could you?
        // createToast('UNDO SUCCESSFUL')
        window.updateCurrentView(window.createRowBlinker(json.id))
      })
  }

  function isOpenOrder(order) {
    return !(order.fetched || isOrderCancelled(order))
  }

  function createOrderRow(json) {
    var date = new Date(json.timestamp)
    var time = date.toTimeString().substring(0, 5)
    var now = new Date()

    // is order from a different day? Then mark it as "old" (i.e. from yesterday)
    var differentDay = now.getDay() !== date.getDay()
    // if it's 0:00 - 05:59 local time, don't mark it as old
    var pastMidnight = 0 <= now.getHours() && now.getHours() <= 5
    // just to be on the safe side (in case of daylight savings and whatnot)
    var isOrderFromFuture = date > now

    var oldOrder = differentDay && !pastMidnight && !isOrderFromFuture

    var fetch
    var cancel

    const setActionButtonDisabledStates = function (disabled) {
      if (disabled) {
        cancel.attr('disabled', 'disabled')
        fetch.attr('disabled', 'disabled')
      } else {
        cancel.removeAttr('disabled')
        fetch.removeAttr('disabled')
      }
    }

    let table

    if (isOpenOrder(json)) {
      table = openOrdersTable
    } else {
      table = closedOrdersTable
    }

    if (json.fetched) {
      fetch = $('<span class="fetched basicListButton">')
        .text(lang.p.orders.table.fetched)
        .attr('disabled', true)

      var gracePeriodEnd = new Date(json.fetchedAt)
      gracePeriodEnd.setMinutes(
        gracePeriodEnd.getMinutes() + use.env.PROVIDER_FETCH_UNDO_AVAILABLE_FOR_MINUTES
      )

      const undoFetchButton = window.createTextButton(lang.common.undo, function (event) {
        event.stopPropagation()
        undoFetchOrder(json)
      })

      undoFetchButton.addClass('undoButton')

      if (Date.now() < gracePeriodEnd) {
        fetch.append('<br>', undoFetchButton)
        undoFetchButton.wrap('<small>')

        const hideButtonAfterMs = gracePeriodEnd.getTime() - Date.now()

        // log('Hiding button after ' + hideButtonAfterMs / 1000 + ' seconds')
        setTimeout(function () {
          undoFetchButton.hide()
        }, hideButtonAfterMs)
      }
    } else if (isOrderCancelled(json)) {
      cancel = $('<button>')
        .addClass('basicListButton secondary')
        .attr('disabled', true)
      cancel.text(lang.p.orders.table.canceled)
    } else {
      fetch = window
        .createBasicButton(lang.p.orders.table.setFetched, function () {
          setActionButtonDisabledStates(true)
          window
            .postRequest('provider/setFetched/' + json.id)
            .done(function () {
              window.updateCurrentView(window.createRowBlinker(json.id))
            })
            .always(() => {
              setActionButtonDisabledStates(false)
            })
        })
        .addClass('basicListButton')

      const notRefundedOrderItems = json.orderItems.filter(oi => !oi.refunded)
      const quantityLeft = _.sumBy(notRefundedOrderItems, 'quantity')
      const isPartiallyRefundable = quantityLeft > 1
      const buttonText = isPartiallyRefundable
        ? lang.p.orders.table.cancelItems
        : lang.p.orders.table.cancelOrder
      cancel = window
        .createBasicButton(buttonText, function (event) {
          event.stopPropagation()
          createCancelOrderDialog(
            notRefundedOrderItems,
            json.id,
            json.sales,
            isPartiallyRefundable,
            setActionButtonDisabledStates,
            buttonText
          )
        })
        .addClass('basicListButton danger')
    }

    var orderDetailsCell = $('<ul>').addClass('orderDetails')

    const offerOrderItems = json.orderItems.filter(oi => !!(oi.offer && oi.offer.tags))

    function isOrderItemNonsurplus(oi) {
      return oi.offer.tags && oi.offer.tags.includes('nonsurplus')
    }

    const hasNonSurplus = offerOrderItems.some(isOrderItemNonsurplus)
    const hasSurplus = !offerOrderItems.every(isOrderItemNonsurplus)

    for (var i = 0; i < json.orderItems.length; i++) {
      var orderItem = json.orderItems[i]

      const isNonsurplus =
        orderItem.offer &&
        orderItem.offer.tags &&
        orderItem.offer.tags.includes('nonsurplus')

      const offerName =
        orderItem.quantity > 1 || json.orderItems.length > 1
          ? `${orderItem.quantity} × ${orderItem.offer.name}`
          : orderItem.offer.name

      var orderItemSpan = $('<li>').append(
        window.getOfferNameElement(offerName, isNonsurplus)
      )

      if (orderItem.refunded) {
        orderItemSpan.addClass('orderItemCancelled')
      }

      orderDetailsCell.append(orderItemSpan)
    }

    var buttonsEl = $('<div>').addClass('small-controls')
    buttonsEl.append(cancel)
    buttonsEl.append(fetch)

    const priceCell = $('<span>')
      .addClass('priceCell left nudgeUp')
      .text((json.sales / 100).toFixed(2))

    if (hasNonSurplus) {
      if (hasSurplus) {
        priceCell.addClass('priceCell-nonsurplus-and-surplus')
      } else {
        priceCell.addClass('priceCell-nonsurplus')
      }
    }

    var customerNameCell = $('<span>').css({'white-space': 'normal'})
    customerNameCell.append(getNameFieldFromOrder(json))

    var tr = table.addRow(
      customerNameCell,
      orderDetailsCell,
      json.phoneNumber
        ? $('<a>')
          .attr('href', 'tel:' + json.phoneNumber)
          .text(json.phoneNumber)
        : '-',
      time,
      priceCell,
      buttonsEl,
      createOrderPopover(json)
    )

    if (oldOrder) {
      tr.addClass('old')
    }

    tr.data('id', json.id)
    tr.attr('data-id', json.id)
  }

  var highestId = NaN

  function filter() {
    var nameFilter = nameInput
      .find('input')
      .val()
      .toLowerCase()

    $('.table .row').each(function () {
      if (
        $(this)
          .find('div:first')
          .text()
          .toLowerCase()
          .indexOf(nameFilter) > -1
      ) {
        $(this).removeClass('hidden')
      } else {
        $(this).addClass('hidden')
      }
    })
  }

  setBasicInfoText()
  for (const table of allOrderTables) {
    table.setDataReady(true)
  }

  function refresh(orders, connectionProblems) {
    if (!openOrdersTable.isInDOM()) {
      return
    }

    if (!orders) {
      return
    }

    // Deep copy so that we can be sure that state.offers will not be edited.
    orders = JSON.parse(JSON.stringify(orders))

    function getStatus(order) {
      return isOrderCancelled(order) * 2 + order.fetched * 1
    }

    orders.sort((a, b) => {
      const statusDiff = getStatus(a) - getStatus(b)
      if (statusDiff !== 0) {
        return statusDiff
      }

      if (sortBy === 'offer') {
        const aName = a.orderItems.filter(oi => oi.type === 'offer')[0].offer.name
        const bName = b.orderItems.filter(oi => oi.type === 'offer')[0].offer.name
        const nameDiff = aName.localeCompare(bName)
        if (nameDiff !== 0) {
          return nameDiff
        }
      }

      if (sortBy === 'name') {
        const aName = getNameFieldFromOrder(a)
        const bName = getNameFieldFromOrder(b)
        const nameDiff = aName.localeCompare(bName)
        if (nameDiff !== 0) {
          return nameDiff
        }
      } else if (sortBy === 'time' || sortBy === 'offer') {
        // If there are two orders in the same second, they will appear in random order.
        return new Date(b.timestamp) - new Date(a.timestamp)
      }

      // Newest first like it has always been.
      return b.id - a.id
    })

    for (const table of allOrderTables) {
      table.removeRows()
    }

    for (var i = 0; i < orders.length; i++) {
      var order = orders[i]

      createOrderRow(order)
      var id = order.id
      if (id > highestId) {
        window.createRowBlinker(id)()
      }
    }

    const showOpenOrders = orders.some(isOpenOrder)
    const showClosedOrders = !orders.every(isOpenOrder)

    if (showOpenOrders) {
      openOrdersTable.getElement().show()
      openOrdersHeader.show()
    } else {
      openOrdersTable.getElement().hide()
      openOrdersHeader.hide()
    }

    if (showClosedOrders) {
      closedOrdersTable.getElement().show()
      closedOrdersHeader.show()
    } else {
      closedOrdersTable.getElement().hide()
      closedOrdersHeader.hide()
    }

    if (orders.length === 0) {
      openOrdersTable.getElement().show()
    }

    for (const table of allOrderTables) {
      table.setEmptyText(lang.p.orders.table.noOrders)
    }

    if (orders.length > 0) highestId = Math.max(...orders.map(o => o.id))

    if (typeof createdCallback == 'function') createdCallback()

    if (connectionProblems && (!window.performance || window.performance.now() > 5000)) {
      openOrdersTable.setEmptyText(lang.p.orders.table.fetchError)

      var span = $('<span>').text(' ' + lang.p.orders.error.connection2 + ' ')
      span.append(
        window.createTextButton(lang.p.orders.error.connection3, function () {
          createOrderView()
        }),
        '.'
      )

      window.setInfoText(
        lang.p.orders.error.connection1,
        span,
        'warning',
        null,
        lang.p.tab.orders,
        false
      )
    }
  }

  function createOrderNotificationSetting() {
    var input = window.createInput({
      label: lang.p.orders.checkBox.playSound,
      size: 'full',
      class: 'offerSound',
      type: 'checkbox',
      value: window.isOrderAlertsOn(),
    })

    input.find('input').change(function () {
      const orderAlertsEnabled = input.find('input').prop('checked')
      window.setOrderAlerts(orderAlertsEnabled)
    })

    return input
  }

  function createNameInput() {
    var nameInput = window.createInputBlock({
      placeholder: lang.p.orders.table.customerName,
      size: 'half',
      class: 'customerName',
      type: 'search',
      onChange: filter,
    })
    nameInput.addClass('icon-search')

    return nameInput
  }

  function createSortInput() {
    const radioElements = []

    function addRadioElement(id, label) {
      radioElements.push({
        id,
        label,
        checked: sortBy === id,
      })
    }

    addRadioElement('name', lang.orders.sort.option.name)
    addRadioElement('time', lang.orders.sort.option.time)
    addRadioElement('offer', lang.orders.sort.option.offer)

    var sortInput = window.createInputBlock({
      label: lang.orders.sort.label,
      class: 'orderSortInput',
      type: 'radio',
      size: 'half',
      radioElements,
    })

    sortInput.addClass('inputBlock-checkboxButtons ordersSortByInputBlock')

    sortInput.data('change')(event => {
      const value = event.target.value
      sortBy = value
      window.store.set('ordersSortBy', value)
      refreshWithSameParameters()
    })

    return sortInput
  }

  function createOrderPopover(json) {
    var description = ''

    const notRefundedOrderItems = json.orderItems.filter(oi => !oi.refunded)
    if (notRefundedOrderItems.length > 0) {
      var descriptions = notRefundedOrderItems
        .map(function (oi) {
          if (oi.offer) {
            return oi.offer.description
          }

          return undefined;
        })
        .filter(Boolean)

      description = descriptions.join(' | ')
    }

    var el = $('<div>').addClass('popover-inner')

    if (description) {
      $(
        `<div><span>${lang.p.dialog.editOffer.form.description.label}: </span><span>${description}</span></div>`
      ).appendTo(el)
    }

    let refundText = ''
    if (isOrderCancelled(json)) {
      refundText = lang.orders.order.summary.cancelledInfo
    } else if (json.orderItems.some(oi => oi.refunded)) {
      refundText = lang.orders.order.summary.partiallyRefundedInfo
    }

    if (refundText) {
      $(`<div><span>${refundText}</span><span> ${json.refundReason || ''}</span></div>`).appendTo(el)
    }

    return el
  }

  window.ordersStream.forEach(function listener(orders) {
    if (!openOrdersTable.isInDOM()) {
      window.ordersStream.removeListener(listener)
      return
    }

    refresh(orders, window.connectionProblemsStream.value)
  })

  window.connectionProblemsStream.forEach(function listener(connectionProblems) {
    if (!openOrdersTable.isInDOM()) {
      window.connectionProblemsStream.removeListener(listener)
      return
    }

    refresh(window.ordersStream.value, connectionProblems)
  })

  function refreshWithSameParameters() {
    refresh(window.ordersStream.value, window.connectionProblemsStream.value)
  }
}

function getNameFieldFromOrder(order) {
  return (order.userName && ('' + order.userName).trim()) || order.email || order.orderEmail
}

function cancelOrder(id, orderItemIdsAndQuantities) {
  return window
    .postRequest('provider/cancelOrder/' + id, {orderItemIdsAndQuantities})
    .done(function () {
      window.createToast(lang.p.orders.toast.delete.success)
      window.updateCurrentView(window.createRowBlinker(id))
    })
    .fail(window.dialogFailResponse)
}

function createCancelOrderDialog(
  notCancelledOrderItems,
  orderId,
  orderSales,
  isPartiallyRefundable,
  setButtonState,
  title = lang.p.orders.table.cancelOrder
) {
  setButtonState(true)

  var dlg = new window.ModalDialog(title, {width: '700px'})

  const dialogElement = dlg.getDialogElement()[0]

  let dialogVisible = true
  let queryActive = false

  // When the dialog is closed (dialogElement no longer in DOM) and the request
  // possibly started by it is finished, enable the button again.
  const intervalId = setInterval(function checkIfButtonShouldBeEnabled() {
    if (!window.isDomNodeConnected(dialogElement)) {
      dialogVisible = false
    }

    if (!dialogVisible && !queryActive) {
      clearInterval(intervalId)
      setButtonState(false)
    }
  }, 50)

  dlg.add($('<p>').text(lang.p.orders.confirm.cancel))

  const setRefundButtonSum = function (sumToRefund) {
    cancelButton.text(
      window.formatText(
        lang.orders.refundMultiorder.refundSum,
        window.formatCurrency(sumToRefund, use.profile.currency, true)
      )
    )
  }

  const orderItemCheckboxes = []
  if (isPartiallyRefundable) {
    const updateTotalPrice = function () {
      const selectedOrderItemsCheckboxes = orderItemCheckboxes.filter(oic => oic.data('value'))
      const sumToRefund = _.sumBy(
        selectedOrderItemsCheckboxes,
        cb => cb.data('orderItemInfo').unitPrice
      )

      setRefundButtonSum(sumToRefund)

      // Allows refund of free item:
      if (selectedOrderItemsCheckboxes.length > 0) {
        cancelButton.removeAttr('disabled')
      } else {
        cancelButton.attr('disabled', 'disabled')
      }
    }

    const addLine = function () {
      const line = $('<div>').addClass('modal-horizontalLine no-margin-light')
      dlg.add(line)
    }

    addLine()

    const selectAllCheckbox = dlg.addInput({
      type: 'checkbox2',
      label: lang.orders.refundMultiorder.refundWholeOrder,
      blockClass: 'no-margin',
    })

    let skipChangeHandler = false

    selectAllCheckbox.data('change')(() => {
      if (skipChangeHandler) {
        return
      }
      for (const checkbox of orderItemCheckboxes) {
        skipChangeHandler = true
        checkbox.data('set')(selectAllCheckbox.data('value'))
        skipChangeHandler = false
      }
      updateTotalPrice()
    })

    const addPriceToCheckbox = function (checkbox, price) {
      checkbox.find('label span').prepend(
        $('<span>')
          .addClass('cancelOrder-checkboxPrice')
          .text(window.formatCurrency(price, use.profile.currency, true))
      )
    }

    addPriceToCheckbox(selectAllCheckbox, orderSales)

    addLine()

    dlg.add(
      $('<div>')
        .text(lang.orders.refundMultiorder.orSelectItems)
        .css({
          background: '#eee',
          padding: '20px',
          'font-size': '14px',
          'font-weight': 'bold',
        })
    )

    addLine()

    const createItemCheckbox = function (id, unitPrice, offerName) {
      const checkbox = dlg.addInput({
        type: 'checkbox2',
        label: `${offerName}`,
        blockClass: 'no-margin',
      })
      checkbox.data('orderItemInfo', {
        id,
        unitPrice,
        offerName,
      })
      checkbox.data('change')(() => {
        if (skipChangeHandler) {
          return
        }
        const allSelected = !orderItemCheckboxes.some(cb => !cb.data('value'))
        skipChangeHandler = true
        selectAllCheckbox.data('set')(allSelected)
        skipChangeHandler = false
        updateTotalPrice()
      })
      orderItemCheckboxes.push(checkbox)

      addPriceToCheckbox(checkbox, unitPrice)

      addLine()
    }

    for (const orderItem of notCancelledOrderItems) {
      for (let i = 0; i < orderItem.quantity; i++) {
        createItemCheckbox(orderItem.id, orderItem.unitPrice, orderItem.offer.name)
      }
    }

    // cancelButton does not yet exists. Wait a bit before running updateTotalPrice().
    setTimeout(updateTotalPrice, 0)
  } else {
    // cancelButton does not yet exists. Wait a bit before running setRefundButtonSum().
    setTimeout(() => setRefundButtonSum(orderSales), 0)
  }

  dlg.addToFooter(
    window.createBasicButton(
      lang.p.orders.table.backToListing,
      function () {
        dlg.hide()
      },
      'basicCancelButton modal-button'
    )
  )

  const cancelButton = dlg.addToFooter(
    window.createBasicButton(
      lang.p.orders.table.cancelOrder,
      function () {
        dlg.hide()

        let orderItemIdsAndQuantities = undefined
        if (isPartiallyRefundable) {
          const selectedIds = orderItemCheckboxes
            .filter(oic => oic.data('value'))
            .map(oic => oic.data('orderItemInfo').id)

          orderItemIdsAndQuantities = _.map(_.groupBy(selectedIds), ids => ({
            id: ids[0],
            quantity: ids.length,
          }))
        }

        cancelOrder(orderId, orderItemIdsAndQuantities).then(
          function () {
            queryActive = false
          },
          function () {
            queryActive = false
          }
        )
        queryActive = true
      },
      'basicDeleteButton modal-button'
    )
  )

  dlg.show()
}
; /* START FILE provider/js/view/settingsView.js */ function setReadonlyIfEditingDisabled(field) {
  if (use.profile.allowInvoiceFieldEditing) {
    return;
  }

  field.input.attr('readonly', 'readonly');
}
function setReadonlyIfFieldHasValue(field, value) {
  if (!value) {
    return;
  }
  field.input.attr('readonly', 'readonly');
}
function setFieldEditability(field, value) {
  return setReadonlyIfFieldHasValue(field, value);
}

function hasSharedBillingInfo(provider) {
  return provider.useEnterpriseBillingInfo === 1 && provider.enterpriseId;
}

function addCompanyOldKycFormFields(dlg, provider) {
  const billingInfoEnterOnceWarningText = window.formatText(
    lang.e.provider.newProvider.billingInfoEnterOnceWarning,
    use.env.SUPPORT_GLOBAL_EMAIL,
    use.env.SUPPORT_GLOBAL_PHONE
  );
  const billingInfoEnterOnceWarning = $('<p class="billing-info-warning">').text(
    billingInfoEnterOnceWarningText
  );
  dlg.add(billingInfoEnterOnceWarning);

  const billingInfoMissingText = $('<p class="billing-info-warning">').text(
    lang.p.settings.form.missingBillingInfo.moreInfo
  );

  dlg.add(billingInfoMissingText);

  const nameInput = dlg.addInputOld(
    'invoiceCompanyName',
    lang.p.settings.form.invoice.companyName + ' *',
    '',
    'text',
    provider.invoiceCompanyName,
    'left',
    '49%'
  );
  setFieldEditability(nameInput, provider.invoiceCompanyName);

  const businessIdInput = dlg.addInputOld(
    'invoiceBusinessID',
    lang.p.settings.form.invoice.businessId + ' *',
    '',
    'text',
    provider.invoiceBusinessID,
    'right',
    '49%'
  );
  setFieldEditability(businessIdInput, provider.invoiceBusinessID);

  dlg.addClear();

  const addressInput = dlg.addInputOld(
    'invoiceAddress',
    lang.p.settings.form.invoice.address,
    '',
    'text',
    provider.invoiceAddress,
    'left',
    '49%'
  );
  setFieldEditability(addressInput, provider.invoiceAddress);

  const postalCodeInput = dlg.addInputOld(
    'invoicePostalCode',
    lang.p.settings.form.invoice.postalCode,
    '',
    'text',
    provider.invoicePostalCode,
    'right',
    '49%'
  );
  setFieldEditability(postalCodeInput, provider.invoicePostalCode);

  dlg.addClear();

  const invoiceCountryInput = dlg.addInputOld(
    'invoiceCountry',
    lang.p.settings.form.invoice.country,
    '',
    'text',
    provider.invoiceCountry,
    'left',
    '49%'
  );
  setFieldEditability(invoiceCountryInput, provider.invoiceCountry);

  const invoiceCityInput = dlg.addInputOld(
    'invoiceCity',
    lang.p.settings.form.invoice.city,
    '',
    'text',
    provider.invoiceCity,
    'right',
    '49%'
  );
  setFieldEditability(invoiceCityInput, provider.invoiceCity);

  dlg.addClear();

  const ibanInput = dlg.addInputOld(
    'invoiceIBAN',
    lang.p.settings.form.invoice.iban + ' *',
    '',
    'text',
    provider.invoiceIBAN,
    'left',
    '49%'
  );
  setFieldEditability(ibanInput, provider.invoiceIBAN);

  const invoiceBicInput = dlg.addInputOld(
    'invoiceBic',
    lang.p.settings.form.invoice.bic,
    '',
    'text',
    provider.invoiceBic,
    'right',
    '49%'
  );
  setFieldEditability(invoiceBicInput, provider.invoiceBic);

  dlg.addClear();

  const requiredInputBlocks = [nameInput, ibanInput, businessIdInput];

  const updateBillingInfoWarningsVisibility = () => {
    for (const requiredInputBlock of requiredInputBlocks) {
      if (requiredInputBlock.input.val() && requiredInputBlock.input.val().length > 3) {
        requiredInputBlock.container.removeClass('inputBlock-warning');
      } else {
        requiredInputBlock.container.addClass('inputBlock-warning');
      }
    }

    const valueMissing = requiredInputBlocks.some((inputBlock) => {
      return !inputBlock.input.val();
    });

    if (valueMissing) {
      billingInfoMissingText.show();
    } else {
      billingInfoMissingText.hide();
    }
  };

  for (const requiredInputBlock of requiredInputBlocks) {
    requiredInputBlock.input.on('input', updateBillingInfoWarningsVisibility);
  }

  updateBillingInfoWarningsVisibility();

  dlg.add('<br>');

  addBillingEmailAndReferenceFields(dlg, provider);
}

function addBillingEmailAndReferenceFields(dlg, provider) {
  dlg.addInputOld(
    'billingEmail',
    lang.p.settings.form.billingEmail.label,
    lang.p.settings.form.billingEmail.placeholder,
    'billingEmail',
    provider.billingEmail,
    'left',
    '100%'
  );

  const defaultInvoiceReferenceNumber = hasSharedBillingInfo(provider) ? provider.name : '';

  dlg.addInputOld(
    'invoiceReferenceNumber',
    lang.p.settings.form.invoice.referenceNumber,
    defaultInvoiceReferenceNumber,
    'text',
    provider.invoiceReferenceNumber,
    'left',
    '49%'
  );
}

function addAdyenOnboardingButton(dlg, provider) {
  const adyenOnboardingButton = window
    .createBasicButton(
      lang.p.settings.adyenKyc.onboardingButton,
      function () {
        window
          .getRequest('v1/payout-psp-accounts/onboarding', {
            reference: provider.id,
            referenceType: 'partner',
          })
          .done((result) => {
            const parsedResult = JSON.parse(result);
            window.open(parsedResult.url, '_blank');
          })
          .error((e) => {
            const message =
              e && e.responseJSON && e.responseJSON.error && e.responseJSON.error.message;
            window.showAlert(message);
          });
      },
      'basicConfirmButton'
    )
    .addClass('adyen-kyc-button');

  dlg.add($('<div class="adyen-button-wrapper">').append(adyenOnboardingButton));
}

// TODO: Localize text strings in this function
function addAdyenOnboardingSection(dlg, provider) {
    const adyenOnboardingIncomplete = $('<p class="kyc-message kyc-warning">').text(
        lang.p.settings.adyenKyc.kycIncompleteMessage
    );

    const adyenSharedOnboardingIncomplete = $('<p class="kyc-message kyc-warning">').text(
        lang.p.settings.adyenKyc.sharedBilling.kycIncompleteMessage
    );
    const adyenOnboardingRejected = $('<p class="kyc-message kyc-warning">').text(
        lang.p.settings.adyenKyc.kycRejectedMessage
    );
    const adyenOnboardingCompleted = $('<p class="kyc-message kyc-success">').text(
        lang.p.settings.adyenKyc.kycCompletedMessage
    );

    switch (use.profile.kycVerificationStatus) {
      case 'rejected':
        // The partner's capabilities (one or more) during the KYC verification
        // Warn the partner to get in touch with CS ASAP.
        dlg.add(adyenOnboardingRejected);
        return;
      case 'valid':
        // The partner completed KYC, we want to prevent further editing
        // We hide the onboarding link and show a message that tells them
        // any changes will requires contacting CS
        dlg.add(adyenOnboardingCompleted);
        return;
      case 'pending':
      case 'invalid':
        if (hasSharedBillingInfo(provider)){
            // The partner has not completed KYC (either pending or invalid).
            // KYC is on the Enterprise because the partner has shared billing
            // We hide the onboarding link because KYC should be done
            // via the Enterpise app -> Account Settings
            dlg.add(adyenSharedOnboardingIncomplete);
            return;
        } else {
            // The partner has not completed KYC (either pending or invalid).
            // The partner shared billing info is OFF
            // We show the onboarding link and prompt partners
            // to visit Adyen's Onboarding
            dlg.add(adyenOnboardingIncomplete);
            addAdyenOnboardingButton(dlg, provider);
            return;
        }
    }
}

function addPaymentInformationForm(dlg, provider) {
  if (use.profile.hasAdyenOnboarding) {
    // Is in Adyen
    addAdyenOnboardingSection(dlg, provider);

    const nameInput = dlg.addInputOld(
      'invoiceCompanyName',
      lang.p.settings.form.invoice.companyName + ' *',
      '',
      'text',
      provider.invoiceCompanyName,
      'left',
      '49%'
    );
    setFieldEditability(nameInput, provider.invoiceCompanyName);

    dlg.add('<br>');

    addBillingEmailAndReferenceFields(dlg, provider);

  } else {
    // Uses legacy
    if (hasSharedBillingInfo(provider)) {
      // Has shared billing (i.e.: enterprise)
      dlg.add($('<p>').text(lang.p.settings.form.invoice.sharedBillingInfoText));
      addBillingEmailAndReferenceFields(dlg, provider);
    } else {
      // Does not have shared billing (i.e.: partner)
      addCompanyOldKycFormFields(dlg, provider);
    }
  }
}

function createSettingsView() {
  var content = window.clearViewContent();

  window.setInfoText('', lang.p.settings.loading, null, null, lang.p.tab.settings, true);

  wait.env
    .then(function () {
      return window.getRequest('provider/myInfo', {});
    })
    .then(function (response) {
      var json = JSON.parse(response).myInfo;

      var realContent = window.clearViewContent();
      var content = $('<div>').addClass('flex-center').appendTo(realContent);
      window.setInfoText(
        lang.p.settings.helpText1 + ' ',
        lang.p.settings.helpText2,
        null,
        null,
        lang.p.tab.settings,
        true
      );

      var dlg = new window.ModalDialog(null, {
        popup: false,
        width: '720px',
        preventLeaveOnChanges: true,
        saveOnlyEdited: true,
        hideTitle: true,
      });

      var passwordButton = window
        .createBasicButton(lang.p.settings.button.changePassword, function () {
          window.openProviderChangePasswordDialog(json.username);
        })
        .css({
          float: 'right',
          width: '49%',
          position: 'relative',
          top: '21px',
          marginBottom: '40px',
        })
        .addClass('inputBlock');

      dlg
        .addInputOld(
          'username',
          lang.p.settings.form.username.label,
          '',
          'text',
          json.username,
          'left',
          '49%'
        )
        .input.attr('readonly', 'readonly');
      dlg.add($('<div>').addClass('inputBlock').append(passwordButton));
      //		dlg.add(passwordButton);

      dlg.addClear();
      const emailInput = dlg.addInputOld(
        'email',
        lang.p.settings.form.email.label,
        lang.p.settings.form.email.placeholder,
        'email',
        json.email,
        'left',
        '49%'
      );

      const isEmailVerified = json.email === json.verifiedEmail;
      if (!isEmailVerified) {
        var emailTitle = emailInput.container.find('.inputBlockTitle');
        var unverifiedText = lang.p.settings.form.email.unverified.label;
        var unverifiedMoreInfo = window.formatText(
          lang.p.settings.form.email.unverified.moreInfo,
          json.verifiedEmail
        );
        var unverifiedSpan = $('<span class="highlighted-warning-text">')
          .text(unverifiedText)
          .attr('title', unverifiedMoreInfo);
        emailTitle.append(unverifiedSpan);
      }

      dlg.addInputOld(
        'phoneNumber',
        lang.p.settings.form.phone.label,
        lang.p.settings.form.phone.placeholder,
        'text',
        json.phoneNumber,
        'right',
        '49%'
      );

      const preferredLanguageSelectOptions = {
        values: use.env.SUPPORTED_CONTACT_LANGUAGES_WITH_NAMES.map((x) => x.id),
        labels: use.env.SUPPORTED_CONTACT_LANGUAGES_WITH_NAMES.map((x) => x.name),
      };

      dlg.addInputOld(
        'preferredLanguageCode',
        lang.p.settings.form.preferredLanguage.label,
        null,
        'select',
        json.preferredLanguageCode,
        'left',
        '49%',
        preferredLanguageSelectOptions
      );

      // TODO we could display the verified email if our email is unverified.
      // if (!isEmailVerified) {
      // 	dlg.addClear()
      // 	dlg.addInputOld(
      // 		'verifiedEmail',
      // 		lang.p.settings.form.verifiedEmail.label,
      // 		'',
      // 		'email',
      // 		json.verifiedEmail,
      // 		'left',
      // 		'49%'
      // 	).input.attr('readonly', 'readonly')
      // }

      dlg.addHorizontalLine();

      if (!use.profile.enforceSharedTemplates) {
        var title = dlg.addInputTitle(lang.p.settings.dynamicPricing.title);
        var logo = $('<img>');
        logo.attr('src', 'img/icon-smart-price-descending.svg');
        logo.css({ 'vertical-align': 'middle', 'padding-left': '10px' });
        logo.appendTo(title);

        const showExplanationLink = $('<a href="#">')
          .addClass('moreInfo')
          .text(lang.p.settings.dynamicPricing.helpLink);

        const escapeHtml = function (unsafe) {
          return unsafe
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
        };

        const helpTexts = [
          lang.p.settings.dynamicPricing.helpText1,
          lang.p.settings.dynamicPricing.helpText2,
          lang.p.settings.dynamicPricing.helpText3,
        ].join('\n\n');

        const minPriceFormatted = window.formatCurrency(
          use.profile.country.minPrice,
          use.profile.country.currency,
          true,
          false
        );

        const helpText = window.formatText(
          helpTexts,
          60,
          100 - use.profile.dynamicPricingMaxDiscountPercentage,
          minPriceFormatted
        );

        const originalDynamicPricingTexts = helpText.split('<br/><br/>');

        const dynamicPricingExplanationText = originalDynamicPricingTexts
          .map(escapeHtml)
          .join('<br><br>');

        showExplanationLink.click((ev) => {
          ev.preventDefault();
          window.showAlert(
            dynamicPricingExplanationText,
            lang.p.settings.dynamicPricing.title,
            null,
            true
          );
        });

        const isDynamicPricingEnabledToggleContainer = dlg.addInputOld(
          'isDynamicPricingEnabled',
          lang.p.settings.dynamicPricing.content,
          0,
          'checkbox',
          json.isDynamicPricingEnabled,
          'left',
          'auto'
        );

        isDynamicPricingEnabledToggleContainer.container.css('padding-right', '0px');
        isDynamicPricingEnabledToggleContainer.container
          .find('input[type=checkbox]')
          .css('margin-right', '10px');
        isDynamicPricingEnabledToggleContainer.container.find('label').css('width', 'initial');

        dlg.add(showExplanationLink);
        dlg.addHorizontalLine();
      }

      dlg.addInputTitle(lang.p.settings.saveOffersAsTemplates.title);
      dlg.addInputOld(
        'createOfferTemplateByDefault',
        lang.p.settings.saveOffersAsTemplates.content,
        0,
        'checkbox',
        json.createOfferTemplateByDefault
      );

      dlg.addHorizontalLine();

      const billingInfoTitle = $('<h1 class="billing-info-subtitle">').text(
        lang.p.settings.form.billing.subtitle
      );
      dlg.add(billingInfoTitle);

      addPaymentInformationForm(dlg, json);

      dlg.addClear();

      dlg.addButton(
        lang.p.settings.form.submit,
        function (data) {
          window
            .postRequest('provider/editProvider', data)
            .done(function (response) {
              window.updateMyInfo();
              window.updateTags();
              var msg = JSON.parse(response).message;
              alert(msg);
              createSettingsView();
            })
            .fail(window.dialogFailResponse);
        },
        'basicConfirmButton'
      );

      dlg.getDialogElement().appendTo(content);
    });
}
; /* START FILE provider/js/view/statView.js */ function createStatView() {
  window.setInfoText(lang.p.stats.table.fetching, '', null, null, lang.p.tab.stats, false)
  var content = window.clearViewContent()
  content.addClass('content-stats')

  var _nowDateInfo = new Date().toISOString().split('-') // stats are in UTC, don't just use new Date()
  var MIN_YEAR = new Date(use.profile.registeredDate).getFullYear()
  var CURRENT_YEAR = ~~_nowDateInfo[0]
  var CURRENT_MONTH = ~~_nowDateInfo[1]

  var years = []
  for (var y = MIN_YEAR; y <= CURRENT_YEAR; y++) {
    years.push(y)
  }

  var yearText = lang.p.stats.year.label
  var monthText = lang.p.stats.month.label

  var yearInput
  var monthInput

  function get(inputContainer) {
    return inputContainer.input.val()
  }

  function set(inputContainer, value) {
    inputContainer.input.val(value)
  }

  function add(inputContainer, change) {
    inputContainer.input.val(Number(inputContainer.input.val()) + change)
  }

  function prev() {
    if (!monthInput || !yearInput) {
      return
    }
    if (get(monthInput) === '1') {
      if (get(yearInput) !== String(MIN_YEAR)) {
        add(yearInput, -1)
        set(monthInput, 12)
      }
    } else if (get(monthInput) === 'all') {
      add(yearInput, -1)
    } else {
      add(monthInput, -1)
    }
    if (!get(yearInput)) {
      set(yearInput, String(MIN_YEAR))
    }
    refreshTableContents()
  }

  function next() {
    if (!monthInput || !yearInput) {
      return
    }
    if (get(monthInput) === '12') {
      if (get(yearInput) !== String(CURRENT_YEAR)) {
        add(yearInput, 1)
        set(monthInput, 1)
      }
    } else if (get(monthInput) === 'all') {
      add(yearInput, 1)
    } else {
      add(monthInput, 1)
    }
    if (!get(yearInput)) {
      set(yearInput, String(CURRENT_YEAR))
    }
    refreshTableContents()
  }

  window.onkeydown = function (ev) {
    // log(ev.keyCode);
    if (ev.keyCode === 37) {
      prev()
    }
    if (ev.keyCode === 39) {
      next()
    }
  }

  function getFilterSettings() {
    return {
      year: yearInput.input.val(),
      month: monthInput.input.val(),
      matches: function (dayString) {
        var dayArr = dayString.split('-')
        var yearMatch = ~~dayArr[0] === ~~this.year
        var monthMatch = this.month === 'all' || (~~dayArr[1] === ~~this.month)
        return yearMatch && monthMatch
      }
    }
  }

  let t = new window.Table()

  //var tableWidth = "1000px";
  var widthCss = {
    //maxWidth: tableWidth,
    //minWidth: tableWidth,
    boxShadow: 'none'
  }

  let tElement

  function renderSettings() {
    yearInput = window.createInputBlockOld('year', yearText, null, 'select', CURRENT_YEAR, 'left', null, {
      values: years
    }).addClass('inputBlock-fixed')

    monthInput = window.createInputBlockOld('month', monthText, null, 'select', CURRENT_MONTH, 'left', null, {
      values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 'all'],
      labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, lang.p.stats.all]
    }).addClass('inputBlock-fixed')

    var buttonsDiv = $('<div class="buttons">')

    function getParams() {
      return {
        year: yearInput.input.val(),
        month: monthInput.input.val()
      }
    }

    window.createBasicButton(lang.p.stats.button.detailedDataCsv, function () {
      var params = Object.assign(getParams(), {type: 'csv'})
      window.downloadAjaxFile('/provider/statsPerOffer', params, 'GET')
    }, 'basicConfirmButton salesButton').css('visibility', 'hidden').appendTo(buttonsDiv)

    window.createBasicButton(lang.p.stats.button.downloadInvoice, function () {
      var params = Object.assign(getParams())
      window.downloadAjaxFile('/provider/invoice', params, 'GET')
    }, 'basicConfirmButton invoiceButton').css('visibility', 'hidden').appendTo(buttonsDiv)

    window.createBasicButton(lang.p.stats.button.downloadServiceInvoice, function () {
      var params = Object.assign(getParams(), {invoiceType: 'service'})
      window.downloadAjaxFile('/provider/invoice', params, 'GET')
    }, 'basicConfirmButton serviceInvoiceButton').css('visibility', 'hidden').appendTo(buttonsDiv)

    yearInput.input.on('change', refreshTableContents)
    monthInput.input.on('change', refreshTableContents)

    var settings = $('<div class=settings>')

    var inputs = $('<div class="inputs"></div>')
    inputs.append(yearInput)
    inputs.append(monthInput)
    inputs.appendTo(settings)

    settings.append(buttonsDiv)
    content.append(settings)

    window.setInfoText(
      lang.p.stats.helpText1 + ' ',
      lang.p.stats.helpText2,
      null,
      null,
      lang.p.tab.stats,
      false
    )
  }

  function renderTableHeader(vats) {
    t.addPrimaryColumn(lang.p.stats.table.date, 120, 120)
    t.addPrimaryColumn(lang.p.stats.table.offered, 70, 70)
    t.addPrimaryColumn(lang.p.stats.table.sold, 70, 70)
    t.addPrimaryColumn(lang.p.stats.table.soldPercentage, 80, 80)

    vats.forEach(vatRate => {
      const totalSalesText = window.formatText(
        lang.p.stats.table.totalSales,
        vatRate
      )
      t.addPrimaryColumn(totalSalesText, 110, 110)
    })

    t.addPrimaryColumn(lang.p.stats.table.totalSalesWithoutTax, 110, 110)

    t.addPrimaryColumn(lang.p.stats.table.commission, 100, 100)

    t.addPrimaryColumn(lang.p.stats.table.providerShareWithoutTax, 140, 140)
    t.addPrimaryColumn(lang.p.stats.table.providerWillBePaid, 110, 110)

    // Technically, we could do this first, and render the data later
    t.setEmptyText(lang.p.stats.table.fetching)
    tElement = t.getElement().css(widthCss)
    tElement.find('#table').css({
      backgroundColor: 'inherit',
      overflow: 'visible'
    })

    content.append(tElement)
  }

  function createStatsRow(row, vatRates) {
    var currency = myInfoResults.country.currency
    var day = row.day ? row.day : lang.p.stats.table.total

    var offered = row.offeredPortions
    var sold = row.offerOrderedPortions
    var soldPercentage = offered > 0 ? (sold / offered * 100).toFixed(0) : '0'

    var sales = vatRates.map(vatRate => {
      return window.trustableHTMLCode(window.formatCurrency((row.salesPerVat[vatRate] || 0), currency))
    })

    const rowData = [
      day,
      offered,
      sold,
      soldPercentage + '%',
      ...sales,
      window.trustableHTMLCode(window.formatCurrency(row.totalSalesWithoutVat, currency)),
      window.trustableHTMLCode(window.formatCurrency(row.commissionWithoutVat, currency)),
      window.trustableHTMLCode(window.formatCurrency(row.partnerIncomeWithoutVat, currency)),
      window.trustableHTMLCode(window.formatCurrency(row.paidToPartner, currency))
    ]

    var tr = t.addRow(...rowData)

    tr.css(widthCss)
    return tr
  }

  function refreshTableContents() {
    var filterSettings = getFilterSettings()
    var year = Number(filterSettings.year)
    var month = Number(filterSettings.month)

    t.removeTable()
    t = new window.Table()

    t.setDataReady(false)
    $('.invoiceButton').css('visibility', 'hidden')
    $('.serviceInvoiceButton').css('visibility', 'hidden')
    $('.salesButton').css('visibility', 'hidden')

    const isMonthlySales = Number.isInteger(month)
    const statsUrl = isMonthlySales ? `provider/statsMonth?year=${year}&month=${month}` : `provider/statsYear?year=${year}`

    window.getRequest(statsUrl, {})
      .done(function (response) {
        var stats = JSON.parse(response)
        renderTableContents(stats, isMonthlySales)
      }).fail(failHandler)
  }

  function renderTableContents(data, isMonthlySales) {
    var vatRates = Object.keys(data.total.salesPerVat)
    renderTableHeader(vatRates)

    createStatsRow(data.total, vatRates).css({fontWeight: 'bold'})

    for (let i = data.dailyStats.length - 1; i >= 0; i--) {
      const dailyStat = data.dailyStats[i]
      createStatsRow(dailyStat, vatRates)
    }

    tElement.find('#table').append($('<div>').css({height: '20px'}))

    if (isMonthlySales) {
      if (data.invoiceInfo.hasInvoice) {
        $('.invoiceButton').css('visibility', 'visible')
      }
      if (data.invoiceInfo.hasServiceInvoice) {
        $('.serviceInvoiceButton').css('visibility', 'visible')
      }
      if (data.total.offerOrderedPortions > 0) {
        $('.salesButton').css('visibility', 'visible')
      }
    }

    t.setDataReady(true)
  }

  var myInfoResults = null

  function failHandler() {
    window.dialogFailResponse(lang.p.stats.table.fetchError)
  }

  window.getRequest('provider/myInfo', {})
    .done(function (response) {
      myInfoResults = JSON.parse(response).myInfo

      renderSettings()
      refreshTableContents()
    })
    .fail(failHandler)
}
; /* START FILE provider/js/view/templateView.js */ function createTableHeader(text) {
    const el = $('<div>').addClass('table-header')
    el.append($('<div>').addClass('spacer'))
    el.append($('<div>').addClass('title').text(text))
    el.append($('<div>').addClass('button-placeholder'))
    return el
}

function createTableWithTemplateHeaders(options) {
    const {
        priceHeaderText,
        elementId
    } = options

    const table = new window.Table()
    table.addSmallHeader(lang.p.tab.templates)
    table.addPrimaryColumn(lang.p.templates.table.offerName, 200, 500)
    const priceHeaderCell = table.addColumn(priceHeaderText, 140)
    if (!use.profile.enforceSharedTemplates || use.profile.isModel) {
        table.addButtonColumn(lang.p.templates.table.edit, 90)
        table.addButtonColumn(lang.p.templates.table.delete, 90)
    }
    table.addButtonColumn('', 190)
    table.addPopoverColumn()

    priceHeaderCell.addClass('priceHeaderCell')

    if (elementId) {
        table.getElement().attr('id', elementId)
    }

    return table
}
function createTemplateView(createdCallback) {
    const content = window.clearViewContent()

    function updateInfoText() {
        const title = use.profile.isModel
            ? lang.p.templates.shared.offerTemplatesTitle
            : lang.p.tab.templates
        window.setInfoText('', '', null, null, title, false)
    }
    updateInfoText()

    const headerContainer = $('<div>').addClass('header-container')
    const actionContainer = $('<div>').addClass('action-container')
    const primaryAction = $('<div>').addClass('offersView-primaryActionWrapper')

    if (!use.profile.enforceSharedTemplates || use.profile.isModel) {
        setTimeout(() => {
            const button = new window.Vue({
                render: h =>
                    h(
                        window.NewButton,
                        {
                          on: {
                            click() {
                              wait.profile.then(profile => {
                                window.openCreateOfferTemplateDialog();
                              })
                            },
                          },
                        },
                        lang.p.templates.button.newTemplate
                    ),
            }).$mount()
            primaryAction.append(button.$el)
        })
    }

    primaryAction.appendTo(actionContainer)
    actionContainer.appendTo(headerContainer)
    headerContainer.appendTo(content)

    const nameInput = createNameInput()

    const toolbar = $('<div>').addClass('toolbar')

    toolbar.appendTo(content)
    nameInput.appendTo(toolbar)

    const addTable = (title, options) => {
        const header = createTableHeader(title)
        header.hide()
        content.append(header)

        const table = createTableWithTemplateHeaders(options)
        content.append(table.getElement())

        return {
            table,
            header
        }
    }

    // Recurring
    const { header: repeatHeader, table: repeatTable } = addTable(lang.p.templates.listHeader.repeating, {
        priceHeaderText: lang.p.offers.table.price,
        elementId: 'repeatTable'
    })
    repeatTable.getElement().hide()

    // Model templates
    const modelTemplateTitle = use.profile.enterprise ? lang.p.templates.shared.offerTemplatesTitle : ''
    const { header: modelTemplateHeader, table: modelTemplateTable } = addTable(modelTemplateTitle, {
        priceHeaderText: lang.p.templates.table.defaultPrice,
    })
    modelTemplateTable.getElement().hide()

    // Normal templates
    const { header: templateHeader, table: t } = addTable(lang.p.templates.listHeader.offerTemplates, {
        priceHeaderText: lang.p.templates.table.defaultPrice,
    })

    function setRepeatingOfferPaused(pause, json) {
        const data = {
            repeatPaused: !!pause
        }
        window
            .postRequest('provider/offerTemplate/' + json.id, data)
            .done(function(res) {
                let text = window.formatText(lang.p.templates.toast.resume.success, json.name)

                if (pause) {
                    text = window.formatText(lang.p.templates.toast.pause.success, json.name)
                }

                window.createToast(text, function() {})

                refresh()
            }, 'basicConfirmButton')
            .fail(window.dialogFailResponse)
    }

    function createTemplateRow(json, table) {
        let primaryButton = window.createBasicButton(
            lang.p.templates.button.makeOffer,
            function(event) {
                event.stopPropagation()

                wait.profile.then(profile => {
                    if (profile.restricted) {
                        alert(lang.p.offers.newOfferRestricted)
                        return
                    }

                    window.showTimezoneWarning().then(function() {
                        window.openTagProposerDialog(json, () => {
                            window.openCreateOfferDialog(json)
                            $('.quantityInput').focus()
                        })
                    })
                })
            },
            'basicListButton primaryButton'
        )

        let tr

        const isNonsurplus = window.isOfferOrOfferTemplateNonsurplus(json)

        const originalPriceFormatted = window.formatCurrency(~~json.defaultPrice, use.profile.country.currency, true)
        const priceCell = $('<span/>').addClass('priceCell')
        if (isNonsurplus) {
            priceCell.addClass('priceCell-nonsurplus')
        }

        if (use.profile.isDynamicPricingEnabled && json.isDynamicallyPriced) {
            const dpIcon = $('<img/>')
            dpIcon.addClass('dynamicPricing')
            dpIcon.attr('src', 'img/icon-smart-price-descending-white.svg')
            dpIcon.appendTo(priceCell)
        }

        priceCell.append($('<span/>').text(originalPriceFormatted))

        const isEditingDisabled = table === modelTemplateTable

        const editButton = window.createIconButton('img/edit_symbol.png', function(event) {
            window.openEditOfferTemplateDialog(json)
            event.stopPropagation()
            return true
        }).attr('disabled', isEditingDisabled)

        const deleteButton = window.createIconButton('img/halt_symbol.png', function(event) {
            event.stopPropagation()
            if (window.escapedConfirm(
                window.formatText(lang.p.templates.delete.confirm, json.name)
            )) {
                deleteOfferTemplate(json)
            }
        }).attr('disabled', isEditingDisabled)

        const addRow = function(offerName) {
            const args = []
            args.push(offerName)
            args.push(priceCell)
            if (!use.profile.enforceSharedTemplates || use.profile.isModel) {
                args.push(editButton)
                args.push(deleteButton)
            }
            args.push(use.profile.isModel ? null : primaryButton)
            args.push(createOfferTemplatePopover(json))

            return table.addRow.apply(table, args)
        }

        if (table === repeatTable) {

            let repeatIcon

            if (json.repeatPaused) {
                repeatIcon = $('<span class="icon-repeat-off" />')

                primaryButton = window.createBasicButton(lang.p.templates.button.resumeOffer, function(event) {
                    event.stopPropagation()
                    window.showTimezoneWarning().then(function() {
                        setRepeatingOfferPaused(false, json)
                        refresh()
                    })

                }, 'basicListButton repeat repeat-off')
            } else {
                repeatIcon = $('<span class="icon-repeat-on" />')
                primaryButton = window.createBasicButton(lang.p.templates.button.pauseOffer, function(event) {
                    event.stopPropagation()
                    setRepeatingOfferPaused(true, json)
                    refresh()
                }, 'basicListButton secondary repeat repeat-on')
            }


            const allWeekdays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
            const weekdays = json.repeatDays

            const weekdaysEl = $('<div>').addClass('labels')
            weekdaysEl.append(repeatIcon)
            const itemsTop = $('<div>').appendTo(weekdaysEl).addClass('weekdays')
            const itemsBottom = $('<div>').appendTo(weekdaysEl).addClass('weekend')

            const FORCE_WEEKDAY_HANDLING = true
            if (FORCE_WEEKDAY_HANDLING) {
                for (const i in allWeekdays) {
                    const weekday = allWeekdays[i]
                    const weekdayName = lang.p.myInfo.form[weekday]
                    let active = ''
                    if (weekdays.indexOf(weekday) > -1) {
                        active = 'active'
                    }

                    itemsTop.append($('<span>').text(weekdayName).addClass(active))
                }
            } else if (weekdays.length == 7) {
                itemsTop.append($('<span>').text('Every day'))
            }  else if (weekdays.length == 1) {
                itemsTop.append($('<span>').text(lang.p.dialog.orderpickuptimes.weekdayLabels[weekdays[0]]))
            } else {
                for (const i in weekdays) {
                    if (weekdays[i] == 'sun' || weekdays[i] == 'sat') {
                        itemsBottom.append($('<span>').text(lang.p.myInfo.form[weekdays[i]]))
                    } else {
                        itemsTop.append($('<span>').text(lang.p.myInfo.form[weekdays[i]]))
                    }

                }
                console.log('itemsTop.length', itemsTop.length, itemsTop)
                if (itemsTop.find('span').length == 5) {
                    itemsTop.html('').append($('<span>').text('Weekdays'))
                }
            }


            const primary = $('<div>').addClass('flex-row')

            primary.append(window.getOfferNameElement(json.name, isNonsurplus, json.itemCode))
            primary.append(weekdaysEl)

            tr = addRow(primary)
            tr.data('id', json.id)
        } else {
            tr = addRow(window.getOfferNameElement(json.name, isNonsurplus, json.itemCode))
            const offerTemplateId = table === modelTemplateTable ? ('model-' + json.id) : json.id
            tr.data('id', offerTemplateId)
        }
    }

    function filter() {

        const nameFilter =  nameInput.find('input').val().toLowerCase()
        $('.tableDiv .selected').removeClass('selected')
        $('.table .row').each(function() {
            if ($(this).find('div:first').text().toLowerCase().indexOf(nameFilter) > -1) {
                $(this).removeClass('hidden')
            } else {
                $(this).addClass('hidden')
            }
        })
    }

    function createNameInput() {
        const nameInput = window.createInputBlock({
            placeholder: lang.p.templates.table.offerName,
            size: '',
            class: 'offerName',
            type: 'search',
            onChange: filter
        })
        nameInput.addClass('icon-search')
        return nameInput
    }

    t.setDataReady(true)
    t.setEmptyText(lang.p.templates.table.fetching)

    function refresh(offerTemplates) {
        if (!t.isInDOM()) {
            return
        }

        if (!offerTemplates) {
            return
        }

        // Deep copy so that we can be sure that state.offers will not be edited.
        offerTemplates = JSON.parse(JSON.stringify(offerTemplates))

        t.removeRows()
        repeatTable.removeRows()
        modelTemplateTable.removeRows()

        const typeCounts = {}

        for (let i = 0; i < offerTemplates.length; i++) {
            const offerTemplate = offerTemplates[i]

            let table, type;

            if (offerTemplate.repeatEnabled) {
                type = 'repeat'
                table = repeatTable
            } else if (offerTemplate.providerId !== use.profile.id) {
                type = 'model'
                table = modelTemplateTable
            } else {
                type = 'normal'
                table = t
            }

            typeCounts[type] = typeCounts[type] ? typeCounts[type] + 1 : 1

            createTemplateRow(offerTemplate, table)
        }

        t.setDataReady(true)

        if (typeCounts.repeat) {
            repeatTable.getElement().show()
            repeatHeader.show()
        }
        if (typeCounts.model) {
            modelTemplateHeader.show()
            modelTemplateTable.getElement().show()
        }
        if (typeCounts.repeat || typeCounts.model) {
            templateHeader.show()
        }

        if (use.profile.enforceSharedTemplates && typeCounts.model && !typeCounts.normal) {
            templateHeader.hide()
            t.getElement().hide()
        }

        repeatTable.setDataReady(true)
        modelTemplateTable.setDataReady(true)
        t.setEmptyText(lang.p.templates.table.noTemplates)

        if (typeof createdCallback == 'function') createdCallback()
    }

    window.offerTemplatesStream.forEach(function listener(offerTemplates) {
        if (!t.isInDOM()) {
            window.offerTemplatesStream.removeListener(listener)
            return
        }

        refresh(offerTemplates)
    })
}

function createOfferTemplatePopover (json) {
    const description = (json && json.description) || ''
    const isRepeating = json && json.repeatEnabled && json.repeatDays

    const el = $('<div>').addClass('popover-inner')

    if (isRepeating) {
        let fetchTimes = lang.p.dialog.orderpickuptimes.unset
        let orderTimes = lang.p.dialog.orderpickuptimes.unset

        if (json && json.orderEndTime && json.orderStartTime) {
            orderTimes = window.formatTimeDisplay(json.orderStartTime)  + ' - ' + window.formatTimeDisplay(json.orderEndTime)
        }
        if (json && json.fetchEndTime && json.fetchStartTime) {
            fetchTimes = window.formatTimeDisplay(json.fetchStartTime)  + ' - ' + window.formatTimeDisplay(json.fetchEndTime)
        }
        $('<div><span>' + lang.p.dialog.orderpickuptimes.order + ':</span> <span>' + orderTimes + '</span></div>').appendTo(el)
        $('<div><span>' + lang.p.dialog.orderpickuptimes.pickup + ':</span> <span>' + fetchTimes + '</span></div>').appendTo(el)

        let weekdays = json.repeatDays
        weekdays = weekdays.map(function(item) {
            return lang.p.dialog.orderpickuptimes.weekdayLabels[item]
        }).join(', ', weekdays)
        $('<div><span>Offer repeated on:</span> <span>'+ weekdays +'</span></div>').appendTo(el)
    }

    if (description) {
        $('<div><span>' + lang.p.dialog.editOffer.form.description.label + ':</span> <span>' + description + '</span></div>').appendTo(el)
    }

    return (description || isRepeating) ? el : null
}


function deleteOfferTemplate(json) {
    window.postRequest('provider/deleteOfferTemplate/' + json.id).done(function() {

        const text = window.formatText(lang.p.templates.toast.delete.success, '<strong>' + json.name + '</strong>')
        window.createToast(text)

        window.createRowBlinker(json.id, window.updateCurrentView, '#a92c39', 1)()
    }).fail(window.dialogFailResponse)
}
; /* START FILE provider/js/providerUIElements.js */ function createDoubleContainer(left, right) {
  var container = $('<table>').addClass('doubleContainer')
  var tr = $('<tr>').appendTo(container)
  var leftContainer = $('<td>').addClass('halfContainer').appendTo(tr).append(left)
  var rightContainer = $('<td>').addClass('halfContainer').appendTo(tr).append(right)

  if (typeof left == 'string') leftContainer.css({textAlign: 'left'})
  if (typeof right == 'string') rightContainer.css({textAlign: 'left'})
  return container
}

// Used in both template and offer views, hence here
function isOfferOrOfferTemplateNonsurplus(json) {
  return json.tags && json.tags.find(tag => tag.id === 'nonsurplus')
}

// Used in both template and offer views, hence here
// Item code is only used with offer templates.
function getOfferNameElement(name, isNonsurplus, itemCode) {
  const offerTemplateName = name || '-'
  const nameElement = $('<div>')
  if (isNonsurplus) {
    const iconElement = $('<img class="tag-button-inline">').attr(
      'src',
      '/app/img/tags/nonsurplus.png'
    )
    nameElement.append(iconElement)
  }
  nameElement.append(offerTemplateName)

  if (use.profile.enterpriseId) {
    if (itemCode) {
      const itemCodeElement = $('<span class="itemCode">').text(itemCode)
      nameElement.append(' ', itemCodeElement)
    }
  }

  return nameElement
}

function toggleAllergens(e) {
  $('.providerAllergensList').toggle()

  return true
}

function createAllergenReminder(dlg) {
  var allergenKeys =
    [
      'cereals',
      'crustaceans',
      'eggs',
      'fish',
      'peanuts',
      'soybeans',
      'milk',
      'nuts',
      'celery',
      'mustard',
      'sesameSeeds',
      'sulphurDioxideAndSulphites',
      'lupin',
      'molluscs'
    ]

  var allergenReminder = $('<div></div>')
  allergenReminder.css({
    marginBottom: 20,
    marginTop: 0,
    fontSize: 14
  })
  allergenReminder.append($('<a href="#" tabindex="-1" onclick="toggleAllergens(); return false;" style="display: inline-block; white-space: nowrap; text-decoration: none; margin-top: 8px;"><span class="icon icon-info"></span> ' + lang.p.dialog.template.description.allergenReminder.buttonLabel + '</a>'))
  var allergenList = $('<br><div><ul></ul></div>')

  $(allergenKeys).each(function (key, allergen) {
    allergenList.find('ul').append($('<li>' + lang.p.dialog.template.description.allergenReminder.allergen[allergen] + '</li>'))
  })

  allergenList.addClass('providerAllergensList')

  allergenList.hide()
  allergenReminder.append(allergenList)
  return allergenReminder
}

function createTimeGraph(options) {

  var div = $('<div>').addClass('providerTimeGraph')
  div.css({
    width: '100%',
    height: 50,
    position: 'relative',
    background: 'white'
  })
  var barCss = {
    position: 'absolute',
    width: '50%',
    height: 20,
    background: '#e6a4ff',
    left: 0,
    top: 0,
  }

  var graphHours = (options && options.graphHours) ? options.graphHours : 0

  var ticks = []
  var tickMs = 1000 * 60 * 60
  var startingHour = 6
  for (var i = 0; i <= graphHours; i++) {

    var tick = $('<div><span>' + (i + startingHour) + '</span></div>').addClass('tick')
    var totalMs = tickMs * graphHours

    tick.css({
      left: tickMs * i / totalMs * 100 + '%'
    })

    ticks.push(tick)
  }
  div.append(ticks)

  var currentTime = $('<div>').addClass('providerTimeGraphCurrentTime')
  if (options && options.hideCurrentTime) {
    currentTime.hide()
  }

  var order = $('<div>' + lang.p.dialog.orderpickuptimes.order + '</div>').addClass('providerTimeGraphOrder')
  order.css(barCss)

  var fetch = $('<div>' + lang.p.dialog.orderpickuptimes.pickup + '</div>').addClass('providerTimeGraphFetch')
  fetch.css(barCss)
  fetch.css({top: 'auto', bottom: 0, background: '#a4cbff'})

  var startLimit = $('<div>').addClass('providerTimeGraphLimit providerTimeGraphLimitStart')
  var endLimit = $('<div>').addClass('providerTimeGraphLimit providerTimeGraphLimitEnd')

  startLimit.css({
    position: 'absolute',
    left: '-2px',
    top: 0,
    bottom: '-10px',
    width: '2px',
    background: '#ffb131'
  })
  endLimit.css({
    position: 'absolute',
    right: '-2px',
    top: 0,
    bottom: '-10px',
    width: '2px',
    background: '#ffb131'
  })
  currentTime.css({
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 2
  })

  div.append(order)
  div.append(fetch)
  div.append(currentTime)
  div.hide()
  return div
}

/*
function updateTimeGraph(selects, firstSlot, closingTime){
	var orderMs = 0, fetchMs = 0, orderWidth, orderLeft, fetchWidth, fetchLeft;
	var totalMs = closingTime.getTime() - firstSlot.getTime();
	var currentTimeMs = new Date().getTime() - firstSlot.getTime();

	if (selects.orderStart && selects.orderStart.val() && selects.orderEnd && selects.orderEnd.val()){
		orderMs = stringToDate(selects.orderEnd.val()).getTime() - stringToDate(selects.orderStart.val()).getTime();
		orderWidth = orderMs / totalMs;
		orderLeft = (stringToDate(selects.orderStart.val()).getTime() - firstSlot.getTime()) / totalMs;
	}
	if (selects.fetchStart && selects.fetchStart.val() && selects.fetchEnd && selects.fetchEnd.val()){
		fetchMs = stringToDate(selects.fetchEnd.val()).getTime() - stringToDate(selects.fetchStart.val()).getTime();
		fetchWidth = fetchMs / totalMs;
		fetchLeft = (stringToDate(selects.fetchStart.val()).getTime() - firstSlot.getTime()) / totalMs;
	} else {
		console.warn("no values found for fetchStart")
	}
	var currentTimeLeft = currentTimeMs / totalMs;

	$('.providerTimeGraphCurrentTime').css({
		left: currentTimeLeft * 100 + "%"
	})

	$('.providerTimeGraph').show();
	$('.providerTimeGraphOrder').css({
		width: orderWidth * 100 + "%",
		left: orderLeft * 100 + "%"
	})
	$('.providerTimeGraphFetch').css({
		width: fetchWidth * 100 + "%",
		left: fetchLeft * 100 + "%"
	})
}
// If you want Date object instead of 12:00 time string
function timeStringToDateTime(timeString) {
	var parts = timeString.split(':');
	var dateTime = new Date();
	dateTime.setHours(~~parts[0]);
	dateTime.setMinutes(~~parts[1]);
	dateTime.setSeconds(0);
	dateTime.setMilliseconds(0);
	return dateTime;
}

*/
function createOrderInstructions() {

  var div = $('<div>').addClass('orderInstructions')

  $('<div>').addClass('orderInstructionsTitle').text(lang.p.orders.instructions.title).appendTo(div)
  var flexBox = $('<div>').appendTo(div).addClass('orderInstructionsFlex flexboxSupport')

  var index = 1

  function createCircle(index) {
    return $('<div>').append($('<span>').text(index + '.')).addClass('orderInstructionCircle')
  }

  function addStep(text) {
    var step = $('<div>').addClass('orderInstructionStep')

    createCircle(index++).appendTo(step)
    $('<span>').text(text).appendTo(step)

    flexBox.append(step)
  }

  addStep(lang.p.orders.instructions1)
  addStep(lang.p.orders.instructions2)
  addStep(lang.p.orders.instructions3)
  addStep(lang.p.orders.instructions4)

  return div
}

/* Avoid duplicate definition when concatenating legacy files */
if (!window.createTextCheckbox) {
  window.createTextCheckbox = function (text, id, callback) {
    var button = $('<span>').text(text).attr('id', id).addClass('textCheckbox').click(function () {
      if (button.attr('disabled')) return
      button.toggleClass('selected')
      if (callback) {
        callback(button.hasClass('selected'))
      }
    })
    return button
  }
}

function createDLRangeRow(options) {
  var el = $('<div></div>')
  el.addClass('ProviderDLRangeRow')
  el.addClass('ProviderDLRangeRow' + window.stringCapitalize(options.type))
  var title = ''
  if (options.type === 'order') {
    title = lang.p.dialog.orderpickuptimes.orderBetween
  } else if (options.type === 'fetch') {
    title = lang.p.dialog.orderpickuptimes.pickupBetween
  }
  el.append('<div class="inputBlockTitle">' + title + '</div>')
  var startContainer = createDLTimeInput({
    type: 'start',
    parentName: options.type,
    callback: options.callback,
    defaultValue: options.values[options.type + 'Start']
  })
  var endContainer = createDLTimeInput({
    type: 'end',
    parentName: options.type,
    callback: options.callback,
    defaultValue: options.values[options.type + 'End']
  })
  var inputContainer = $('<div />')

  inputContainer.addClass('ProviderDLDayRowInputs')
  inputContainer.append(startContainer)
  inputContainer.append(endContainer)

  el.append(inputContainer)
  /*
el.append(startContainer);
el.append(endContainer);
*/
  return el

}

function createDLTimeInput(options) {
  var el = $('<div />')
  el.addClass('ProviderDLTimeInput')
  el.addClass('ProviderDLTimeInput' + window.stringCapitalize(options.type))

  var inputName = options.parentName + window.stringCapitalize(options.type)
  var input = $('<input />')
  input.addClass('basicInput')

  input.attr({
    type: 'text',
    name: inputName,
    value: window.dateToString(options.defaultValue, true)
  })

  input.data('defaultValue', window.dateToString(options.defaultValue, true))
  var oldValue = window.dateToString(options.defaultValue, true)
  input.data('oldValue', oldValue)

  input.on('mousedown touchstart', function (e) {
    if (Math.abs(input.width() / 2 - e.offsetX) > 30) {
      e.preventDefault()
    }
  })

  input.change(function (event) {
    var valDate = window.stringToDate(input.val())

    if (!valDate) {
      input.val(window.dateToString(input.data('defaultValue'), true))

    } else {
      var minutes = valDate.getMinutes()
      if (inputName === 'orderStart' && !input.data('disable-bundle-check')) {
        if (minutes > 35) {
          valDate.setMinutes(60 + 5)
        } else if (minutes > 5) {
          valDate.setMinutes(35)
        } else {
          valDate.setMinutes(5)
        }
        input.val(window.dateToString(valDate, true))
      } else {

        if (valDate) {
          /*
 var remainder = valDate.getMinutes() % 15;
 var newTime;
 if (remainder === 0){
 newTime = valDate.getMinutes();
 } else {
 newTime = valDate.getMinutes() + 15 - remainder;
 }
 valDate.setMinutes(newTime);
 */
          input.val(window.dateToString(valDate, true))
        } else {
          input.val(window.dateToString(input.data('defaultValue'), true))
        }
      }
    }


    //input.data("oldValue", oldValue);
    oldValue = input.val()
    //console.info("setting oldValue", inputName, oldValue);
    if (options && options.callback) {
      options.callback(input)
    }
  })


  el.append(input)

  var addButton = createDLTimeInputButton({
    type: 'add', cb: function (values) {
      var valDate = window.stringToDate(input.val())
      if (valDate) {
        var remainder = valDate.getMinutes() % 15
        var newTime
        if (remainder === 0) {
          newTime = valDate.getMinutes() + 15
        } else {
          newTime = valDate.getMinutes() + 15 - remainder
        }
        valDate.setMinutes(newTime)
        if (valDate.getDate() === new Date().getDate()) {
          input.data('disable-bundle-check', false)
          input.val(window.dateToString(valDate, true))
          input.trigger('change')
        } else {
          input.val(window.dateToString(valDate, true))
        }

      } else {
        input.val(window.dateToString(input.data('defaultValue'), true))
      }
      options.callback(input)
    }
  })

  var subtractButton = createDLTimeInputButton({
    type: 'subtract', cb: function (values) {
      var valDate = window.stringToDate(input.val())
      if (valDate) {
        0
        /*
  if (valDate.getMinutes() > 5){
    valDate.setMinutes(5)
  } else if (valDate.getMinutes() > 35){
    valDate.setMinutes(35);
  } else {
    valDate.setMinutes(5)
  }
  */


        var newTime

        if (input.attr('name') === 'orderStart') {

          newTime = window.getBundleMinutes(valDate.getMinutes()) - 30

          console.info('orderstart minutes', newTime)

        } else {

          //var prevBundleMinutes = getBundleMinutes(valDate.getMinutes()) - 30;

          var remainder = valDate.getMinutes() % 15
          if (remainder === 0) {
            newTime = valDate.getMinutes() - 15
          } else {
            newTime = valDate.getMinutes() - remainder
          }
        }

        valDate.setMinutes(newTime)
        input.val(window.dateToString(valDate, true))

        input.trigger('change')
      } else {
        input.val(window.dateToString(input.data('defaultValue'), true))
      }
      options.callback(input)
    }
  })


  input.keydown(function (event) {
    if (event && event.key === 'ArrowDown') {
      event.preventDefault()
      subtractButton.trigger('click')
    } else if (event && event.key === 'ArrowUp') {
      event.preventDefault()
      addButton.trigger('click')
    }
  })

  var controlsContainer = $('<div>')
  controlsContainer.addClass('ProviderInputControls')
  controlsContainer.append(subtractButton)
  controlsContainer.append(addButton)

  el.append(controlsContainer)

  return el
}

function createDLTimeInputButton(options) {
  var symbol = '+'
  if (options && options.type === 'subtract') {
    symbol = '-'
  }
  var el = $('<button>' + symbol + '</button>')
  el.click(function (event) {
    event.preventDefault()
    if (options && options.cb) {
      options.cb({type: options.type})
    }

  })
  return el
}

var toastTimeout

function createToast(text, callback) {
  var container = $('.toastContainer')
  var content = container.find('.content')
  container.find('.modalCloseButton').click(function (e) {
    e.preventDefault()
    container.removeClass('visible')
    return true
  })
  content.html(text)
  container.addClass('visible')

  if (callback) {
    content.click(function () {
      if (typeof callback === 'string') {
        window.location = callback
      } else if (typeof callback === 'function') {
        callback()
      }
      container.removeClass('visible')
    })
  }

  clearTimeout(toastTimeout)
  toastTimeout = setTimeout(function () {
    //container.css('opacity', 0)
    container.removeClass('visible')
  }, 5000)

}

function formatTimeDisplay(time) {
  if (!time) {
    return ''
  } else {
    return time.substr(0, 5)
  }
}

var createRepeatControls = function (dlg, json, fetchOrderTimesToggle, changeCallback) {
  if (use.profile.allowRecurringOffers) {
    dlg.addHorizontalLine()
  }

  var fetchOrderTimesToggleInput = fetchOrderTimesToggle.find('input')
  var repeatToggle = dlg.addInput({
    type: 'checkbox2',
    label: lang.p.dialog.template.setRepeat,
    value: json.repeatEnabled,

  })

  if (!use.profile.allowRecurringOffers) {
    repeatToggle.hide()
  }

  var createCheckboxListButton = function (name, label, value) {
    var el = $('<li>')
    var labelContainer = $('<label>')
    label = $('<span>').text(label)
    var input = $('<input type="checkbox" />')
    var background = $('<div>').addClass('checkbox-list-button-background')
    input.prop('checked', !!value)
    el.append(labelContainer)
    labelContainer.append(input)
    labelContainer.append(background)
    background.append(label)
    return el
  }

  //repeating offers weekday selector
  var checkBoxListButtonContainer = $('<ul>').addClass('checkbox-list-buttons')
  checkBoxListButtonContainer.hide = function () {
    checkBoxListButtonContainer.css({'opacity': 0, height: 0})
  }
  checkBoxListButtonContainer.show = function () {
    checkBoxListButtonContainer.css({'opacity': 1, height: 'auto'})
  }

  checkBoxListButtonContainer.hide()


  var repeatDays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
  var repeatDaysValues = json.repeatDays
  for (var i = 0; i < repeatDays.length; i++) {
    var dayShort = repeatDays[i]
    var dayValue = false //has this day been toggled
    if (repeatDaysValues && repeatDaysValues.indexOf(dayShort) != -1) {
      dayValue = true
    }

    var btn = createCheckboxListButton(dayShort, lang.p.dialog.orderpickuptimes.weekdayLabels[dayShort], dayValue)
    btn.appendTo(checkBoxListButtonContainer)
  }

  repeatToggle.change(function (a, b, c) {
    var val = repeatToggle.data('value')
    if (val) {
      checkBoxListButtonContainer.show()
      fetchOrderTimesToggleInput.prop('checked', true)
      fetchOrderTimesToggleInput.prop('disabled', true)
      repeatDisclaimer.show()
    } else {
      checkBoxListButtonContainer.hide()
      fetchOrderTimesToggleInput.prop('disabled', false)
      fetchOrderTimesToggleInput.prop('checked', false)

      repeatDisclaimer.hide()
    }

    if (changeCallback && typeof changeCallback === 'function') {
      changeCallback(val)
    }

    fetchOrderTimesToggleInput.trigger('change')
  })
  var repeatDisclaimer = $('<p style="margin: 20px; margin-top: 0px; font-size: 14px;"><span class="icon icon-info"></span> <em>' + lang.p.dialog.template.repeat.help + '</em></p>')
  repeatDisclaimer.hide()

  var el = $('<div>').addClass('repeatContainer')
  el.append(repeatToggle)
  el.append(repeatDisclaimer)
  el.append(checkBoxListButtonContainer)

  //set initial initial switch values
  if (repeatToggle.data('value')) {

    checkBoxListButtonContainer.show()
    fetchOrderTimesToggleInput.prop('checked', true)
    fetchOrderTimesToggleInput.prop('disabled', true)
  } else {
    checkBoxListButtonContainer.hide()
    fetchOrderTimesToggleInput.prop('disabled', false)
  }


  return el
}

function createDynamicPricingBlock(originalPrice, defaultValue) {
  const label = $('<div>').text(lang.offers.dynamicPricing.title)
  label.prepend($('<img>').addClass('dynamicPricingIcon').attr('src', './img/icon-smart-price-descending.svg'))

  function updatePrice(originalPrice) {
    if (isNaN(originalPrice)) {
      dynamicPricingSmallDescription.text('')
      return
    }
    const minimumFractionFromOriginalPrice = (100 - use.profile.dynamicPricingMaxDiscountPercentage) / 100
    const minPrice = Math.max(originalPrice * minimumFractionFromOriginalPrice, use.profile.country.minPrice)
    dynamicPricingSmallDescription.text(window.formatText(lang.offers.dynamicPricing.minimumPrice, window.formatCurrency(minPrice, use.profile.currency, true)))
  }

  const dynamicPricingSmallDescription = $('<span>').addClass('dynamicPricingSmallDescription')
  label.append(dynamicPricingSmallDescription)
  // TODO if needed, uncomment this to make a popup about smart pricing.
  // let dynamicPricingInfoButton = $('<button class="basicButton">').text('???').click((ev) => {
  // 	ev.preventDefault()
  // 	showAlert('Smart pricing', 'More info about smart pricing')
  // })
  // label.append($('<span>').addClass('dynamicPricingMoreInfo').append(dynamicPricingInfoButton))

  const dynamicPricingBlock = window.createInputBlock({
    type: 'checkbox2',
    name: 'isDynamicallyPriced',
    label: label,
    value: defaultValue,
    blockClass: 'modalDialogDynamicPricingBlock'
  })

  updatePrice(originalPrice)

  return {
    dynamicPricingBlock,
    updatePrice
  }
}

function setInputBlockSummary(inputBlock, summary) {
  const summarySelector = inputBlock.find('.inputBlock-label-summary')
  if (typeof summary === 'string') {
    summarySelector.html(summary)
  } else {
    summarySelector.empty().append(summary)
  }
}

function addDynamicPricing(priceElement, offerPrice, isOfferDynamicallyPriced) {
  function setPriceSummaryWithDynamicPrice(dynamicPricingBlock, priceBlock) {
    const dynamicPricingValue = dynamicPricingBlock.data('value')

    let dynamicPricingHTML = ''
    if (dynamicPricingValue) {
      dynamicPricingHTML = `<img class="dynamicPricingIcon" src="./img/icon-smart-price-descending.svg"><span>${lang.offers.dynamicPricing.title}</span>`
    }

    let priceValue = priceBlock.data('value')
    if (priceValue) {
      priceValue = window.formatCurrency(priceValue, null, true)
    } else {
      priceValue = ''
    }

    setInputBlockSummary(
      priceBlock,
      `
<span class="priceSummaryDynamicPrice">${dynamicPricingHTML}</span>
<span class="priceSummaryPrice">${priceValue}</span>`
    )
  }

  let dynamicPricingBlock
  if (use.profile.isDynamicPricingEnabled) {
    const dynamicPricingBlockInfo = window.createDynamicPricingBlock(offerPrice, isOfferDynamicallyPriced)
    dynamicPricingBlock = dynamicPricingBlockInfo.dynamicPricingBlock
    priceElement.find('.inputBlockContent').append(dynamicPricingBlock)

    const updatePrice = () => dynamicPricingBlockInfo.updatePrice(priceElement.data('get')())
    priceElement.data('input').on('input', updatePrice)
    priceElement.data('change')(updatePrice)

    // change listener for both price and dynamicPrice inputs
    priceElement.find('input').change(function (e) {
      setPriceSummaryWithDynamicPrice(dynamicPricingBlock, priceElement)
    })
    setPriceSummaryWithDynamicPrice(dynamicPricingBlock, priceElement)
  }
  return dynamicPricingBlock
}
; /* START FILE provider/js/modalDialogOfferCommon.js */ wait.lang.then(function () {
  const inputDefaults = {
    quantity: {
      type: 'number',
      name: 'quantity',
      label: window.lang.p.dialog.offer.form.quantity,
      placeholder: '1',
      value: 1,
      min: 1,
      helpText: window.lang.p.dialog.offer.form.quantityHelpText,
      size: 'auto',
      collapse: true,
    },
  }

  const isValidQuantity = (newQuantity, ordered = 0) => {
    return Number.isInteger(newQuantity) && newQuantity >= inputDefaults.quantity.min && newQuantity >= ordered
  }

  const handleQuantityInputChange = (e, quantityElement, { ordered = null, defaultValue = inputDefaults.quantity.min } = {}) => {
    e.preventDefault()

    const newQuantity = parseInt(e.target.value)
    const quantity = isValidQuantity(newQuantity, ordered) ? newQuantity : defaultValue

    quantityElement.find('input').val(quantity)

    const summaryText = ordered !== null
      ? `<span>${ordered}/${quantity}</span><em> ${window.lang.p.offers.table.sold}</em>`
      : quantity

    window.setInputBlockSummary(quantityElement, summaryText)
  }

  const offerCommonFields = {
    quantity: {
      attributes: inputDefaults.quantity,
      handleChange: handleQuantityInputChange,
    },
  }

  window.inputDefaults = inputDefaults
  window.isValidQuantity = isValidQuantity
  window.handleQuantityInputChange = handleQuantityInputChange
  window.offerCommonFields = offerCommonFields
})

; /* START FILE provider/js/table.js */ function Table() {
    var tableDiv = $('<div>').addClass('tableDiv')
    tableDiv.addClass('tableDiv')
    var headerRow = $('<div>').addClass('row headerRow flexboxSupport').appendTo(tableDiv)
    var table = $('<div>').addClass('table').appendTo(tableDiv)

    var columns = []

    var emptyText = ''
    var rowAdded = false

    var minimumTableWidth = 0

    var dataReady = false

    var loadingIndicator = $('<div></div>').addClass('loadingIndicator')
    var spinner = $('<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>')
    spinner.appendTo(loadingIndicator)
    loadingIndicator.appendTo(tableDiv)


    this.setDataReady = function(argDataReady) {
        dataReady = !!argDataReady
        if (dataReady) {
            tableDiv.addClass('data-ready')
        } else {
            tableDiv.removeClass('data-ready')
        }
    }

    this.addSmallHeader = function(text) {
        if (text) {
            tableDiv.prepend($('<div class=\'smallHeader\'>').text(text))
        }
    }

    this.addPrimaryColumn = function(name, min, max, order, flex, showName) {
        min = min || 50
        max = max || 500
        flex = flex || 1
        order = order || 10
        showName = showName || false
        // showName = true for a flex column with name displayed on mobile

        var columnCss = {
            '-webkit-box-flex': ''+flex,
            '-moz-box-flex': ''+flex,
            '-webkit-flex': ''+flex,
            '-ms-flex': ''+flex,
            flex: ''+flex,
            minWidth: min+'px',
            maxWidth: max+'px',
            verticalAlign: 'top',
            'order': '' + order,
        }
        var headerCell = $('<div>').addClass('cell headerCell').text(name).css(columnCss)
        headerCell.attr('title', name)
        headerRow.append(headerCell)

        columns.push({
            name: name,
            columnCss: columnCss,
            type : 'primary',
            showName : showName
        })

        minimumTableWidth += min

        return headerCell
    }

    this.addColumn = function(name, width, order) {
        return this.addSecondaryColumn(name, width, order)
    }

    this.addPopoverColumn = function() {
        var columnCss = {
        }
        columns.push({
            name: 'popover',
            columnCss: columnCss,
            type: 'popover',
            showName : false
        })
    }
    this.addSecondaryColumn = function(name, width, order, showName) {
        var min = width || 100
        var max = width ||	100
        order = order || 10
        if (typeof showName === 'undefined')
            showName = true

        var flex = 1
        var columnCss = {
            minWidth: min+'px',
            maxWidth: max+'px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            verticalAlign: 'top',
            'order': '' + order
        }
        var headerInner = $('<div>').text(name)
        var headerCell = $('<div>').addClass('cell headerCell').html(headerInner).css(columnCss)
        headerCell.append(headerInner)
        headerCell.attr('title', name)
        headerRow.append(headerCell)
        columns.push({
            name: name,
            columnCss: columnCss,
            type: 'secondary',
            showName : showName
        })
        minimumTableWidth += min
        return headerCell
    }

    this.addButtonColumn = function(name, width, order) {
        var min = width || 100
        var max = width ||	100
        order = order || 10

        var columnCss = {
            minWidth: min+'px',
            maxWidth: max+'px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            verticalAlign: 'top',
            'order': '' + order
        }
        headerRow.append($('<div>').addClass('cell headerCell').text(name).css(columnCss))
        columns.push({
            name: name,
            columnCss: columnCss,
            type: 'button'
        })
        minimumTableWidth += min
    }

    // pass html code inside of jquery object
    this.addRow = function() {
        if (!rowAdded) table.empty()
        rowAdded = true

        var buttonContainer, rowContainer

        rowContainer = $('<div>').addClass('row-container').appendTo(table)
        var tr = $('<div>').addClass('row flexboxSupport').appendTo(rowContainer)
        tr.addClass('clearfix')
        for (var j = 0; j < columns.length; j++) {
            var cellType = 'cell'
            if (columns[j].type === 'popover') {
                cellType = 'popover'
                tr.addClass('has-content')
            }

            var cell = $('<div>').addClass(cellType).addClass(columns[j].type).addClass(columns[j].showName ? 'showName' : '').css(columns[j].columnCss)
            cell.attr('data-name', columns[j].name)
            var arg = arguments[j]
            if (typeof arg === 'string')
                cell.text(arg)
            else
                cell.append(arg)

            // Buttons must be put in a separate container
            if (columns[j].type === 'button') {
                if (!buttonContainer) {
                    buttonContainer = $('<div class="buttonContainer"></div>')
                    buttonContainer.appendTo(tr)
                }
                cell.appendTo(buttonContainer)
            } else if (columns[j].type === 'popover') {
                cell.appendTo(rowContainer)
            } else {
                cell.appendTo(tr)
            }
        }
        tr.css('position', 'relative')

        tr.click(function() {
            if (tr.hasClass('selected')) {
                tr.removeClass('selected')

            } else {
                //$('.tableDiv .selected').removeClass('selected');
                tr.addClass('selected')
            }

        })
        /*
		tr.on('mouseenter', function(){
			console.log("hello")
			popOver.show()
		})
		tr.on('mouseleave', function(){
			console.log("hello")
			//popOver.hide()
		})

		tr.append(popOver)
		*/
        return tr
    }

    this.setEmptyText = function(text) {
        emptyText = text
        if (!rowAdded) {
            this._showEmptyText()
        }
    }

    this.getElement = function() {
        if (!rowAdded) this._showEmptyText()

        // Must check width after element is appended to page
        setTimeout(this.checkWidth, 1)

        return tableDiv
    }

    this.removeRows = function() {
        table.empty()
    }

    this.removeTable = function() {
      $('.tableDiv').remove()
    }

    this.isInDOM = function() {
        return window.jQuery.contains(document.documentElement, table[0])
    }

    this._showEmptyText = function() {
        table.empty()
        $('<div>').text(emptyText).css({color: 'gray', marginTop: '20px', textAlign: 'center'}).appendTo(table)
    }

    this.checkWidth = function() {
        if (tableDiv.width() < minimumTableWidth) {
            //console.log('width: ' + tableDiv.width() + ', ' + 'threshold: ' + minimumTableWidth + ', narrow');
            tableDiv.addClass('narrow')
        } else {
            //console.log('width: ' + tableDiv.width() + ', ' + 'threshold: ' + minimumTableWidth + ', wide');
            tableDiv.removeClass('narrow')
        }
    }

    $(window).resize(function() {
        this.checkWidth()
    }.bind(this))

}

function createRowBlinker(id, callback, color, times) {
    color = color || 'white'
    times = times || 2
    return function() {
        $('.table .row').each(function() {
            if ($(this).data('id') == id) {
                var originalBgColor = $(this).css('backgroundColor')
                var me = $(this)

                for (var i = 0; i < times; i++) {
                    me = me
                        .animate({ backgroundColor: color }, 400)
                        .animate({ backgroundColor: originalBgColor, }, 400)
                }
                me.filter(':animated').promise().done(callback)
                return false
            }
        })
    }
}
; /* START FILE provider/js/util.js */ function sendInfo() {
	function getOSName() {
		var result = 'Unknown OS'
		var appVersion = navigator.appVersion
		if (appVersion.indexOf('Win') != -1) result = 'Windows'
		else if (appVersion.match(/i(Phone|Pad|Pod)/)) result = 'iOS'
		else if (appVersion.indexOf('OS X') != -1) result = 'OS X'
		else if (appVersion.indexOf('Android') != -1) result = 'Android'
		else if (appVersion.indexOf('Linux') != -1) result = 'Linux'
		return result
	}

	var now = new Date()
	var localDateString = now.toString() + ' (' + now.getTimezoneOffset() + ')'

	var data = {
		type: 'provider',
		os: getOSName(),
		localDateString: localDateString,
		browser: navigator.userAgent || navigator.appVersion,
		displayWidth: window.innerWidth,
		displayHeight: window.innerHeight,
		appVersion: 'classic'
	}

	return window.postRequest('provider/sendInfo', data).fail(function(err) {
		console.log('Sending info failed. ' + err.responseText)
	})
}

function setInfoText(boldText, normalText, warningColor, warningTag, pageTitleText, isNarrow) {
	if (!boldText && !normalText && !pageTitleText) {
		$('#infoText').html('')
		$('#infoText').hide()
		return
	} else {
		$('#infoText').show()
	}
	$('#infoText')
		.html($('<b>').text(boldText))
		.append(normalText)
	if (warningColor) $('#infoText').addClass('warningInfoText')
	else $('#infoText').removeClass('warningInfoText')

	if (warningTag) {
		$('#infoText').prepend('<span class="infoText-warningTag">' + warningTag + '</span> ')
	}

	$('#infoText').prepend(
		$('<div>')
			.addClass('pageTitleText')
			.text(pageTitleText)
	)

	// Yes, this is hack. Fix this when we rewrite provider pages.
	if (isNarrow) {
		$('#infoText').css('max-width', '721px')
	} else {
		$('#infoText').css('max-width', '1015px')
	}
}

function updateTags() {
	window.getRequest('provider/tags')
		.then(function(response) {
			window.tags = {}
			try {
				var tagList = JSON.parse(response).tags
				for (var i = 0; i < tagList.length; i++) {
					window.tags[tagList[i].id] = tagList[i]
				}
			} catch (e) {}
		})
		.fail(function(err) {
			console.log('failed to get tags', err)
		})
}

function logout() {
	window
		.postRequest('provider/logout')
		.done(function() {
			window.store.remove('providerToken')
			window.redirect('login.html', 'replace')
		})
		.fail(window.dialogFailResponse)
}

function clearViewContent() {
	var content = $('#content')

	content.empty()
	// TODO remove all classes that match "content-*" once they are used
	content.removeClass('content-stats')
	return content
}

function updateMyInfo(callback) {
	window.getRequest('provider/myInfo').done(function(response) {
		try {
			waitNoMore.profile(JSON.parse(response).myInfo)

			const { name, id } = use.profile
			const hasAdminLogin = Boolean(use.env.admin)
			const providerInfoText = `${name} ${ hasAdminLogin ? `(${id})` : '' }`

			$('<span class="providerIdentity">')
				.html(providerInfoText)
				.insertBefore($('.topBarLogoutButton'))
		} catch (e) {}

		if (callback) callback()
	})
}

/**
 * Sets up a new date object with the given time and today for a date
 * @param string
 * @returns {*}
 */
function stringToDate(string, options) {
	//console.log("splitting string", string)
	string = string + ''
	string = string.trim()
	var date

	if (string.length < 4) {
		date = new Date()
		date.setHours(parseInt(string.substr(0, 2)))
		date.setMinutes(0)
		date.setSeconds(0)
		date.setMilliseconds(0)
		return date
	}

	if (!string || !string.split(':')) {
		console.error('error splitting string', string)
		return false
	}

	//allow dates in format hh:mm and hh:mm:ss (discard seconds)
	var regex = /([01]\d|2[0-3]):([0-5]\d)/

	var parts = string.match(regex)
	//"12:01".match(/(\d{1,2}):(\d{1,2})?(?::)?(\d{1,2})/)
	if (parts && parts.length === 3) {
		date = new Date()
		date.setHours(parts[1])
		date.setMinutes(parts[2])
		date.setSeconds(0)
		date.setMilliseconds(0)
	}

	if (options && options.format === 'utc') {
		date.setMinutes(date.getMinutes() - use.profile.timezoneOffsetInMinutes - date.getTimezoneOffset())
	}

	return date
}

function featureHas(featureName) {
	return false
}

function getProviderDefaultOrderAndFetchTimes(daysFromNow) {
	const now = new Date()
	if (daysFromNow) {
		now.setDate(now.getDate() + daysFromNow)
	}

	const dayKey = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'][now.getDay()]

	let fetchStart = use.profile[dayKey + 'FetchStart']
	const fetchEnd = use.profile[dayKey + 'FetchEnd']
	let orderStart = fetchStart
	let orderEnd = fetchEnd
	const defaultOrderEndBeforeFetchEndInMinutes = use.profile.defaultOrderEndBeforeFetchEndInMinutes

	// For today, we will select the next bundle time as start time
	if (daysFromNow === 0) {
		const publishTime = new Date()
		const publishTimeString = `${window.padTo2(publishTime.getHours())}:${window.padTo2(
			publishTime.getMinutes()
		)}:00`

		// use publishTime only if it is later than the default fetchStart time
		const fetchStartDate = window.timeToDateTime(fetchStart)
		if (publishTime > fetchStartDate) {
			fetchStart = publishTimeString
		}

		// For today, always set orderStart as now.
		orderStart = publishTimeString
	}

	if (defaultOrderEndBeforeFetchEndInMinutes > 0) {
		// subtract needed minutes from fetchEnd
		const fetchEndDate = getDateFromTimeString(fetchEnd)
		const orderEndDate = new Date(fetchEndDate - defaultOrderEndBeforeFetchEndInMinutes * (60 * 1000))

		// Check that orderEnd is not moved past orderStart
		const orderStartDate = getDateFromTimeString(orderStart)
		if (orderEndDate > orderStartDate) {
			orderEnd = `${window.padTo2(orderEndDate.getHours())}:${window.padTo2(orderEndDate.getMinutes())}:00`
		}
	}

	return {
		orderStart: orderStart,
		orderEnd: orderEnd,
		fetchStart: fetchStart,
		fetchEnd: fetchEnd,
	}
}

function getDateFromTimeString(time) {
	const parts = time.split(':')
	const d = new Date()
	d.setHours(parts[0], parts[1], parts[2], 0)
	return d
}

// Make sure provider web app stays updated
function refreshNightly() {
	var refreshTime = new Date()
	if (refreshTime.getHours() === 4) {
		refreshTime.setDate(refreshTime.getDate() + 1)
	}
	refreshTime.setHours(4)
	if (refreshTime < new Date()) refreshTime.setDate(refreshTime.getDate() + 1)
	setInterval(function() {
		if (new Date() > refreshTime) location.reload()
	}, 10000)
}
; /* START FILE provider/js/init.js */ function showKycOnboardingOverlay() {
    if (
        use.profile.kycVerificationStatus === 'pending' ||
        use.profile.kycVerificationStatus === 'invalid'
    ) {
        fetchKycOnboardingUri()
            .then((uri) => {
                $('#kycOnboardingOverlay')
                    .css({
                        'background-color': '#ffd54f',
                        'font-weight': 600,
                        'font-size': '0.9rem',
                        width: '100vw', // Full width of the screen
                        display: 'block',
                        'text-align': 'center',
                        padding: '10px 20px',
                        'line-height': '1.5',
                    })
                    .html(
                        `<p>${lang.p.offers.adyenKyc.onboardingOverlay.message}</p>
                        <a href="${uri}" target="_blank">${lang.p.offers.adyenKyc.onboardingOverlay.link}</a>`
                    )
                    .show();
            })
            .catch(() => {
                console.error('Failed to fetch the URI');
            });
    }
}

function fetchKycOnboardingUri() {
    return new Promise((resolve, reject) => {
        window
            .getRequest('v1/payout-psp-accounts/onboarding', {
                reference: use.profile.id,
                referenceType: 'partner',
            })
            .done((result) => {
                const parsedResult = JSON.parse(result);
                resolve(parsedResult.url);
            })
            .error(() => {
                reject(new Error('Failed to fetch the URI'));
            });
    });
}

// TODO: Once we clear all the local storage tokens, refactor to make server request with token instead of redirecting
// The native apps construct this URL when using the web app views (settings).
function storeProviderTokenFromUrlAndRedirect() {
    // Provider token from the url
    if (window.location.search.indexOf('providerToken=') >= 0) {
        const tokenStringPart = window.location.search.split('providerToken=')[1];
        const token = tokenStringPart.split(/[&#]/)[0];
        window.store.set('providerToken', token);
        const url = location.pathname + location.hash;
        window.redirect(url, 'replace');
    }
}

function initMainProviderApp() {
    window.tags = {};

    if (!use.env.provider) {
        // If env doesn't have env.provider, either providerToken doesn't exist or it is expired.
        // Anyhow, providerToken is invalid and we should logout and go to login page.
        return window.logout();
    }

    wait.profile.then(function () {
        window.createVueTopBar();
        window.showKycOnboardingOverlay();

        window.initRouteManager(use.profile.isModel ? 'templates' : 'offers');
        window.sendInfo();
    });

    window.updateMyInfo();

    window.updateTags();

    window.refreshNightly();

    window.initOrderAlertSound();

    // Intercom chat widget
    wait.profile.then(function (profile) {
        const isLoggedInAsAdminInProduction = Boolean(use.env.admin) && !use.env.DEV_ENV;

        if (isLoggedInAsAdminInProduction) {
            console.log('Admin login found. Intercom disabled.');
        } else if (use.profile.isModel) {
            console.log('Model provider. Intercom disabled.');
        } else {
            window.intercomInit(profile);
        }

        window.vueStore.commit('setNewReviewCount', profile.newReviewCount);
    });
}

function initLogin() {
    var placeholder = '';
    for (var i = 0; i < 6; i++) {
        placeholder += '*';
    }

    wait.env.then(function (env) {
        if (env.provider) window.redirect('./', 'replace');
    });

    window.createTopBar();

    var dlg = new window.ModalDialog(lang.p.login.title, {
        submitFromEnter: true,
        horizontalLine: false,
        popup: false,
        width: '300px',
        // Not needed as long as we use dlg.addInputOld, which doesn't initialize
        // tabindexes to -1
        // autoTabIndexify: true,
    });

    dlg.getDialogElement().css({
        border: '1px solid rgba(0,0,0,0.1)',
        background: 'white',
    });

    dlg.getDialogElement().find('.modal-title h2').css({
        textAlign: 'center',
    });
    var username = dlg.addInputOld('username', lang.p.login.providerUsername.label, '', 'text', '');
    dlg.addInputOld('password', lang.p.login.password.label, placeholder, 'password', '');

    dlg.addButton(lang.p.login.login, function (data) {
        window
            .postRequest('provider/login', data)
            .done(function (results) {
                results = JSON.parse(results);
                window.store.set('providerToken', results.providerToken);

                // HACK FOR AFTER LOGIN ROUTING!
                // Multiple domain app limits us for a nice shared local/session storage implementation
                // wrapped in a store. We can't even use local/session storage between our old and new app due to different domains.
                // So what we'll do for now is implement page rerouting on case by case basis until we have
                // a single application.
                const params = new URLSearchParams(window.location.search);
                const redirectTo = params.get('redirectTo');
                if (redirectTo && redirectTo === 'payoutSettings') {
                    const languageCode = window.getLanguage();
                    const payoutSettingsUrl = `${use.env.NEW_PARTNER_APP_URL_BASE}/${languageCode}/payouts/settings`;
                    window.location.replace(payoutSettingsUrl);
                } else {
                    window.redirect('./', 'replace');
                }
            })
            .fail(window.dialogFailResponse);
    });

    dlg.addTextButton(lang.login.forgotPassword, function () {
        window.showPrompt(lang.p.forgotPassword.enterUsernameOrEmail).then(function (input) {
            if (input) {
                var data = {};
                if (input.indexOf('@') >= 0 && input.indexOf('.') >= 0) data.email = input;
                else data.username = input;
                window
                    .postRequest('provider/sendPasswordChangeLinkToEmail', data)
                    .done(function () {
                        window.showAlert(lang.login.resetRequested.message, ' ');
                    })
                    .fail(function (e) {
                        window.showAlert(e.responseText);
                    });
            }
        });
    }).addClass('forgotPasswordLink green');

    var dialog = dlg.getDialogElement().appendTo($('body'));

    var input = dialog.find('input').first();

    if (input.val() == '') input.focus();
}

function initChangePassword() {
    var str = '?token=';
    var url = location.href;
    var pos = url.indexOf(str);
    var changeProviderPasswordToken = pos > 0 ? url.substring(pos + str.length) : '';

    var placeholder = '';
    for (var i = 0; i < use.env.PASSWORD_MIN_LENGTH; i++) {
        placeholder += '*';
    }

    window.createTopBar(null, { language: false });
    var dlg = new window.ModalDialog(lang.p.dialog.changePassword.title, {
        submitFromEnter: true,
        horizontalLine: false,
        popup: false,
    });

    var new1 = dlg.addInputOld(
        'newPassword',
        lang.p.dialog.changePassword.newPassword,
        placeholder,
        'password',
        ''
    );
    var new2 = dlg.addInputOld(
        'newPassword2',
        lang.p.dialog.changePassword.newPassword2,
        placeholder,
        'password',
        ''
    );

    dlg.addButton(lang.p.login.login, function (data) {
        if (new1() != new2()) {
            alert(lang.p.dialog.changePassword.badlyTyped);
            dlg.enableAllAgain();
            return;
        }

        if (changeProviderPasswordToken) {
            data.changeProviderPasswordToken = changeProviderPasswordToken;
        }

        window
            .postRequest('provider/changePassword', data)
            .done(function (results) {
                results = JSON.parse(results);

                var data2 = {
                    username: results.username,
                    password: data.newPassword,
                };

                window
                    .postRequest('provider/login', data2)
                    .done(function (results) {
                        results = JSON.parse(results);
                        window.store.set('providerToken', results.providerToken);
                        window.redirect('./', 'replace');
                    })
                    .fail(window.dialogFailResponse);
            })
            .fail(window.dialogFailResponse);
    });

    var dialog = dlg.getDialogElement().appendTo($('body'));

    var input = dialog.find('input').first();

    if (input.val() == '') input.focus();
}
//# sourceMappingURL=bundle.js.map